import { Link } from '@material-ui/core';
import {
  AccountParticipationLevel,
  AmountOfEmployees,
  ArticleCategory,
  ArticleType,
  ArticleTypeExternal,
  AssetType,
  BorrowerFileType,
  BusinessType,
  CashInCashOutType,
  ChannelType,
  CompanyActivity,
  CustomLanguage,
  CustomRegistry,
  DeclaredBusinessType,
  deleteAgentInLenderContextById,
  deleteCheckoutSessionByCheckoutSessionId,
  DownPaymentCollection,
  EmploymentStatus,
  FeePaymentType,
  FeeType,
  Gender,
  HolderType,
  HppStatus,
  IberiaCompanyActivity,
  IberiaEmploymentStatus,
  IncomeType,
  LenderApprovalStatus,
  LenderName,
  LoanApplicationStatus,
  LoanDesistReason,
  LoanFileType,
  LoanStatusExternal,
  MerchantFileType,
  NetIncomeType,
  OnboardingDetailsRole,
  OperativeType,
  OtpStatus,
  patchAddCashInCashOutMethodByMerchantId,
  patchAddPricingSpecInLenderContextInPricingSpec,
  patchAddRequiredFileTypeToDocumentationRequired,
  patchBlockUser,
  patchChangeAcquisitionChannelByMerchantId,
  patchChangeAgentIdChannel,
  patchChangeApprovalStatusByMerchantId,
  patchChangeDescription,
  patchChangeLoanStatus,
  patchChangeMerchantStatusByMerchantId,
  patchChangeRegistrationFieldsByMerchantId,
  patchChangeType,
  patchChangeUserId,
  patchCreateSignatureReminderRequestForMerchantContract,
  patchCreateSignatureRequestForMerchantContract,
  patchPaymentMethodModification,
  patchProcessLoanApplicationInLenderManually,
  patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId,
  patchRemoveRequiredFileTypeFromDocumentationRequired,
  patchSendDocumentationIncidenceNotification,
  patchSetAgentConfiguration,
  patchSetAgentIdInLenderContextById,
  patchSetAreDocumentsConfirmed,
  patchSetBorrowerOnboardingDetailsByRole,
  patchSetBrandInformationAndUploadLogoToCDN,
  patchSetBusinessDetailsToBusinessOnboardingDetails,
  patchSetCart,
  patchSetDocumentRequiredIsNotSent,
  patchSetDocumentStatus,
  patchSetHoldersToBusinessOnboardingDetails,
  patchSetLegalAddress,
  patchSetLenderRequestId,
  patchSetNieData,
  patchSetPricingIdsToAgent,
  patchSetProcessingConfigToMerchantAgents,
  patchSetRangesForAgent,
  patchSignLoanLenderBorrowerContract,
  patchSyncBorrowerDocumentationByLoanId,
  patchUnblockUser,
  patchUnSignLoanLenderBorrowerContract,
  patchUpdateBorrowerContractLoan,
  patchUpdateBorrowerDetails,
  patchUpdateCashInCashOutMethod,
  patchUpdateCashInCashOutMethodByMerchantId,
  patchUpdateDeclaredIncome,
  patchUpdateDownPayment,
  patchUpdateInvitationByType,
  patchUpdateLoanApplicationInLender,
  patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod,
  patchUpdatePaymentDateByPaymentLineId,
  patchUpdatePaymentMethodOptions,
  patchUpdatePaymentPlanLineSentDate,
  patchUpdatePaymentPlanLineStatus,
  patchUploadDocumentationToLender,
  patchUploadFileToDocumentationRequired,
  PaymentMethodType,
  PaymentMode,
  PaymentPlanLineStatus,
  PayoutStatus,
  PetitionType,
  postAgentInLenderContext,
  postCloneOrUpdateAgent,
  postCreateAgent,
  postCreateChannel,
  postCreateCheckoutSession,
  postCreateMerchant,
  postCreateMerchantData,
  postCreatePaymentIntent,
  postCreateUser,
  postCreditCardIberiaCards,
  postPaymentMethodModificationPreview,
  postSendEmailForNewVideoId,
  postSyncPricingsToCdnByAgentId,
  Priority,
  Product,
  ProductExternal,
  ProfessionalPosition,
  Program,
  PurchaseCountry,
  Relation,
  SecurityCheckName,
  SentCodeStatus,
  SimilarityLevel,
  StopCondition,
  TransactionType,
  TravelCategory,
  Turnover,
  UserType,
  WorkflowPlace,
} from '@nemuru-eng/js-api-client';
import {
  InsuranceProvider,
  InsuranceType,
  PaymentAttemptFailReason,
  PaymentAttemptStatus,
  PaymentProvider,
  RangeType,
} from '@nemuru-eng/js-api-client/slim';
import esLocale from 'date-fns/locale/es';

import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
import { FilterType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/Filter';
import { ApplicationIberiaCardsStep } from '@/components/modules/Application/IberiaCards/_shared/types/ApplicationIberiaCardsStep';
import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { KycIntegrationMethodOwner } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { CreditCardName } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { ValidationStep } from '@/components/modules/DocumentsValidation/types/ValidationStep';
import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { TimeIntervalType } from '@/components/modules/Metrics/shared/types/TimeIntervalType';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { DistributionMethod } from '@/components/shared/components/DistributionDialog/types/DistributionMethod';
import { FilterByType } from '@/components/shared/components/SuperSearchBar/types/FilterByType';
import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';
import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

import { OverduePlanLineStatus } from '../../components/modules/PaymentPlan/types/PaymentPlanLineStatusExtended';
import { FilterByDate } from '../../components/shared/components/SuperSearchBar/types/FilterByDate';
import { APP_ROLES } from '../config';
import { statusSections } from '../loanConfig';
import { PendingDataType } from '../types';

const es = {
  //GENERAL
  YES: 'Sí',
  NO: 'No',
  EDIT_INFORMATION: 'Editar información',
  DATE_FORMAT_DAY_MONTH_YEAR: 'Día, mes, año',
  DATE_FORMAT_MONTH_YEAR: 'Mes, año',
  DATE_FORMAT_YEAR: 'Año',
  DATE_LOCALE: esLocale,
  SEND: 'Enviar',
  CANCEL: 'Cancelar',
  SEE_MORE: 'Ver más',
  BY: 'por',
  OF: 'de',
  COPY: 'Copiar',
  EDIT: 'Editar',
  NO_OPTIONS_TO_DISPLAY: 'Sin opciones disponibles',
  ITEM: 'artículo',
  ITEMS: 'artículos',
  INFORMATION: 'Información',
  WELCOME_TO_THE_OFFER_PROCESS: 'Bienvenido $v1',
  WELCOME_TO_THE_OFFER_PROCESS_SUBTITLE: 'Asocia una referencia de pedido de tu sistema para esta nueva solicitud.',

  //PAGES
  HOME: 'Home',
  CONSUMER_LOAN_LIST: 'Préstamo consumo',
  CONSUMER_LOAN_DETAIL: 'Detalle de préstamo',
  DOCUMENTS_VALIDATION: 'Validación de documentación',
  AUTO_LOAN_LIST: 'Préstamo auto',
  AUTO_LIST: 'Préstamos auto',
  AUTO_LOAN_DETAIL: 'Detalle de préstamo',
  CREDIT_LINE_LIST: 'Línea de crédito',
  CREDIT_LINE_DETAIL: 'Detalle de línea de crédito',
  ORDER_LIST: 'BNPL',
  PAY_BY_LINK_LIST: 'Pay by link',
  ORDER_DETAIL: 'Detalle del pedido',
  MERCHANTS_LIST: 'Listado de merchants',
  MERCHANTS_LIST_TITLE: 'Merchants',
  CONSUMER_LOAN_SUBSECTION_TITLE: 'Listado de préstamos consumo',
  AUTO_SUBSECTION_TITLE: 'Listado de préstamos auto',
  CREDIT_LINE_SUBSECTION_TITLE: 'Listado de líneas de crédito',
  ORDER_SUBSECTION_TITLE: 'Listado de BNPL',
  PAY_BY_LINK_SUBSECTION_TITLE: 'Listado de Pay by link',
  MERCHANT_DETAIL: 'Detalle del merchant',
  MERCHANT_DETAILS: 'Detalles de merchant',
  BORROWER_LIST: 'Borrowers',
  BORROWER_DETAIL: 'Detalle de borrower',
  APPLICATIONS: 'Solicitudes',
  OPEN_APPLICATION: 'Abrir solicitud',
  CONTINUE_APPLICATION: 'Continuar solicitud',
  CONTINUE_APPLICATION_TEXT:
    'Has iniciado este método de pago pero todavía no has completado la información necesaria para enviar la solicitud a las entidades.',
  CUSTOMER_CONTINUE_APPLICATION_TEXT:
    'Tu cliente ha iniciado este método de pago pero todavía no ha completado la información necesaria para enviar la solicitud a las entidades.',
  PAY_FIRST_INSTALMENT_TITLE: 'Pendiente pago de la primera cuota...',
  PAY_FIRST_INSTALMENT_DESCRIPTION:
    'Deberás compartir el enlace de pago con tu cliente para que pueda acceder al proceso y completar el pago de la primera cuota con $v1. Una vez realizado el pago, el proceso se completará automáticamente.',
  PAY_FIRST_INSTALMENT_DESCRIPTION_NOT_SHAREABLE:
    'Tu cliente debe realizar el pago de la primera cuota con $v1. Una vez realizado el pago, el proceso se completará automáticamente.',

  BNPL_LENDER_SELECTED_APPROVED_TITLE: 'Entidad seleccionada',
  BNPL_LENDER_SELECTED_APPROVED_DESCRIPTION:
    'El cliente ha sido aprobado por $v1. Deberás compartir el enlace de pago con tu cliente para que pueda acceder al proceso y completar el pago de la primera cuota.',
  BNPL_LENDER_SELECTED_REJECTED_TITLE: 'Entidad no seleccionada',
  BNPL_LENDER_SELECTED_REJECTED_DESCRIPTION:
    'El cliente no ha sido seleccionado por ninguna entidad financiera. Puedes continuar con el proceso de pago seleccionando otro método de pago.',
  CAPTURE_ORDER_TITLE: 'Capturar el pedido',
  CAPTURE_ORDER_DESCRIPTION:
    'Para que puedas recibir el pago del importe total de este pedido, debes capturarlo. La captura del pedido se debe realizar en el momento en el que entregues los productos o prestes los servicios.',

  START: 'Iniciar',

  SHORTCUTS: 'Accesos directos',
  //LOGIN
  EMAIL: 'Correo electrónico',
  PASSWORD: 'Contraseña',
  PASSWORD_OPTIONAL: 'Contraseña (opcional)',
  ENTER: 'Entrar',
  LOGOUT: 'Cerrar sesión',
  FORGOT_PASSWORD: 'Olvidé mi contraseña',
  REQUIRED_FIELD_EMAIL: 'Se requiere un correo electrónico',
  REQUIRED_FIELD_PASSWORD: 'No has introducido contraseña',
  LOGIN: 'Iniciar sesión',
  DID_YOU_FORGET_YOUR_PASSWORD: '¿Has olvidado tu contraseña?',
  PLEASE_REVIEW_YOUR_LOGIN_CREDENTIALS: 'Por favor revisa tus credenciales de acceso',

  //ACCOUNT DETAIL
  ACTIVE_PROFILE: 'Perfil activo',
  ACTIVE_PROFILE_CAPTION: 'Tienes $v1 perfiles. Al cambiar de perfil, la página se recarga.',
  ACTIVE_PROFILE_TAG: 'Activo',
  MORE_PROFILES: '$v1 perfiles más',
  MORE_PROFILES_ONE: '1 perfil más',
  GO_TO_ACCOUNT: 'Ir a Cuenta',
  PROFILE_SWITCH_ERROR: 'No se ha podido cambiar de perfil',
  PROFILE_SWITCHING_TO: 'Cambiando a $v1…',
  ORGANIZATION: 'Organización',
  ORGANIZATION_STRUCTURE: 'Estructura jerárquica de tu cuenta',

  // FORGOT PASSWORD
  CREDENTIALS_RECOVERY: 'Recuperación de credenciales',
  CREDENTIALS_RECOVERY_EXPLANATION:
    'Por favor, introduce tu dirección de correo electrónico. Pronto recibirás un correo para crear una nueva contraseña y recuperar el acceso.',
  CREDENTIALS_RECOVERY_EMAIL_SENT: 'Se ha enviado un email a la dirección introducida',
  CREDENTIALS_RECOVERY_EMAIL_SENT_EXPLANATION:
    'Por favor, revisa tu bandeja de entrada. Si la dirección estaba asociada a una cuenta válida, recibirás un correo para crear una nueva contraseña y recuperar el acceso.',
  RECOVERY_PASSWORD_EMAIL_FAILED: 'El envío del correo para recuperar la contraseña ha fallado.',
  PLEASE_CHECK_INPUT_DATA_OR_TRY_LATER:
    'Por favor, revisa los datos introducidos. Si el problema persiste, intentalo más tarde o contacta con nuestro apoyo al cliente',
  CREATE_YOUR_PASSWORD_EXPLANATION: 'Crea una nueva contraseña para recuperar el acceso a la plataforma',
  BACK_TO_HOME: 'Volver a Inicio',
  INVALID_EMAIL: 'Correo electrónico no válido',
  INVALID_URL: 'URL no válida',
  INVALID_JSON: 'JSON inválido',
  FORMAT_JSON: 'Formatear JSON',
  YOU_CAN_SAFELY_CLOSE_THE_DIALOG: 'Ya puedes cerrar esta ventana',
  RETRY: 'Volver a intentar',
  CLOSE: 'Cerrar',
  OPEN_IN_NEW_TAB: 'Abrir en una nueva pestaña',
  UPDATING: 'Actualizando...',
  BACK_TO_LOGIN: 'Volver a Login',
  ACTION_REQUEST_AUTH_REJECTED: 'Error al iniciar sesión',

  YOU_CAN_CLOSE_THIS_WINDOW_AND_LOGIN_WITH_YOUR_NEW_PASSWORD:
    'Ya puedes cerrar esta ventana con seguirada y entrar a tu cuenta con la nueva contraseña',

  //SET PASSWORD
  CREATE_YOUR_PASSWORD: 'Crea tu contraseña',
  MIN_PASSWORD_LENGTH: 'Debe contener como mínimo 6 caracteres',
  CURRENT_PASSWORD: 'Contraseña actual',
  NEW_PASSWORD: 'Nueva contraseña',
  NEW_PASSWORD_MIN_VALUE: 'Nueva contraseña (mínimo $v1 caracteres)',
  REPEAT_NEW_PASSWORD: 'Repite nueva contraseña',
  CHANGE_PASSWORD: 'Cambiar contraseña',
  CHANGE: 'Cambiar',
  NEW_PASSWORD_CANNOT_BE_SAME_AS_CURRENT: 'La nueva contraseña no puede ser igual a la actual',
  NEW_PASSWORD_AND_CONFIRMATION_DONT_MATCH: 'Las contraseñas no coinciden',

  // FORM INPUT HELP
  REQUIRED_FIELD: 'Campo requerido',
  PLEASE_COMPLETE_THIS_FIELD_CORRECTLY: 'Por favor, complete el campo correctamente',
  INVALID_FORMAT: 'Formato no válido',
  PLEASE_CHECK_INPUT_DATA: 'Por favor, revisa los datos introducidos.',
  CANNOT_BE_LESS_THAN_LOAN_AMOUNT: 'No puede ser menor al importe del préstamo',
  REQUIRED_MIN_LENGTH: 'Numero mínimo requerido de caracteres no alcanzado',
  REQUIRED_MAX_LENGTH: 'Se ha alcanzado la longitud máxima caracteres',
  MIN_NUMBER_ERROR: 'El valor no supera el mínimo exigido',
  MAX_NUMBER_EXCEEDED: 'Numero máximo excedido',
  INVALID_POSTAL_CODE: 'Código postal no válido',
  EQUAL_OR_LARGER_THAN: 'Debe ser igual o mayor que $v1',

  //NOTIFICATIONS
  NOTIFICATIONS: 'Notificaciones',
  ALL_NOTIFICATIONS_READ_AND_NO_NEW_NOTIFICATIONS:
    'Todas las notificaciones se han leído y no hay nuevas notificaciones',
  ALL_NOTIFICATIONS_READ: 'Todas las notificaciones se han leído',
  NO_NEW_NOTIFICATIONS: 'No hay nuevas notificaciones',
  BORROWER_NOTIFICATIONS: 'Notificaciones enviadas a cliente',
  AGENT_NOTIFICATIONS: 'Notificaciones enviadas al comercio',
  NO_NOTIFICATIONS: 'Todavía no se han enviado notificaciones',
  EXTERNAL_ID_TYPE: 'Tipo',
  NOTIFICATION_TYPE: 'Tipo de notificación',
  DELIVERED_AT: 'Fecha entrega',
  MESSAGE_SUBJECT: 'Asunto',
  DELIVERY_STATUS: 'Entregado',
  LOADING_NOTIFICATIONS: 'Cargando notificaciones',

  //TASKS:
  MANAGEMENT: 'Gestión',
  SUPPORT: 'Soporte',
  TASKS: 'Tareas',
  NO_NEW_TASKS: 'No hay nuevas tareas',
  ALL_TASKS_COMPLETED: 'Todas las tareas están completadas',

  // SUPER SEARCH BAR:
  SEARCH_BAR: 'Buscador',
  SEARCH_APPLICATIONS: 'Buscar solicitud...',
  SEARCH_MERCHANTS: 'Buscar merchant...',
  SEARCH_AGENTS: 'Buscar agente...',
  LOADING_RESULTS: 'Cargando resultados...',
  DYNAMIC_CUSTOMER_NAME_WITH_APPLICATION_AMOUNT: '$v1 por $v2',
  [FilterByDate.TODAY]: 'Hoy',
  [FilterByDate.LAST_7_DAYS]: 'Últimos 7 días',
  [FilterByDate.LAST_30_DAYS]: 'Últimos 30 días',
  [FilterByDate.ALL_DATES]: 'Cualquier fecha',
  [FilterByType.APPLICATIONS]: 'Productos',
  [FilterByType.CHECKOUT_SESSIONS]: 'Solicitudes',
  [FilterByType.MERCHANTS]: 'Merchants',
  UPDATED_AT_DESCEND: 'Fecha actualización: Recientes primero',
  UPDATED_AT_ASCEND: 'Fecha actualización: Antiguos primero',
  CREATED_AT_ASCEND: 'Fecha creación: Antiguos primero',
  CREATED_AT_DESCEND: 'Fecha creación: Recientes primero',
  SORT_BY: 'Ordenar',
  ITEMS_PER_PAGE: 'Resultados por pagina',
  COPY_ID: 'Copiar ID',
  SELECT: 'Seleccionar',
  NO_SELECTION: 'Sin selección',
  OPEN: 'Abrir',
  NAVIGATE: 'Navegar',

  //HOME
  WELCOME_TO_PANEL: '¡Hola, $v1!',
  CHOOSE_SECTION:
    'Estos son los apartados a los que tienes acceso con tu rol $v1. Elige el que desees para empezar a gestionar.',

  //GLOBAL METRICS
  [TimeIntervalType.TODAY]: 'Hoy',
  [TimeIntervalType.THIS_WEEK]: 'Últimos 7 días',
  [TimeIntervalType.THIS_MONTH]: 'Últimos 30 días',
  NO_PREVIOUS_RESULTS: 'Sin datos anteriores',
  OF_PREV_PERIOD: 'período anterior ($v1)',
  [`${ScoreCardMetricKey.totalLoansNumber}_TID`]: 'Solicitudes',
  [`${ScoreCardMetricKey.totalPrincipalAmount}_TID`]: 'Importe',
  [ScoreCardMetricKey.totalLoansNumber]: 'Solicitudes',
  [ScoreCardMetricKey.totalPrincipalAmount]: 'Importe',

  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.INITIAL}`]: 'Iniciado',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.ON_HOLD}`]: 'Solicitado',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.REQUESTED}`]: 'Preaprobado',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.APPROVED}`]: 'Preaprobado',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.CONFIRMED}`]: 'Confirmado',
  [`LOAN_STATUS_EXTERNAL_${LoanStatusExternal.PAID}`]: 'Pagado',

  [`PRODUCT_EXTERNAL_${ProductExternal.CONSUMER_LOAN}`]: 'Préstamo consumo',
  [`PRODUCT_EXTERNAL_${ProductExternal.AUTO}`]: 'Préstamo auto',
  [`PRODUCT_EXTERNAL_${ProductExternal.CREDIT_LINE}`]: 'Línea de crédito',
  [`PRODUCT_EXTERNAL_${ProductExternal.BNPL}`]: 'BNPL',
  [`PRODUCT_EXTERNAL_${ProductExternal.PAY_BY_LINK}`]: 'Pay by link',

  TOP_MERCHANTS_TITLE: 'Top merchants',
  TOP_MERCHANTS_DESCRIPTION: 'Con más confirmadas durante $v1.',

  PRODUCT_EXTERNAL_TITLE: 'Tipos de solicitud',
  PRODUCT_EXTERNAL_DESCRIPTION: 'Confirmadas durante $v1.',

  CHANNEL_METRICS: 'Métricas del canal',
  MERCHANT_METRICS: 'Métricas del merchant',
  AGENT_METRICS: 'Métricas del agente',
  NO_METRICS_INFORMATION: 'Sin datos para mostrar',

  //CONSUMER LOAN LIST
  LOAN: 'Solicitud',
  PRODUCTS_LIST: 'Listado de productos',
  TYPE: 'Tipo',
  CLIENT: 'Titular',
  CREATION_DATE: 'Fecha creación',
  CREATED: 'Creado:',
  UPDATE_DATE: 'Fecha actualización',
  ID: 'ID',
  STATUS: 'Estado',
  CHECKOUT_SESSION_STATUS: 'Estado solicitud',
  SELECTED_PAYMENT_INTENT: 'Método de pago',
  ALL: 'Todos',
  [CustomRegistry.DEFAULT]: 'Por defecto',
  [CustomRegistry.TECHNOLOGICAL_PLATFORM]: 'Plataforma tecnológica',
  SELECT_ALL: 'Seleccionar todos',
  DESELECT_ALL: 'Deseleccionar todos',
  FROM_DATE: 'Desde fecha',
  TO_DATE: 'Hasta fecha',
  LENDER: 'Entidad financiera',
  ORDER_DETAILS: 'Detalle del pedido',
  LOAN_DETAILS: 'Detalles de solicitud',
  BORROWER_DETAILS: 'Detalles prescriptor',
  STATUS_DETAILS: 'Detalles estado',
  LENDER_ASSIGNMENT_DETAILS: 'Detalles entidad financiera',
  ID_DETAILS: 'Detalles ID',
  MAIN_RESIDENCE_ADDRESS: 'Dirección',
  EDIT_DOCUMENT_ID: 'Editar datos personales',
  EDIT_MAIN_RESIDENCE_INFORMATION: 'Editar datos del domicilio principal',
  EDIT_FAMILIAR_SITUATION: 'Editar datos familiares',
  EDIT_PROFESSIONAL_DETAILS: 'Editar datos profesionales',
  DOCUMENT_EXPEDITOR: 'País de expedición',

  REFERENCES_DETAILS: 'Detalles referencias',

  [statusSections.PENDING]: 'Iniciado',
  [statusSections.ANALYSING]: 'Solicitado',
  [statusSections.APPROVED]: 'Preaprobado',
  [statusSections.FORMALIZED]: 'Confirmado',
  [statusSections.DENIED]: 'Denegado',
  [statusSections.CANCELLED]: 'Cancelado',
  [statusSections.DESISTED]: 'Desistido',
  [statusSections.EXPIRED]: 'Caducado',

  PROCESS_TERMINATED: 'Proceso terminado',

  ['status_active,status_active_trial']: 'Pago realizado',
  ['status_cancelled,status_cancelled_test']: 'Cancelado',

  STATUS_NEXT_STEP_INITIAL_CERTIFICATION: 'Primera certificación',
  STATUS_DESC_INITIAL_CERTIFICATION: 'Primera certificación pendiente',
  STATUS_DESC_APPLICATION_STARTED: 'Solicitud iniciada',

  STATUS_NEXT_STEP_PARTIALLY_CERTIFICATED: 'Certificaciones y abono',
  STATUS_DESC_PARTIALLY_CERTIFICATED: 'Certificaciones pendientes',

  STATUS_NEXT_STEP_INITIATED: 'Rellenado de datos del cliente',
  STATUS_DESC_INITIATED: 'Pendiente rellenar por el cliente',

  STATUS_NEXT_STEP_LENDER_HAS_BEEN_SELECTED: 'Firma del contrato',
  STATUS_DESC_PENDING_CONTRACT_SENDING: 'Pendiente envío contrato',
  STATUS_DESC_LENDER_HAS_BEEN_SELECTED: 'Contrato enviado, pendiente firma',

  STATUS_NEXT_STEP_CONTRACT_SIGNED: 'Validación de la solicitud',
  STATUS_DESC_CONTRACT_SIGNED: 'Firmado por formalizar',

  STATUS_NEXT_STEP_DOCUMENTATION: 'Envío transferencia',
  STATUS_DESC_DOCUMENTATION: 'Pago pendiente',

  STATUS_NEXT_STEP_UNOPENED: 'Apertura de la solicitud',
  STATUS_DESC_UNOPENED: 'Sin Abrir',

  STATUS_NEXT_STEP_ANALYSING: 'Estudio de riesgos',
  STATUS_DESC_ANALYSING: 'En estudio riesgos',

  STATUS_NEXT_STEP_UNPAID: 'Impago',
  STATUS_DESC_UNPAID: 'Cliente en impago',

  STATUS_NEXT_STEP_DENIED: 'Denegación',
  STATUS_DESC_DENIED: 'Solicitud denegada',

  STATUS_NEXT_STEP_DESISTED: 'Desistido',
  STATUS_DESC_DESISTED: 'El cliente ha desistido',

  STATUS_NEXT_STEP_EXPIRED: 'Expiración',
  STATUS_DESC_EXPIRED: '30 días sin actividad',
  STATUS_DESC_ORDER_EXPIRED: 'El pedido ha caducado',

  STATUS_NEXT_STEP_CANCELLED: 'Cancelación',
  STATUS_DESC_CANCELLED: 'Cancelado',

  STATUS_NEXT_STEP_CANCELLED_TEST: '-',
  STATUS_DESC_CANCELLED_TEST: 'Prueba cancelada',

  STATUS_NEXT_STEP_ACTIVE: 'Abono',

  STATUS_DESC_FRONT_COMPLETED: 'Completado',

  STATUS_DESC_ACTIVE: 'Pago realizado',
  STATUS_DESC_INFORMATION_PENDING: 'Pendiente rellenar',
  STATUS_DESC_PAYMENT_PENDING: 'Pago pendiente',
  FILTER_FROM: 'Filtrar desde',
  FILTER_TO: 'Filtrar hasta',
  updated_at: 'Fecha actualización',
  created_at: 'Fecha creación',
  expiration_date: 'Fecha expiración',

  COBORROWER_UNDER_MANAGEMENT: 'Cotitular en gestión',

  //CONSUMER LOAN DETAILS

  TOTAL_COST_PER_QUOTA: 'Coste total ($v1 por cuota)',
  TOTAL_COST_PER_QUOTA_UPFRONT_PERCENTAGE: 'Coste total ($v1 upfront)',

  //MERCHANT LIST
  CONTACT_PERSON: 'Persona de contacto',
  STATUS_PENDING_DOCUMENTS: 'Documentación pendiente',
  STATUS_DOCUMENTS_COMPLETED: 'Documentación completada',
  STATUS_DENIED_PENDING_MANUAL: 'Denegado pendiente manual',
  STATUS_DENIED_EVALUATED: 'Evaluado denegado',
  STATUS_PRE_APPROVED: 'Preaprobado',
  STATUS_ASLEEP: 'Dormido',
  STATUS_SUSPENDED: 'Suspendido',
  STATUS_BANNED: 'Expulsado',
  contact_person: 'Persona de contacto',
  status_pending_documents: 'Documentación pendiente',
  status_documents_completed: 'Documentación completada',
  status_denied_pending_manual: 'Denegado pendiente manual',
  status_denied_evaluated: 'Evaluado denegado',
  status_pre_approved: 'Preaprobado',
  status_asleep: 'Dormido',
  status_suspended: 'Suspendido',
  status_banned: 'Expulsado',

  //MERCHANT LIST WIDGET
  ACTIONS: 'Acciones',
  ADD_MERCHANT: 'Crear merchant',
  CREATE_MERCHANT: 'Crear nuevo merchant',

  //MERCHANT DETAIL WIDGET
  APPROVE_BY_COMMERCIAL: 'Aprobar por comercial',
  APPROVE_BY_COMMERCIAL_TEXT: '¿Deseas aprobar a este merchant por comercial?',
  APPROVE_BY_COMMERCIAL_BTN: 'Aprobar',
  APPROVE_BY_RISK: 'Aprobar por riesgos',
  APPROVE_BY_RISK_TEXT: '¿Deseas aprobar a este merchant por riesgos?',
  APPROVE_BY_RISK_BTN: 'Aprobar',
  SUSPEND_ACTION: 'Suspender merchant',
  SUSPEND_ACTION_TEXT: '¿Deseas suspender temporalmente a este merchant?',
  SUSPEND_ACTION_BTN: 'Suspender',
  BAN_ACTION: 'Expulsar merchant',
  BAN_ACTION_TEXT: '¿Deseas expulsar permanentemente a este merchant?',
  BAN_ACTION_BTN: 'Expulsar',
  REACTIVATE_ACTION: 'Reactivar merchant',
  REACTIVATE_ACTION_TEXT: '¿Deseas reactivar a este merchant?',
  REACTIVATE_ACTION_BTN: 'Reactivar',
  APPROVE: 'Aprobar',
  SUSPEND: 'Suspender',
  BAN: 'Expulsar',

  // MERCHANT OVERVIEW
  MERCHANT_CONFIGURATION: 'Configuración del merchant',
  PENDING_TODO_ACTIONS: 'Acciones pendientes',
  MERCHANT_OVERVIEW: 'Detalle del merchant',
  REGISTRATION_DATA: 'Datos de registro',
  COMPANY_INFORMATION: 'Información de la empresa',
  BUSINESS_NAME: 'Nombre merchant',
  BUSINESS_NAME_FISCAL: 'Razón social',
  BUSINESS_TYPE: 'Tipo de negocio',
  DECLARED_BUSINESS_TYPE: 'Tipo de negocio',
  [DeclaredBusinessType.SELF_EMPLOYED]: 'Autónomo/a',
  [DeclaredBusinessType.LTD]: 'Empresa',
  MERCHANT_CATEGORY: 'Sector',
  BUSINESS_DETAILS: 'Detalles empresa',
  SECTOR: 'Sector',
  ACQUISITION_CHANNEL: 'Canal de adquisición',
  CIF: 'CIF',
  TURNOVER: 'Facturación anual',
  [Turnover.ZERO_300]: 'De 0€ a 300K€',
  [Turnover.THREE_HUNDRED_1MILLION]: 'De 300K€ a 1M€',
  [Turnover.ONE_MILLION_2_MILLION]: 'De 1M€ a 2M€',
  [Turnover.TWO_MILLION_5_MILLION]: 'De 2M€ a 5M€',
  [Turnover.FIVE_MILLION_PLUS]: 'Más de 5M€',
  POSTAL_CODE: 'Código postal',
  AMOUNT_OF_EMPLOYEES: 'Número de empleados',
  [AmountOfEmployees.ZERO_THREE]: 'De 0 a 3',
  [AmountOfEmployees.THREE_TEN]: 'De 3 a 10',
  [AmountOfEmployees.TEN_TWENTY]: 'De 10 a 20',
  [AmountOfEmployees.TWENTY_PLUS]: 'Más de 20',

  CONTACT_PERSON_DETAILS: 'Detalles de contacto',
  CONTACT_PERSON_FIRSTNAME: 'Nombre persona de contacto',
  CONTACT_PERSON_LASTNAME: 'Apellidos persona de contacto',
  NAME: 'Nombre',
  FIRSTNAME: 'Nombre',
  LASTNAME: 'Apellidos',
  FULLNAME: 'Nombre y apellidos',
  PHONE: 'Teléfono',

  LEGAL_ADDRESS: 'Dirección fiscal',
  ADD_LEGAL_ADDRESS: 'Añadir dirección fiscal',
  EDIT_LEGAL_ADDRESS: 'Editar dirección fiscal',

  CASH_IN_CASH_OUT_METHOD: 'Información bancaria',
  ACCOUNT_HOLDER_FIRSTNAME: 'Nombre titular',
  ACCOUNT_HOLDER_LASTNAME: 'Apellidos titular',
  BANK: 'Entidad financiera',
  ACCOUNT_NUMBER_IS_NOT_VALID: 'El número de cuenta bancaria no es válido',
  BANK_RELATED_TO_ACCOUNT_NUMBER_DOES_NOT_EXIST_IN_TABLE: 'El número de cuenta corresponde a un banco no soportado',
  BANK_ACCOUNT_NUMBER_DOES_NOT_MATCHES_THE_SELECTED_BANK:
    'El banco seleccionado no corresponde a la cuenta bancaria introducida',

  ADD_CASH_IN_CASH_OUT_METHOD: 'Añadir información bancaria',
  EDIT_CASH_IN_CASH_OUT_METHOD: 'Editar información bancaria',

  ADD_BRAND_INFORMATION: 'Añadir información de marca',
  EDIT_BRAND_INFORMATION: 'Editar información de marca',
  BRANDING: 'Branding',
  BRAND_NAME: 'Nombre comercial',
  CUSTOMER_SUPPORT_EMAIL: 'Email soporte',
  CUSTOMER_SUPPORT_PHONE_NUMBER: 'Teléfono soporte',
  HOMEPAGE_URL: 'URL homepage',
  BRAND_LOGO: 'Logo del comercio',
  BRAND_LOGO_URL: 'URL logo',
  ADD_BRANDING_INFROMATION: 'Añadir branding',
  EDIT_BRANDING_INFORMATION: 'Editar branding',
  CHOOSE_IMAGE_FILE: 'Seleccionar el fichero',
  CHOOSE_LOGO_IMAGE_FILE: 'Seleccionar el fichero del logo',
  IMAGE_SIZE: 'Tamaño de la imagen',

  // MERCHANT COMPLIANCE
  MERCHANT_CONTRACT: 'Contrato de colaboración',
  CONTRACT_SENT_DATE: 'Fecha envío del contrato',
  CONTRACT_SIGNED_DATE: 'Fecha firma del contrato',
  CONTRACT_STATUS: 'Estado del contrato',
  SIGNED: 'Firmado',
  NOT_SENT: 'No enviado',
  MERCHANT_DATA: 'Datos de la empresa',
  COMPANY_MANAGER_DATA: 'Datos del administrador',
  COMPANY_MANAGER_NAME: 'Nombre y apellido(s)',
  ID_NUMBER: 'Número de documento de identidad',
  COMPLIANCE_CONTRACT_PENDING: 'Contrato de colaboración pendiente',

  SEE_MERCHANT_CONTRACT_FIELDS: 'Ver datos del contrato enviado',
  SEE_MERCHANT_CONTRACT_FIELDS_FROM_CRM: 'Ver datos actuales en el CRM',
  MERCHANT_CONTRACT_DATA: 'Datos del contrato',
  MERCHANT_CONTRACT_DATA_FROM_CRM: 'Datos del contrato en el CRM',
  MERCHANT_CONTRACT_DATA_TEXT:
    'Los siguientes datos corresponden a los enviados en el contrato de colaboración el día $v1.',
  PROVINCE: 'Provincia',
  COMPANY_MANAGER_FULLNAME: 'Nombre y apellidos del administrador',
  COMPANY_MANAGER_DOCUMENT_NUMBER: 'DNI administrador',
  CONTACT_EMAIL: 'Email de contacto',
  CONTACT_PHONE_NUMBER: 'Teléfono de contacto',

  SEND_MERCHANT_CONTRACT_REMINDER: 'Enviar recordatorio de firma',
  SEND_REMINDER: 'Enviar recordatorio',
  SEND_MERCHANT_CONTRACT_REMINDER_TEXT: '¿Deseas enviar un recordatorio para firmar el contrato que ya fue enviado?',
  SEND_NEW_MERCHANT_CONTRACT: 'Enviar nuevo contrato',
  SEND_NEW_MERCHANT_CONTRACT_TEXT:
    '¿Deseas enviar un nuevo contrato con los datos actuales del CRM? Puedes ver los datos que se incluirán en el nuevo contrato haciendo click en “Ver datos actuales en el CRM".',

  // MERCHANT IN LENDER CONTEXT
  FINANCIAL_ENTITIES_ENABLED: 'Entidades financieras habilitadas',
  ADD_MERCHANT_IN_LENDER_CONTEXT: 'Añadir entidades financieras',
  EDIT_MERCHANT_IN_LENDER_CONTEXT: 'Editar entidades financieras',
  EDIT_MERCHANT_IN_LENDER_CONTEXT_TEXT: 'Selecciona las entidades financieras habilitadas para este merchant.',

  // MERCHANT_STRUCTURE
  REFRESH: 'Actualizar',
  LIVE: 'En vivo: esta página se actualiza automáticamente',
  LIVE_RECONNECTING: 'Reconectando a las actualizaciones en vivo…',
  LIVE_PENDING_CHANGES: '$v1 cambios · Actualizar',
  REFRESH_DATA: 'Actualizar información',
  MAIL: 'Email',
  ADD_MERCHANT_STRUCTURE: 'Añadir canales y agentes',
  MERCHANT_STRUCTURE: 'Estructura',
  CHANNEL_STRUCTURE: 'Estructura del canal',
  CHANNELS_AND_AGENTS: 'Canales y agentes',
  SELECT_CHANNEL_TO_VIEW_ITS_AGENTS_AND_DETAILS: 'Selecciona un canal para ver sus agentes y detalles.',
  X_CHANNELS_AND_Y_AGENTS_IN_TOTAL: '$v1 canales y $v2 agentes en total.',
  SELECT_CHANNEL_TO_VIEW_DETAILS: 'Selecciona este canal para ver sus agentes y detalles.',
  X_ONLY_INCLUDES_ONE_CHANNEL: 'Se compone de un único canal con $v2 agente/s',
  AGENTS: 'Agentes',
  AGENT: 'Agente',
  SALES_AGENT: 'Agente (Vendedor)',
  SEARCH_AGENT: 'Buscar agente',
  SEARCH_CHANNEL: 'Buscar canal',
  CHANNEL: 'Canal',
  CHANNELS: 'Canales',
  SALES_CHANNEL: 'Canal de ventas',
  NO_ASSOCIATED_CHANNEL_ACCOUNT: 'Sin acceso',
  THERE_ARE_NO_AGENTS_ON_THIS_CHANNEL_YET: 'Aún no hay ningún agente creado en este canal',
  THERE_ARE_NO_CHANNEL_YET: 'Aún no hay ningún canal creado',
  THERE_ARE_NO_LISTS_TO_SHOW: 'Todavía no hay solicitudes para mostrar',
  AGENTS_OF_CHANNEL_X: 'Agentes del canal $v1',
  MERCHANT_STATISTICS: 'Estadísticas de merchant',
  COPY_MERCHANT_ID: 'Copiar ID merchant',
  COPY_AGENT_ID: 'Copiar ID agente',
  COPY_CHANNEL_ID: 'Copiar ID canal',
  COPY_BORROWER_ID: 'Copiar ID borrower',
  ADD_CHANNEL: 'Añadir canal',
  ADD_ANOTHER_AGENT: 'Añadir otro agente',
  ADD_AGENT_TO_CHANNEL: 'Añadir agente a $v1',
  NUMBER_OF_CHANNELS: '$v1 canales',
  NUMBER_OF_CHANNEL_1: '1 canal',
  NUMBER_OF_AGENTS: '$v1 agentes',
  NUMBER_OF_AGENT_1: '1 agente',

  SELECTED_AGENT_ERROR_ALERT:
    'El agente seleccionado no tiene métodos de pago disponibles. Por favor, prueba seleccionar otro agente o canal.',

  TYPE_OF_APPLICATIONS: 'Solicitudes de tipo:',
  APPLICATIONS_LIST: 'Listado de solicitudes',

  //MERCHANT CATEGORY
  awnings: 'Toldos',
  elevators: 'Ascensores',
  installations: 'Instalaciones',
  education_and_trainings: 'Educación',
  buildings: 'Edificación',
  car_dealerships: 'Venta coches',
  moto_dealerships: 'Venta motos',
  driving_courses: 'Cursos de conducción',
  languages_courses: 'Cursos de idiomas',
  bootcamp_courses: 'Bootcamps',
  fp_programs: 'Cursos de formación',
  business_schools_programs: 'Business schools',
  postgraduate_and_masters: 'Masters',
  other_professional_courses: 'Otros cursos profesionales',
  school: 'Institutos',
  fertility_treatment: 'Tratamientos de fertilidad',
  orthopedic_equipment: 'Aparatos ortopédicos',
  other_surgery_interventions: 'Otras intervenciones quirúrgicas',
  rehabilitation: 'Rehabilitación',
  optical_prosthesis: 'Protesis oculares',
  cosmetic_surgery: 'Medicina estética',
  dental_treatments: 'Medicina dental',
  cosmetic_treatments: 'Tratamientos cosméticos',
  auditory_prothesis: 'Protesis auditivas',
  terrace_and_awnings: 'Terrazas y toldos',
  structure_and_humidity: 'Estructuras y humedades',
  insulation: 'Aislamientos',
  warehouse: 'Almacén de material',
  kitchen: 'Cocinas',
  bathrooms: 'Duchas y baños',
  furniture: 'Muebles',
  windows: 'Ventanas y puertas',
  pools: 'Piscinas',
  gardening: 'Jardines',
  home_automation: 'Domótica',
  prefabricated_houses: 'Casas prefabricadas',
  decoration_and_design: 'Decoradores y diseñadores',
  architecture: 'Arquitectos',
  floors_and_ceilings: 'Parquet y techos',
  whole_house: 'Reformas integrales',
  painting: 'Pintores',
  carpentry: 'Carpintería, madera y aluminio',
  home_staging: 'Home staging',
  water_treatment: 'Tratamiento de agua',
  air_treatments: 'Aire acondicionado',
  eco_improvement_and_solar_panels: 'Ecoreformas y paneles solares',
  electric_installations: 'Instalaciones eléctricas',
  heating_installations: 'Calefacción',
  alarms_and_security: 'Sistemas de alarma',
  car_tuning: 'Car tuning',
  car_service: 'Talleres coches',
  moto_service: 'Talleres motos',
  bike: 'Bicicletas',
  other_mobility_and_accessories: 'Otros accesorios de movilidad',
  household_appliances: 'Electrodómesticos',
  garden_machines: 'Maquinaria de jardinería',
  perfumery_and_cosmetics: 'Perfumería y cosméticos',
  gym_accessories: 'Accesorios de gimnasio',
  electronic: 'Electrónica',
  antiques: 'Antigüedades',
  art: 'Arte',
  jewellery: 'Joyería',
  fashion: 'Moda y accesorios',
  lighting: 'Iluminación',
  travels: 'Viajes',
  relocation: 'Mudanzas',
  real_estate_and_rentals: 'Inmobiliarias y alquileres',
  celebrations: 'Celebraciones',
  funeral_services: 'Servicios funerarios',
  pet_shops: 'Tiendas de mascotas',
  charging_points: 'Puntos de carga',

  //LOAN DETAIL WIDGET
  ADD_PARTICIPANT_TO_LOAN: 'Añadir cotitular/avalista',
  REMOVE_PARTICIPANT_FROM_LOAN: 'Eliminar cotitular/avalista',
  ADD_GUARANTOR_TO_LOAN: 'Añadir avalista',
  REMOVE_GUARANTOR_FROM_LOAN: 'Eliminar avalista',
  REMOVE_PARTICIPANT_DIALOG: 'Eliminar cotitular/avalista',
  REMOVE_GUARANTOR_DIALOG: 'Eliminar avalista',
  REMOVE_PARTICIPANT_DIALOG_TEXT: '¿Deseas eliminar el siguiente participante de la solicitud?',
  REMOVE_PARTICIPANT_DIALOG_BTN: 'Eliminar participante',
  remove_co_borrower: 'Eliminar cotitular',
  remove_guarantor: 'Eliminar avalista',
  PARTICIPANT_ROLE: 'Tipo de participante',
  ADD_PARTICIPANT_DIALOG: 'Añadir cotitular/avalista',
  ADD_GUARANTOR_DIALOG: 'Añadir avalista',
  ADD_PARTICIPANT_DIALOG_TEXT:
    'Rellena los datos de contacto del nuevo cotitular/avalista de la solicitud. A continuación le enviaremos un email para que pueda completar su información personal.',
  PARTICIPANT_RELATION: 'Relación',
  ADD_PARTICIPANT_DIALOG_BTN: 'Añadir participante',
  add_borrower: 'Añadir titular',
  add_co_borrower: 'Añadir cotitular',
  add_guarantor: 'Añadir avalista',
  INVALID_PHONE_NUMBER: 'Número de teléfono inválido',
  INVALID_DIAL_CODE: 'Código inválido',
  REMOVE_GUARANTOR_DIALOG_TEXT: '¿Deseas eliminar el siguiente avalista de la solicitud?',
  CHANGE_LOAN_CONDITIONS: 'Modificar condiciones',
  PRINCIPAL_VALUE_SELECTOR: 'Importe (entre $v1 y $v2)',
  TERM_VALUE_SELECTOR: 'Plazo (entre $v1 y $v2 meses)',
  INVALID_PRINCIPAL_VALUE: 'Importe no permitido',
  AUTO_AMOUNT_OUT_OF_RANGE: 'El importe del vehículo debe ser superior a $v1',
  INVALID_TERM_VALUE: 'Plazo no permitido',
  THE_TERM_VALUE_DOES_NOT_EXIST_IN_PRICING: 'El plazo no existe para la tarifa e importe seleccionados',
  SELECT_PRICING: 'Selecciona tarifa',
  SELECT_PRICING_DESCRIPTION:
    'Selecciona una de las tarifas disponibles para el agente e introduce los nuevos valores de importe y plazo.',
  EDIT_LOAN_CONDITIONS: 'Editar condiciones del préstamo',
  CURRENT_LOAN_CONDITIONS: 'Condiciones actuales',
  NEW_LOAN_CONDITIONS: 'Nuevas condiciones',
  COMPARE: 'Comparar condiciones',
  ADJUST_LOAN_CONDITION: 'Volver a ajustar condiciones',
  NO_PRICINGS_AVAILABLE: 'No se han encontrado tarifas disponibles',
  PRICINGS_ARE_FILTERED_BY_LOAN_CONDITIONS: '*Las tarifas se están filtrando por el programa actual del préstamo',
  LOAN_CALCULATOR_NOT_FOUND_FOR_THE_GIVEN_TERM: 'No se han encontrado condiciones para el plazo seleccionado',
  SELECT_PRICING_PRINCIPAL_AND_TERM: 'Selecciona una tarifa del agente e introduce importe y plazo válidos',
  INVALID_OPTIONS_FOR_THE_CONDITIONS: 'Opciones no válidas para el programa seleccionado',
  [`all_${PricingFilterType.PRODUCT}`]: 'Todos los productos',
  [`all_${PricingFilterType.PROGRAM}`]: 'Todos los programas',
  //translate till here

  // AGENT DETAIL WIDGET
  CHANGE_TO_ANOTHER_CHANNEL: 'Cambiar de canal',
  CHANGE_TO_ANOTHER_CHANNEL_TEXT: '¿Deseas mover el agente a otro canal?',
  CHANGE_TO_ANOTHER_CHANNEL_BTN: 'Cambiar de canal',
  NEW_CHANNEL: 'Nuevo canal',
  CURRENT_CHANNEL: 'Canal actual',

  CREATE_NEW_AGENTS: 'Crear nuevos agentes',
  MODIFY_AGENTS: 'Modificar agentes',
  FROM_THIS_AGENT: 'Vas a copiar a partir de los datos de este agente:',
  LIST_OF_NEW_AGENTS: 'Listado de nuevos agentes',
  LIST_OF_NEW_AGENTS_TEXT:
    'Introduce el nombre, apellidos y email de los múltiples agentes a generar a partir del agente seleccionado:',
  LIST_OF_AGENTS_TO_UPDATE: 'Listado de agentes a modificar',
  LIST_OF_AGENTS_TO_UPDATE_TEXT: 'Escoge los agentes a modificar a partir del agente seleccionado:',
  BACK: 'Volver',

  CLONE_AGENT_MENU: 'Copiar y crear nuevos agentes',
  UPDATE_AGENT_MENU: 'Copiar y modificar agentes',

  CLONE_AGENT_WITH_NAME: 'Clonar a $v1',
  // 'Copia la configuración deseada de este agente y genera todos los nuevos agentes de forma rápida para el canal deseado:',
  CLONE_AGENT_BTN: 'Clonar',
  AGENT_TO_CLONE: 'Copiar datos de',
  DESTINATION_CHANNEL: 'Canal de destino',
  DESTINATION_CHANNEL_TOOLTIP: 'Elige el canal de destino donde se asignarán los nuevos agentes clonados',
  CONFIGURATION_OPTIONS: 'Opciones de configuración',
  CONFIGURATION_OPTIONS_CLONE_TEXT: 'Escoge qué opciones de configuración deseas para los nuevos agentes:',
  CONFIGURATION_OPTIONS_UPDATE_TEXT:
    'Escoge qué opciones de configuración deseas copiar para modificar los agentes seleccionados:',
  CLONE_CONFIGURATION: 'Configuración',
  CLONE_AGENT_IN_LENDER_CONTEXT: 'Credenciales en entidades financieras',
  CLONE_PRICINGS: 'Tarifas',
  CLONE_CREATE_USER: 'Crear usuario',
  CLONE_SEND_PASSWORD_RECOVERY: 'Enviar email para generar contraseña',
  CLONE_AGENT_EMAIL_TOOLTIP:
    'A la hora de crear o modificar un agente, se necesita un correo electrónico para validar que no exista ya en la plataforma. No obstante, si no se desea crear un usuario para el agente, se puede marcar esa opción en el siguiente paso. En cualquier caso, el correo electrónico es necesario para la creación o modificación del agente.',
  NEW_AGENTS: 'Nuevos agentes',
  NEW_AGENTS_TEXT: 'Introduce el nombre y email de los nuevos agentes a generar:',
  CREATE_NEW_AGENTS_NUMBER: 'Crear $v1 agentes',
  UPDATE_NEW_AGENTS_NUMBER: 'Modificar $v1 agentes',
  CREATING_NEW_AGENTS: 'Creando nuevos agentes',
  SEE_ERROR_DETAILS: 'Ver mensaje de error',
  CLONE_SUCCESS: 'Creado',
  CLONE_UPDATED: 'Modificado',
  CLONE_ERROR: 'Error',
  SELECT_DESIRED_AGENTS: 'Selecciona los agentes a modificar',

  // CHANNEL

  CHANNEL_ID: 'ID de canal:',
  CHANNEL_TYPE: 'Tipo de canal',
  CHANNEL_DESCRIPTION: 'Descripción del canal',
  CHANNEL_DETAILS: 'Detalles del canal',
  CHANNEL_CONFIGURATION: 'Configuración del canal',
  [ChannelType.APP]: 'App',
  [ChannelType.MARKETPLACE]: 'Marketplace',
  [ChannelType.PHONE]: 'Phone',
  [ChannelType.SOCIAL_MEDIA]: 'Social media',
  [ChannelType.STORE]: 'Tienda física',
  [ChannelType.TPV]: 'TPV',
  [ChannelType.WEB]: 'Web',
  // AGENT

  AGENT_DETAILS: 'Detalle del agente',
  AGENT_ID: 'ID del agente:',
  AGENT_CONFIGURATION: 'Configuración del agente',
  CONFIGURATION: 'Configuración',
  ENABLED: 'Habilitado',
  DISABLED: 'Deshabilitado',
  AGENT_NAME: 'Nombre del agente',
  AGENT_EMAIL: 'Email del agente',
  CUSTOM_THEME: 'Apariencia',
  CUSTOM_REGISTRY: 'Registro',
  CUSTOM_LANGUAGE: 'Idioma',
  COMMUNICATIONS: 'Comunicaciones',
  BANK_READER_ENABLED: 'Agregación bancaria',
  QUOTA_SELECTION_ALLOWED: 'Ajuste de cuota',
  DOCUMENT_REQUIRED_MANAGEMENT: 'Gestor documental',
  CERTIFICATIONS: 'Certificaciones',
  STATUS_ANALYSING_ENABLED: 'Estudio de Riesgos',
  BANK_READER_MAX_ATTEMPTS: 'Máximo número intentos bank reader',
  ALLOWED_ASSET_TYPES: ' Sectores permitidos',
  ALLOWED_PRODUCTS: 'Productos permitidos',
  ALLOWED_ARTICLE_TYPES: 'Artículos permitidos',
  ALLOWED_ONBOARDING_FULFILLED_BY_TYPES: 'Procesos de solicitud permitidos',
  [Product.CONSUMER_LOAN]: 'Préstamo consumo',
  [Product.AUTO]: 'Préstamo auto',
  [Product.CREDIT_LINE]: 'Línea de crédito',
  [CustomLanguage.ENGLISH]: 'Inglés',
  [CustomLanguage.SPANISH]: 'Castellano',
  FINANCIAL_ENTITIES: 'Entidades financieras',
  FINANCIAL_ENTITIES_CREDENTIALS: 'Credenciales en entidades financieras',
  FREE_PROGRAM: 'Programa estándar',
  ZERO_PROGRAM: 'Programa cero',
  FREE_PROGRAM_SHORT: 'Estándar',
  ZERO_PROGRAM_SHORT: 'Cero',
  SLIDE_TO_SEE_ALL_VALUES: 'Desliza para ver todos los valores',
  CREATION: 'Creación',
  CREATED_AT_FOR_TABLE: 'Fecha creación',
  PROGRAM: 'Programa',
  PROGRAMS: 'Program(as)',
  MARKET: 'Mercado',
  OPTIONAL: 'opcional',
  AGENT_IN_LENDER_CONTEXT_ID: 'ID del merchant',
  MERCHANT_ID_IN_LENDER_CONTEXT: 'ID merchant',
  CHANNEL_ID_IN_LENDER_CONTEXT: 'ID canal',
  AGENT_ID_IN_LENDER_CONTEXT: 'ID agente',
  ALLOWED_PURCHASE_COUNTRIES: 'Países de compra permitidos',
  paymentMethodType: 'Método de pago',
  PAYMENT_METHOD_TYPE: 'Método de pago',
  ALLOWED_PAYMENT_METHODS: 'Métodos de pago permitidos',
  ALL_PAYMENT_METHODS: 'Todos los métodos de pago',
  FILTER_BY_PAYMENT_METHOD_AND_OTHERS: 'Filtra las tarifas por los filtros disponibles',
  RELOAD_PRICINGS: 'Volver a cargar tarifas',
  WITH: 'Con',
  WITHOUT: 'Sin',
  WITH_GRACE_PERIOD: 'Con carencia',
  WITHOUT_GRACE_PERIOD: 'Sin carencia',
  WITH_SETUP_FEE: 'Con gastos de apertura',
  WITHOUT_SETUP_FEE: 'Sin gastos de apertura',
  SEARCH_BY_PRICING_NAME: 'Buscar (nombre tarifa)',
  LENDER_NOT_AVAILABLE_WARNING:
    'La entidad $v1 no está disponible para este usuario. Contacta con Nemuru para configurar la posibilidad de trabajar con esta entidad financiera.',

  USERNAME: 'Usuario',
  CLIENT_SECRET_OAUTH_2: 'Client secret (OAuth 2)',
  CLIENT_ID_OAUTH_2: 'Client ID (OAuth 2)',
  HAS_USERNAME_TOOLTIP: 'Las credenciales actuales almacenadas en plataforma contienen un usuario',
  HAS_PASSWORD_TOOLTIP: 'Las credenciales actuales almacenadas en plataforma contienen una contraseña',
  HAS_CLIENT_ID_OAUTH_2_TOOLTIP: 'Las credenciales actuales almacenadas en plataforma contienen un client_id',
  HAS_CLIENT_SECRET_OAUTH_2_TOOLTIP: 'Las credenciales actuales almacenadas en plataforma contienen un client_secret',
  STORED_CREDENTIAL_FIELD_TOOLTIP:
    'Valor almacenado en base de datos. Es necesario introducirlo de nuevo si se modifican las credenciales.',
  STORED_VALUE_LABEL_SUFFIX: 'guardado',

  ADD_CREDENTIALS: 'Añadir credenciales',
  THE_FOLLOWING_CREDENTIALS_WILL_BE_DELETED: 'Se eliminarán las siguientes credenciales:',
  EDIT_CREDENTIALS: 'Editar credenciales',
  DELETE_CREDENTIALS: 'Eliminar credenciales',
  DELETE: 'Eliminar',
  NO_CREDENTIALS_SET: 'Todavía no existen credenciales',
  NO_AGENT_PRICINGS: 'Todavía no se han asignado tarifas',
  MUST_BE_A_NUMERIC_VALUE: 'Este valor tiene que ser numérico',
  AGENT_CREATION_FOR_CHANNEL_X: 'Vas a crear un nuevo agente para el canal $v1',
  CREATE_AGENT: 'Crear agente',
  UPDATE_AGENT: 'Modificar agente',
  ADD_AGENT: 'Añadir agente',
  IS_STATUS_ANALYSING_ENABLED: 'Estudio de Riesgos',
  SELECTED_PRICINGS: 'Tarifas seleccionadas: $v1',
  REMOVE_PRICING_FROM_AGENT: 'Eliminar tarifa del agente',
  REMOVE_PRICING_SPECS: 'Eliminar código de tarifa del lender',
  REMOVE_X_PRICING_SPECS: 'Eliminar $v1 código(s) de tarifa del lender',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT: 'Añadir código de tarifa del lender',
  ADD_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION:
    'Introduce los detalles del nuevo código de tarifa que quieres añadir. Recuerda que cada línea de la tarifa sólo puede tener un código por lender.',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT_DESCRIPTION:
    'Selecciona los códigos de tarifa de las entidades financieras que deseas eliminar. La línea de tarifa seguirá existiendo en la tarifa, pero los lenders cuyo código de tarifa se elimine ya no estarán asociados a esta línea de tarifa.',
  REMOVE_PRICING_SPEC_IN_LENDER_CONTEXT: 'Quitar código de tarifa del lender',
  REMOVE_PRICING_SPEC_FROM_PRICING: 'Eliminar línea de la tarifa',
  REMOVE_PRICING_SPEC_FROM_PRICING_DESCRIPTION:
    '¿Deseas eliminar la siguiente línea de la tarifa? Recuerda que esta acción afectará a todos los merchants que tengan asignada esta tarifa.',
  PRICING_NAME_IN_LENDER_CONTEXT: 'Nombre de código de tarifa',
  PRICING_VERSION: 'Versión',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_PRICING_FROM_AGENT: '¿Deseas eliminar esta tarifa del agente?',
  REMOVE_FROM: 'Eliminar',
  FILL_WITH_CHANNEL_AND_AGENT_DATA: 'Rellenar datos del canal y agente',
  THERE_ARE_NO_CHANNELS_FOUND_BY_SEARCH_PARAMS: 'No se ha encontrado ningún canal en base a los parámetros de búsqueda',
  NO_AGENTS_FOUND_BY_SEARCH_TERM: 'No se ha encontrado ningún agente en base a los parámetros de búsqueda',
  SET_ARTICLE_TYPE: 'Limitar tipo de artículo',
  SET_ARTICLE_TYPE_EXPLANATION: 'Sólo usar si se quiere limitar esta credencial a un tipo de artículo específico',

  //AGENT IN SINGLE PAYMENT PROVIDER CONTEXT
  SET_AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_CONFIGURATION: 'Añadir configuración de credenciales',
  AGENT_IN_LENDER_CONTEXT_TAB_LABEL: 'Pagos financiados',
  AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_TAB_LABEL: 'Pago único',
  PROVIDER_ID_IN_PROVIDER_CONTEXT: 'ID Plataforma pago',
  AGENT_ID_IN_PROVIDER_CONTEXT: 'ID Agente',
  PROVIDER_ID: 'Plataforma de pago',
  PROVIDERS_DETAILS: 'Configuraciones',
  [CredentialsType.AGENT_IN_LENDER_CONTEXT]: 'Credenciales en entidades financieras',
  [CredentialsType.AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT]: 'Credenciales en plataformas de pago',

  // AGENT PRICINGS
  PRICINGS: 'Tarifas',
  ASSIGNED_PRICINGS: 'Tarifas asignadas',
  SEARCH_PRICING: 'Buscar tarifa...',
  ASSIGN_PRICINGS_TO_AGENT: 'Modificar tarifas asignadas',
  UPLOAD_PRICINGS_TO_CDN: 'Subir tarifas al CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG: 'Subir tarifas al CDN',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_TEXT: '¿Deseas subir las tarifas asignadas actualmente a este agente al CDN?',
  UPLOAD_PRICINGS_TO_CDN_DIALOG_BTN: 'Subir',

  PRICINGS_IN_CDN: 'Tarifas subidas al CDN',
  PRICINGS_IN_CDN_STATUS: 'Estado tarifas en el CDN',
  NO_PRICINGS_UPLOADED_TO_CDN: 'No se han subido tarifas al CDN',
  DOWNLOAD_PRICINGS_FROM_CDN: 'Ver tarifas en el CDN',

  CREATE_NEW_PRICING: 'Crear nueva tarifa',
  CREATE_NEW_PRICING_DESCRIPTION:
    'Para poder crear una nueva tarifa, se debe introducir la siguiente información y añadir al menos una línea de tarifa',

  REFRESH_PRICING: 'Actualizar tarifa',
  OPEN_PRICING_EDITOR: 'Abrir editor de tarifa',
  PRICING_EDITOR: 'Editor de tarifa',
  ADD_PRICING_TAG: 'Añadir tag',
  CHANGE_PRICING_NAME: 'Cambiar nombre de la tarifa',
  COPY_PRICING_SPEC_ID: 'Copiar ID línea de tarifa',
  ADD_NEW_PRICING_SPEC: 'Añadir nueva línea a la tarifa',
  ADD_NEW_PRICING_SPEC_BY_ID: 'Añadir nueva línea a la tarifa por ID',
  REMOVE_ALL_PRICING_SPECS_IN_LENDER_CONTEXT: 'Quitar todos los códigos de tarifa del lender',
  PRICING_DOES_NOT_EXIST: 'Tarifa no encontrada',

  minPrincipal: 'Importe mín.',
  maxPrincipal: 'Importe máx.',
  minTerm: 'Plazo mín. (meses)',
  maxTerm: 'Plazo máx. (meses)',
  setupFeeType: 'Tipo',
  setupFeePaymentType: 'Tipo de pago',
  setupFeeValue: 'Valor',
  annualInterest: 'TIN',
  merchantDiscountPercentage: 'Coste merchant (%)',
  merchantFeeType: 'Tipo',
  merchantFeeValue: 'Valor',
  gracePeriod: 'Plazo máx. (meses)',
  gracePercentage: 'Carencia (%)',
  yearsSinceAutoRegistrationMin: 'Fecha matricula mín.',
  yearsSinceAutoRegistrationMax: 'Fecha matricula máx.',
  pricingSpecId: 'ID línea de tarifa',
  PRICING_SPEC_SEARCH_ENABLED: 'Búsqueda de línea de tarifa similar',
  PRICING_SPEC_SEARCH_ENABLED_TOOLTIP:
    'Si la búsqueda de la línea de tarifa está activada (por defecto), al crear una nueva línea, se verificará la existencia de líneas con las mismas características para prevenir duplicados y se asignará a esta tarifa la línea encontrada. Sin embargo, si es necesario crear una línea de tarifa con características idénticas debido a diferencias en el código del lender (por ejemplo), se puede hacer desactivando esta opción.',

  MERCHANT_FEE_COMMISSION: 'Comisión merchant',
  SETUP_FEE_COST: 'Coste cliente',
  INSURANCE: 'Seguro',
  INSURANCES: 'Seguro(s)',
  AVAILABLE_INSURANCES: 'Seguros disponibles',
  NO_AVAILABLE_INSURANCES: 'Sin seguros disponibles',
  REGISTRATION: 'Matriculación',
  YEARS_SINCE_REGISTRATION: 'Años matriculación',
  ANNUAL_INTEREST_AND_DISCOUNT: 'TIN y descuento',

  [`FEE_TYPE_${FeeType.FIX_AMOUNT}`]: 'Importe fijo',
  [`FEE_TYPE_${FeeType.PERCENTAGE}`]: 'Porcentaje',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FINANCED}`]: 'Gasto financiado',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Gasto fijo por cuota',
  [`FEE_PAYMENT_TYPE_${FeePaymentType.TYPE_UPFRONT}`]: 'Gasto de apertura',

  LESS_OPTIONS: 'Menos opciones',
  MORE_OPTIONS: 'Más opciones',
  REQUIRED: 'obligatorio',

  UPLOADED_TO_CDN: 'Subidas al CDN',
  NOT_UPLOADED_TO_CDN: 'No subidas al CDN',

  COPY_PRICING_ID: 'Copiar ID tarifa',
  PRICING_NAME: 'Nombre tarifa',
  RANGE_PRINCIPAL: 'Principal',
  RANGE_PERIOD: 'Plazo',
  LENDERS: 'Entidades',
  TAGS: 'Tags',

  SEE_PRICING_DETAIL: 'Ver detalle de la tarifa',

  [Program.FREE_PROGRAM]: 'Programa estándar',
  [Program.ZERO_PROGRAM]: 'Programa cero',
  [Program.NO_PURCHASE]: 'Sin compra',
  [Program.CAMPAIGN]: 'Campaña',
  NO_PURCHASE_SHORT: 'Sin compra',

  [FeePaymentType.TYPE_UPFRONT]: 'apertura',
  [FeePaymentType.TYPE_FINANCED]: 'financiado',
  [FeePaymentType.TYPE_FIXED_AMOUNT]: '/cuota',

  RANGE_PRINCIPAL_MIN: 'Importe mín.',
  RANGE_PRINCIPAL_MAX: 'Importe máx.',
  RANGE_PERIOD_MIN: 'Plazo mín.',
  RANGE_PERIOD_MAX: 'Plazo máx.',
  ANNUAL_INTEREST: 'Interés',
  EXPENSES: 'Gastos',
  COST_MERCHANT: 'Coste merchant',
  MERCHANT_FEE: 'Comisión',
  GRACE_PERCENTAGE_PERIOD: 'Carencia (meses)',
  LENDER_PRICING_NAME: 'Códigos',
  INSURANCE_AND_FINANCED: 'Seguro (financiado)',

  SEE_SELECTED_PRICINGS: 'Ver seleccionadas',
  SET_PRICINGS_DIALOG: 'Modificar tarifas asignadas',
  SET_PRICINGS_DIALOG_TEXT: 'Resumen de la modificación a realizar:',
  SET_PRICINGS_DIALOG_BTN: 'Modificar',
  UNCHANGED_PRICINGS: 'Tarifas sin cambios',
  PRICINGS_TO_ADD: 'Tarifas nuevas',
  PRICINGS_TO_REMOVE: 'Tarifas eliminadas',

  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_FULFILLED: 'Se han modificado las tarifas asignadas correctamente',
  REQUEST_PATCH_SET_PRICING_IDS_TO_AGENT_REJECTED: 'Ha surgido un problema al intentar modificar las tarifas asignadas',
  EDIT_AGENT_PRICINGS_RANGES: 'Editar límites de tarifas',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG: 'Editar límites de tarifas',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_TEXT: 'Por favor, selecciona los nuevos límites de las tarifas del agente:',
  EDIT_AGENT_PRICINGS_RANGES_DIALOG_BTN: 'Editar límites',
  MIN_PERIOD: 'Plazo mínimo',
  MAX_PERIOD: 'Plazo máximo',
  MIN_PRINCIPAL: 'Importe mínimo',
  MAX_PRINCIPAL: 'Importe máximo',
  [RangeType.PERIOD]: 'Plazo',
  [RangeType.PRINCIPAL]: 'Importe',

  MIN_PERIOD_CANNOT_BE_GREATER_THAN_MAX_PERIOD: 'Plazo mínimo no puede superar el plazo máximo',
  MIN_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_PRINCIPAL: 'Importe mínimo no puede superar el importe máximo',
  MIN_PERIOD_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PERIOD: 'Plazo mínimo no puede ser inferior a $v1',
  MIN_PRINCIPAL_CANNOT_BE_LOWER_THAN_MIN_ALLOWED_PRINCIPAL: 'Importe mínimo no puede ser inferior a $v1',
  MAX_PERIOD_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PERIOD: 'Plazo máximo no puede ser superior a $v1',
  MAX_PRINCIPAL_CANNOT_BE_GREATER_THAN_MAX_ALLOWED_PRINCIPAL: 'Importe máximo no puede ser superior a $v1',
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_FULFILLED: 'Se han modificado correctamente los rangos de las tarifas del agente.',
  REQUEST_PATCH_SET_RANGES_FOR_AGENT_REJECTED:
    'Ha surgido un problema al intentar modificar los rangos de las tarifas del agente',

  // Users
  ADD_USER: 'Añadir credenciales de acceso',
  BLOCK_ALL_USERS: 'Bloquear todas las credenciales',
  COPY_USER_ID: 'Copiar el ID del usuario',
  BLOCK_STATUS: 'Estado',
  BLOCKED: 'Bloqueado',
  UNBLOCKED: 'Habilitado',
  ROLES: 'Roles',
  SEND_FORGOT_PASSWORD_EMAIL: 'Enviar email para generar contraseña',
  CHANGE_ROLES: 'Cambiar roles',
  BLOCK_USER: 'Bloquear credenciales',
  UNBLOCK_USER: 'Habilitar credenciales',
  DO_YOU_WANT_TO_BLOCK_THE_FOLLOWING_USERS: '¿Deseas bloquear las siguientes credenciales?',
  DO_YOU_WANT_TO_BLOCK_THE_USER: '¿Deseas bloquear las credenciales $v1?',
  DO_YOU_WANT_TO_UNBLOCK_THE_USER: '¿Deseas habilitar las credenciales $v1?',
  PASSWORD_RECOVERY_LIST: 'Emails de recuperación de contraseña enviados',
  SEE_PASSWORD_RECOVERY_LIST: 'Ver emails enviados',
  CAN_BE_USED_TO_CHANGE_PASSWORD: 'Utilizable',
  HAS_BEEN_USED: 'Utilizado',
  COPY_EMAIL_ID: 'Copiar id de recuperación de contraseña',
  CHANGE_USER_BY_ID: 'Mover credenciales de usuario por ID',
  CHANGE_USER_BY_ID_TEXT:
    'Introduce el ID del agente, canal o merchant al que quieres mover estas credenciales. Por favor, asegúrate de que el ID es correcto.',
  NEW_USER_ID: 'Nuevo ID de usuario',
  BLOCK: 'Bloquear',
  UNBLOCK: 'Habilitar',
  BLOCK_USERS: 'Bloquear credenciales',
  OLD_PASSWORD: 'Contraseña actual',
  FORGOT_PASSWORD_EMAIL_RECOVERY_WILL_BE_SEND_TO_USER:
    '¿Deseas enviar un correo de recuperación de contraseña al usuario $v1?',
  SEND_EMAIL: 'Enviar correo',
  CHANGING_PASSWORD_FOR_USER: 'Cambio de contraseña de $v1:',
  NO_ACTIONS_AVAILABLE: 'No hay acciones disponibles',
  USER_ROLE: 'Rol de usuario',
  GENERATE_RANDOM_PASSWORD: 'Generar contraseña aleatoria',
  TWO_FACTOR_AUTH: '2FA',
  [UserRowActionType.ADD_TWO_FACTOR_AUTH]: 'Activar verificación en dos pasos (2FA)',
  [UserRowActionType.REMOVE_TWO_FACTOR_AUTH]: 'Desactivar verificación en dos pasos (2FA)',
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    '¿Estás seguro que quieres activar la verificación en dos pasos para el usuario $v1?',
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_DESCRIPTION`]:
    '¿Estás seguro que quieres desactivar la verificación en dos pasos para el usuario $v1?',
  [`${UserRowActionType.ADD_TWO_FACTOR_AUTH}_BUTTON`]: 'Activar',
  [`${UserRowActionType.REMOVE_TWO_FACTOR_AUTH}_BUTTON`]: 'Desactivar',

  SPY_USER: 'Espiar usuario',
  [`SPY_USER_${UserType.AGENT}`]: 'Espiar a este agente',
  [`SPY_USER_${UserType.CHANNEL}`]: 'Espiar a este canal',
  [`SPY_USER_${UserType.MERCHANT}`]: 'Espiar a este merchant',

  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.AGENT}`]:
    '¿Deseas espiar a este agente? Se asignarán unas credenciales especiales que permitirán empersonar a este agente. Deberás utilizar el email: spy@nemuru.com y su contraseña maestra.',
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.CHANNEL}`]:
    '¿Deseas espiar a este canal?  Se asignarán unas credenciales especiales que permitirán empersonar a este canal. Deberás utilizar el email: spy@nemuru.com y su contraseña maestra.',
  [`DO_YOU_WANT_TO_SPY_THIS_USER_${UserType.MERCHANT}`]:
    '¿Deseas espiar a este merchant?  Se asignarán unas credenciales especiales que permitirán empersonar a este merchant. Deberás utilizar el email: spy@nemuru.com y su contraseña maestra.',

  DO_YOU_WANT_TO_SPY_THIS_USER:
    '¿Deseas espiar a $v1? Para empersonar a este usuario deberás utilizar el email: spy@nemuru.com y su contraseña maestra.',

  CHANGE_USER: 'Mover credenciales de usuario',
  CHANGE_USER_BTN: 'Mover credenciales de usuario',
  NO_USERS_FOUND: 'No se han encontrado usuarios',
  SEARCH_FOR_MERCHANT_CHANNEL_AGENT_NAME: 'Buscar nombre o id de Merchant, Canal o Agente...',
  CONFIRM_CHANGE_TEXT: '¿Deseas realizar el siguiente cambio de usuario?',
  SELECTED_USER: 'Usuario seleccionado',
  SELECT_WHERE_TO_MOVE: 'Selecciona dónde quieres moverlo',
  CONFIRM_CHANGE: 'Confirmar cambio de usuario',
  CONFIRM_CHANGE_BTN: 'Confirmar',
  YOU_WILL_CHANGE_THE_FOLLOWING_USER: 'Vas a cambiar el siguiente usuario:',

  //Loan detail view
  LOAN_ID: 'ID de la solicitud:',
  LOAN_OVERVIEW: 'Resumen',
  PURCHASE_COUNTRY_TITLE: 'País de compra:',
  [PurchaseCountry.ESP]: 'España',
  [PurchaseCountry.FRA]: 'Francia',
  [PurchaseCountry.MEX]: 'Mexico',
  [PurchaseCountry.BRA]: 'Brasil',
  [PurchaseCountry.ZAF]: 'Sudáfrica',
  [PurchaseCountry.PRT]: 'Portugal',
  [PurchaseCountry.DEU]: 'Alemania',
  APPLICATION: 'Solicitud',
  CONSUMER_LOAN: 'Préstamo consumo',
  PERSONAL_FINANCE: 'Información financiera',
  CONTENTS: 'Contenido',
  ALERTS: 'Alertas',
  USERS: 'Usuarios',
  USERS_OF: 'Usuarios de $v1',
  USER_CREDENTIALS: 'Credenciales de acceso',
  [`USER_CREDENTIALS_${UserType.AGENT}`]: 'Credenciales del agente',
  [`USER_CREDENTIALS_${UserType.CHANNEL}`]: 'Credenciales del canal',
  [`USER_CREDENTIALS_${UserType.MERCHANT}`]: 'Credenciales del merchant',
  ACCOUNT: 'Cuenta',
  FUNNEL: 'Funnel',
  MERCHANT_CHANNEL_AGENT_POS: 'Punto de venta',
  PARTICIPANTS: 'Cotitulares',
  ADD_PARTICIPANT: 'Añadir cotitular',
  BORROWER: 'Titular',
  CO_BORROWER: 'Cotitular',
  GUARANTOR: 'Avalista',
  [OnboardingDetailsRole.BORROWER]: 'Titular',
  [OnboardingDetailsRole.CO_BORROWER]: 'Cotitular',
  [OnboardingDetailsRole.GUARANTOR]: 'Avalista',
  PROGRESS: 'Progreso',
  X_DAYS_LEFT: '$v1 days left',
  X_MONTHS: '$v1 meses',
  MONTHS: 'meses',
  SHOW_MORE: 'Mostrar',
  SHOW_LESS: 'Ocultar',
  DESCRIPTION: 'Descripción',
  ADDRESS: 'Dirección',
  INTEREST: 'Interés',
  TOTAL_COST: 'Coste total',
  TOTAL_COST_WITH_UPFRONT_PERCENTAGE: 'Coste total ($v1 gastos apertura)',
  TOTAL_COST_WITH_FINANCED_PERCENTAGE: 'Coste total ($v1 financiado)',
  TOTAL_COST_WITH_FIXED_AMOUNT_VALUE: 'Coste total ($v1 por cuota)',
  INTERESTS_TO_PAY: 'Total intereses',
  TIN: 'TIN',
  TAE: 'TAE',
  PRODUCT: 'Producto',
  TERM: 'Plazo',
  MONTHLY_QUOTA: 'Cuota mensual',
  DOWN_PAYMENT: 'Entrada',
  CASH_PRICE: 'Precio contado',
  TOTAL_DISCOUNT: 'Descuento',
  DISCOUNT: 'Descuento ($v1)',
  MERCHANT_TOTAL_TO_COLLECT: 'Total a cobrar',
  PRINCIPAL_AMOUNT: 'Importe del préstamo',
  TOTAL_AMOUNT_TO_PAY: 'Total a pagar',
  CREDIT_LINE_AMOUNT: 'Importe de la línea de crédito',
  CREDIT_LINE: 'Línea de credito',
  CREDIT_LINE_WITH_PURCHASE: 'Alta con compra',
  WITH_ANNUAL_INTERESTS: 'Con intereses',
  NO_ANNUAL_INTERESTS: 'Sin intereses',
  SETUP_FEE: 'Gastos de apertura',
  SPLIT_PAY: 'Fracciona el pago',
  INSTALMENTS: 'Paga en cuotas',
  COPY_LOAN_ID: 'Copiar ID préstamo',
  COPY_CONSUMER_LOAN_ID: 'Copiar ID préstamo',
  COPY_AUTO_ID: 'Copiar ID préstamo auto',
  COPY_CREDIT_LINE_ID: 'Copiar ID línea de crédito',
  COPY_ORDER_ID: 'Copiar ID del pedido',
  COPY_ARTICLE_ID: 'Copiar ID artículo',
  ID_COPIED_SUCCESSFULLY: 'ID copiado con éxito',
  COPY_SUCCESSFUL: 'Copiado en portapapeles',
  COPY_LENDER_REQUEST_ID: 'Copiar ID solicitud entidad financiera',
  FILE_NOT_FOUND: 'Fichero no encontrado',
  RESPONSE: 'Respuesta',
  DESIST: 'Desistir',
  DESIST_LOAN: 'Desistir la solicitud',
  DESIST_LOAN_BTN: 'Desistir',
  REFUND: 'Realizar devolución',
  CANCEL_TEST: 'Cancelar como prueba',
  CANCEL_TEST_BTN: 'Cancelar como prueba',
  CANCEL_LOAN: 'Cancelar solicitud',
  CANCEL_LOAN_BTN: 'Cancelar solicitud',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED: '¿Deseas marcar esta solucitud como cancelada?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_CANCELLED_TEST: '¿Deseas marcar esta solucitud como prueba cancelada?',
  DO_YOU_WISH_TO_SET_THIS_LOAN_STATUS_AS_STATUS_DESISTED: '¿Deseas marcar esta solucitud como desistida?',
  PLEASE_SELECT_THE_REASON_WHY_YOU_ARE_DESISTING_THIS_LOAN:
    'Por favor, selecciona el motivo de abandono de esta solicitud.',
  DESIST_REASON: 'Motivo de abandono',
  RESEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Reenviar contrato para firmar',
  ARE_YOU_SURE_YOU_WANT_TO_RESEND_CONTRACT_SIGNATURE_TO_BORROWER:
    '¿Deseas reenviar el contrato para firmar al titular?',
  RESEND_CONTRACT: 'Reenviar contrato',
  SEND_CONTRACT: 'Enviar contrato para firmar',
  SEND_CONTRACT_SIGNATURE_TO_BORROWER: 'Enviar contrato para firmar',
  ARE_YOU_SURE_YOU_WANT_TO_SEND_CONTRACT_SIGNATURE_TO_BORROWER: '¿Deseas enviar el contrato para firmar al titular?',
  SET_CONTRACT_SIGNED: 'Marcar contrato como firmado',
  ARE_YOU_SURE_YOU_WANT_TO_SET_LOAN_LENDER_BORROWER_CONTRACT_TO_SIGNED:
    '¿Deseas marcar el contrato de esta solicitud como firmado?',
  SET_CONTRACT_SIGNED_BUTTON: 'Marcar como firmado',
  FORMALIZE_APPLICATION: 'Formalizar solicitud',
  DO_YOU_WISH_TO_FORMALIZED_THIS_APPLICATION: '¿Deseas marcar esta solicitud como formalizada?',
  FORMALIZE_APPLICATION_BTN: 'Formalizar solicitud',
  MARK_LOAN_AS_PAID: 'Marcar solicitud como pagada',
  DO_YOU_WISH_TO_MARK_THIS_LOAN_AS_PAID: '¿Deseas marcar esta solicitud como pagada?',
  MARK_LOAN_AS_PAID_BTN: 'Marcar como pagada',
  GRACE_PERIOD: 'Carencia',
  OPT_OUT_NOTIFICATIONS: 'Desactivar notificaciones',
  OPT_OUT_NOTIFICATIONS_DESCRIPTION: '¿Deseas desactivar las notificaciones para $v1?',
  OPT_OUT_NOTIFICATIONS_BTN: 'Desactivar',

  [LoanDesistReason.BANK_READER]: 'Bank Reader',
  [LoanDesistReason.DO_NOT_TRUST_IN_NEMURU]: 'Nemuru no me da confianza',
  [LoanDesistReason.NO_FINANCING_WANTED]: 'No quiero financiación',
  [LoanDesistReason.MERCHANT_SERVICE_IS_EXPENSIVE]: 'Servicio del merchant es caro',
  [LoanDesistReason.NEMURU_IS_EXPENSIVE]: 'Nemuru es caro',
  [LoanDesistReason.DO_NOT_WANT_THE_SERVICE]: 'No quiero el servicio del merchant',
  [LoanDesistReason.NEMURU_APP_IS_NOT_WORKING]: 'El app de Nemuru no funciona',
  [LoanDesistReason.NEMURU_PROCESS_IS_COMPLICATED]: 'El proceso de Nemuru es complicado',
  [LoanDesistReason.ALTERNATIVE_FINANCIAL_INSTITUTION]: 'Financiaré con otra entidad',
  [LoanDesistReason.WILL_DO_IT_LATER]: 'Lo haré después',
  [LoanDesistReason.WILL_DO_IT_WITH_ANOTHER_MERCHANT]: 'Lo llevaré a cabo con otro merchant',
  [LoanDesistReason.NOT_CONTACTABLE]: 'No contactable',
  [LoanDesistReason.CANNOT_AFFORD]: 'No puedo permitirme hacer el servicio',
  [LoanDesistReason.LOAN_CONTRACT_TERMS]: 'Cláusulas legales',
  [LoanDesistReason.MERCHANT_BAD_SERVICE]: 'Mal servicio del merchant',
  [LoanDesistReason.MERCHANT_CURN_BEHAVIOUR]: 'Merchant expulsado',
  [LoanDesistReason.WRONG_BUDGET_MANAGEMENT]: 'Presupuesto mal gestionado',
  [LoanDesistReason.LENDER_PROCEDURES]: 'Tramitación del lender',
  [LoanDesistReason.OTP_NOT_RECEIVED]: 'No he recibido el código vía SMS',
  [LoanDesistReason.SCA_ERROR]: 'La pantalla se queda en blanco después de introducir los datos de mi tarjeta',
  [LoanDesistReason.ORDER_CONFIRMATION_NOT_COMPLETED]:
    'He autorizado la compra con la aplicación de mi banco, pero no la pude completar',
  [LoanDesistReason.DO_NOT_UNDERSTAND_FUTURE_PAYMENTS]: 'No entiendo como se cobrarán los pagos futuros',
  [LoanDesistReason.UNKNOWN]: 'Sin motivo',

  //Order detail view
  ORDER_OVERVIEW: 'Detalle del pedido',
  MERCHANT_REFERENCE_1: 'Referencia #1 merchant',
  REFERENCE_1: 'Referencia #1:',
  CREATED_AT: 'Fecha creación:',
  CLIENT_CONTACT_EMAIL: 'Email del cliente:',
  UNITS: 'Unidades',
  UNIT_PRICE_WITH_TAX: 'Precio (incl. IVA)',
  AMOUNT_WITH_TAX: 'Total (incl. IVA)',
  SEE_DETAIL: 'Ver detalle',
  REFERENCE: 'Referencia',
  ARTICLE: 'Artículo',
  FLIGHT: 'Vuelo',
  ONLINE_PRODUCT: 'Producto',
  SERVICE: 'Servicio',
  ACCOMMODATION: 'Hotel',
  TRAVEL: 'Viaje',
  TRAVEL_CATEGORY: 'Categoría de viaje',
  DESTINATION: 'Destino',
  START_DATE: 'Fecha inicio',
  END_DATE: 'Fecha fin',
  TRAVELLERS: 'Número de viajeros',
  CARRIER_CODE: 'Código compañia',
  FLIGHT_CODE: 'Número de vuelo',
  CABIN_CLASS: 'Clase',
  FARE_BASIS: 'Tarifa',
  ORDER_LINES: 'Líneas del carrito',
  REFERENCES: 'Referencias',
  MERCHANT_ORDER_REFERENCE_1: 'Referencia 1',
  MERCHANT_ORDER_REFERENCE_2: 'Referencia 2',
  SERVICE_END_DATE: 'Fecha fin servicio',
  SUMMARY: 'Resumen',
  CAPTURES_AND_REFUNDS: 'Capturas y devoluciones',
  TRANSACTION_HISTORY: 'Historial de transacciones',
  DETAILS: 'Detalles',
  PROCESSING: 'Procesando',
  PROCESSING_WITH_DOTS: 'Procesando...',
  CONTINUE: 'Continuar',
  CONTINUE_BY: 'Continuar por $v1',
  NO_CART_INFORMATION_AVAILABLE: 'No existe información de carrito disponible',
  NO_ACTIVITY_INFORMATION_AVAILABLE: 'No existe información de actividad disponible',
  CHECK_IN_DATE: 'Fecha de entrada',
  CHECK_OUT_DATE: 'Fecha de salida',
  NUMBER_OF_GUESTS: 'Número de huéspedes',
  LAST_CARTS: 'Últimos carritos',
  LAST_THREE_DAYS: 'Últimos 3 días',
  LAST_TWO_WEEKS: 'Últimas 2 semanas',
  REMOVE_CART: 'Eliminar carrito',
  REMOVE_CART_DESCRIPTION: '¿Estás seguro de que quieres eliminar este carrito con los siguiente items?',

  //PAY_BY_LINK
  PAY_BY_LINK_DETAIL: 'Detalle del pedido',

  //Payment method
  PAYMENT_METHOD: 'Método de pago',
  PAYMENT_ATTEMPTS: 'Pago con tarjeta',
  PAYMENT_ATTEMPT_STATUS: 'Evento',
  PAYMENT_ATTEMPT_FAIL_REASON: 'Motivo de rechazo',
  PAYMENT_ATTEMPT_CREATED_AT: 'Fecha',
  [PaymentAttemptStatus.PAYMENT_SUCCESSFUL]: 'Pago aceptado',
  [PaymentAttemptStatus.PAYMENT_FAILED]: 'Pago rechazado',
  [PaymentAttemptStatus.SCA_LOADED]: 'Apertura SCA',
  [PaymentAttemptStatus.SCA_CLOSED]: 'Cierre SCA',
  [PaymentAttemptStatus.PAYMENT_CANCELLED]: 'Pago cancelado',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.AUTHENTICATION}`]: 'Hubo un problema en el paso de SCA',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE}`]: 'No se pudo realizar el cargo',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.GENERIC}`]: 'Ocurrió algún otro error',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.SERVICE_PROCESSING}`]:
    'La autorización o tokenización no fue posible',
  [`PAYMENT_ATTEMPT_FAIL_REASON_${PaymentAttemptFailReason.USE_A_DIFFERENT_CARD}`]:
    'Existe algún problema con la tarjeta',
  CASH_IN_CASH_OUT_METHOD_TYPE: 'Tipo de método de pago',
  [CashInCashOutType.BANK_ACCOUNT]: 'Cuenta corriente',
  [CashInCashOutType.SAVING_BANK_ACCOUNT]: 'Cuenta ahorros',
  [CashInCashOutType.FLYWIRE]: 'Flywire',
  HOLDER: 'Titular',
  ACCOUNT_HOLDER_FIRST_NAME: 'Nombre',
  ACCOUNT_HOLDER_FIRST_LAST_NAME: 'Primer apellido',
  ACCOUNT_HOLDER_SECOND_LAST_NAME: 'Segundo apellido',
  ACCOUNT_HOLDER_PARTICIPATION_LEVEL: 'Tipo de intervininente',
  [`${AccountParticipationLevel.OWNER}_OPTION`]: 'Titular',
  [`${AccountParticipationLevel.CO_OWNER}_OPTION`]: 'Cotitular',
  [`${AccountParticipationLevel.OTHER}_OPTION`]: 'Otro',
  [`${AccountParticipationLevel.PARTICIPATED}_OPTION`]: 'Participante',
  [`${AccountParticipationLevel.UNKNOWN}_OPTION`]: 'Desconocido',
  [PaymentMethodType.A2A_PAYMENT]: 'Transferencia bancaria inmediata',
  [PaymentMethodType.B2B_LOAN]: 'Préstamo B2B',
  [PaymentMethodType.BNPL_INSTALMENTS]: 'Pago en cuotas',
  [PaymentMethodType.BNPL_SPLIT_PAY]: 'Fracciona el pago',
  [PaymentMethodType.CONSUMER_LOAN_INSTALMENTS]: 'Financiación',
  [PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY]: 'Financiación sin intereses',
  [PaymentMethodType.CARD_PAYMENT]: 'Pago con tarjeta',
  [PaymentMethodType.SUBSCRIPTION]: 'Suscripción',
  [PaymentMethodType.CREDIT_CARD]: 'Tarjeta de crédito',
  [PaymentMethodType.CARD_ONBOARDING]: 'Tarjeta de crédito',

  // [PaymentMethodType.AUTO_LOAN]: 'Préstamo auto',   // Same as Product.AUTO
  // [PaymentMethodType.CREDIT_LINE]: 'Línea de crédito',     // Same as Product.CREDIT_LINE

  [`${PaymentMethodType.A2A_PAYMENT}_SHORT`]: 'Transferencia inmediata',
  [`${PaymentMethodType.B2B_LOAN}_SHORT`]: 'Préstamo B2B',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_SHORT`]: 'Pago en cuotas',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_SHORT`]: 'Fracciona el pago',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_SHORT`]: 'Financiación',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_SHORT`]: 'Financiación sin intereses',
  [`${PaymentMethodType.CARD_PAYMENT}_SHORT`]: 'Pago con tarjeta',
  [`${PaymentMethodType.SUBSCRIPTION}_SHORT`]: 'Suscripción',
  [`${PaymentMethodType.AUTO_LOAN}_SHORT`]: 'Préstamo auto',
  [`${PaymentMethodType.CREDIT_LINE}_SHORT`]: 'Línea de crédito',
  [`${PaymentMethodType.CREDIT_CARD}_SHORT`]: 'Tarjeta de crédito',
  [`${PaymentMethodType.CARD_ONBOARDING}_SHORT`]: 'Tarjeta de crédito',

  [OperativeType.STANDARD]: 'Operación estándar',
  [OperativeType.NO_PAYROLL]: 'Operación sin nómina',

  PAYMENT_METHODS: 'Métodos de pago',
  PER_MONTH: '/mes',

  //Payment plan
  PAYMENT_PLAN: 'Plan de pagos',
  PAYMENT_PLAN_TABLE: 'Cuotas',
  DUE_DATE: 'Fecha vencimiento',
  PAYMENT_DATE: 'Fecha pago',
  OVERDUE: 'Vencido',
  PAYMENT_PLAN_LINE_ID: 'ID cuota',
  PAYMENT_PROVIDER: 'Método de pago',
  PAYMENT_PLAN_STATUS: 'Estado plan de pagos',
  [PaymentProvider.DIRECT_DEBIT]: 'Domiciliación bancaria',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PENDING}`]: 'Pendiente',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PROCESSING}`]: 'Pago iniciado',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.PAID}`]: 'Pagado',
  [`PAYMENT_PLAN_LINE_${PaymentPlanLineStatus.CANCELLED}`]: 'Cancelado',
  [`PAYMENT_PLAN_LINE_${OverduePlanLineStatus.OVERDUE}`]: 'Vencido',
  NO_PAYMENT_PLAN_AVAILABLE: 'No existe plan de pagos para esta solicitud',
  NO_PAYMENT_ATTEMPTS_REGISTERED: 'No hay intentos de pago registrados',
  ROWS_PER_PAGE: 'Filas por página',
  SENT_DATE: 'Fecha solicitud pago',
  COPY_PAYMENT_LINE_ID: 'Copiar ID de la cuota',
  SEND_PAYMENT_NOTIFICATION: 'Enviar email de solicitud de pago',
  PAYMENT_NOTIFICATION: 'Enviar email de solicitud de pago',
  PAYMENT_NOTIFICATION_TEXT: '¿Deseas enviar un email para solicitar el pago de esta cuota al cliente?',
  PAYMENT_NOTIFICATION_BTN: 'Enviar email',
  QUOTA_NUMBER: 'Número de cuota',
  SEE_PAYMENT_ATTEMPTS: 'Ver intentos de pago',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE: 'Cambiar fecha de vencimiento',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_TEXT: 'Selecciona la nueva fecha de vencimiento de la cuota',
  UPDATE_PAYMENT_PLAN_LINE_DUE_DATE_BTN: 'Cambiar fecha',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE: 'Cambiar fecha de pago',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_TEXT: 'Selecciona la nueva fecha de pago de la cuota',
  UPDATE_PAYMENT_PLAN_LINE_PAYMENT_DATE_BTN: 'Cambiar fecha',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT: 'Cambiar importe',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_TEXT: 'Introduce el nuevo importe de la cuota',
  UPDATE_PAYMENT_PLAN_LINE_QUOTA_AMOUNT_BTN: 'Cambiar importe',
  UPDATE_PAYMENT_PLAN_LINE_STATUS: 'Cambiar estado',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_TEXT: 'Selecciona el nuevo estado de la cuota',
  UPDATE_PAYMENT_PLAN_LINE_STATUS_BTN: 'Cambiar estado',
  PAYMENT_LINE_STATUS: 'Estado de cuota',

  //Activity
  TOTAL_ORDER: 'Total del pedido',
  PENDING_CAPTURE: 'Pendiente capturar️',
  PENDING_TO_CAPTURE: 'Pendiente capturar️',
  TOTAL_CAPTURED: 'Total capturado',
  TOTAL_REFUNDED: 'Total devoluciones',
  BILLED: 'Facturado',
  TOTAL_FEES: 'Total comisiones',
  TOTAL_PAID: 'Total pagado',
  PENDING: 'Pendiente',
  PENDING_INFORMATION: 'Pendiente...',
  AMOUNT: 'Importe',
  TOTAL: 'Total️',
  CAPTURED: 'Capturado',
  CAPTURE: 'Captura',
  ORDER_APPROVED: 'Aprobado',
  APPROVED: 'Preaprobado',
  REFUNDED: 'Devuelto',
  PRODUCTS: 'Productos️',
  SALE: 'Venta',
  ORDER_ACTIVITY: 'Actividad',
  REFUNDED_AMOUNT: 'Importe reembolsado',
  CAPTURE_NUMBER: 'Captura nº $v1',
  REFUND_NUMBER: 'Devolución nº $v1',
  PAYOUT_NUMBER: 'Pago nº $v1',
  ORDER_CREATED: 'Pedido creado',
  REFERENCE_1_TOOLTIP_TEXT: 'Referencia principal del pedido del merchant',
  REFERENCE_2_TOOLTIP_TEXT: 'Referencia opcional del pedido del merchant',
  PASSENGERS: 'Pasajeros ($v1)',
  SEGMENTS: 'Tramos ($v1)',
  IN_REFERENCE_TO: 'En referencia a:',
  CANCEL_PAYMENT_PLAN: 'Cancelar plan de pagos',
  CANCEL_PAYMENT_PLAN_TEXT: '¿Estás seguro que deseas cancelar el plan de pagos?',

  //PAYOUTS
  PAYMENTS: 'Pagos',
  PAYOUT: 'Pago',
  PAYOUTS: 'Pagos',
  PAYER: 'Pagador',
  issue_date: 'Fecha emisión',
  VAT_ON_FEES: 'IVA sobre comisiones ($v1)',
  VAT_ON_ADJUSTMENTS: 'IVA sobre ajustes ($v1)',
  PAYOUTS_LIST: 'Listado de pagos',
  MERCHANT_ID: 'ID del merchant',
  ADJUSTMENTS_AMOUNT: 'Importe ajustes',
  DISBURSED_AMOUNT: 'Importe pagado',
  PAYOUT_STATUS: 'Estados del pago',
  [PayoutStatus.DISBURSED]: 'Pagado',
  [PayoutStatus.IN_REVIEW]: 'En revisión',
  [PayoutStatus.PUBLISHING]: 'Publicando',
  [PayoutStatus.PUBLISHED]: 'Publicado',
  PAYMENT: 'Pago',
  PAYOUT_DETAILS_OVERVIEW: 'Resumen',
  TRANSACTIONS: 'Cantidad',
  TRANSACTIONS_VIEW: 'Transacciones',
  SALES: 'Ventas',
  REFUNDS: 'Devoluciones',
  FIXED_FEES: 'Comisiones fijas',
  VARIABLE_FEES: 'Comisiones variables',
  ADJUSTMENTS: 'Ajustes',
  TOTAL_ADJUSTMENTS: 'Total ajustes',
  LENDER_NAME: 'Nombre entidad financiera',
  PAYOUT_REFERENCE: 'Referencia pago',
  PAYOUT_DATE: 'Fecha pago',
  MERCHANT_NAME: 'Nombre merchant',
  VAT: 'IVA',
  COPY_PAYMENT_ID: 'Copiar ID de pago',
  COPY_PAYOUT_ID: 'Copiar ID de pago',
  PAYOUT_DETAILS_NOT_FOUND: 'No se han encontrado detalles del pago',

  //REPORTS

  REPORTS: 'Conciliaciones',
  REPORTS_LIST: 'Listado de conciliaciones',
  REPORT: 'Conciliación',
  REPORT_DATE: 'Fecha conciliación',
  REPORT_DETAILS_OVERVIEW: 'Resumen',
  ENTITY: 'Entidad',
  BATCH_NUMBER: 'Núm. batch',
  DOWNLOAD: 'Descargar',
  TOTAL_DISBURSED_AMOUNT: 'Importe total pagado',
  COPY_REPORT_ID: 'Copiar ID conciliación',

  //TRANSACTIONS
  TRANSACTIONS_LIST: 'Listado de transacciones',
  TRANSACTION_TYPE: 'Tipo de transacción',
  VAT_RATE: 'IVA',
  VAT_AMOUNT: 'Importe IVA',
  COPY_TRANSACTION_ID: 'Copiar ID de transacción',
  ORDER_ID: 'ID del pedido',
  [TransactionType.REFUND]: 'Devolución',
  [TransactionType.DEBT_BALANCE]: 'Saldo de deuda',
  [TransactionType.FIXED_FEE]: 'Comisión fija',
  [TransactionType.VARIABLE_FEE]: 'Comisión variable',
  [TransactionType.COST_OF_CREDIT]: 'Cuota de crédito',
  [TransactionType.FEE_CORRECTION]: 'Ajuste de comisión',

  //LENDER LOAN APPLICATIONS
  LENDER_APPLICATIONS: 'Respuestas de entidades financieras',
  LENDER_X_APPLICATION: 'Respuesta de $v1',
  LENDER_STATE: 'Estado de la entidad financiera',
  LENDER_CONTRACT_SENT: 'Contrato enviado',
  LENDER_CONTRACT_SIGNED: 'Contrato firmado',
  SENT_AT: 'Fecha de envío de contrato',
  SIGNED_AT: 'Fecha de firma de contrato',
  LENDER_REQUEST_ID: 'ID solicitud',
  LENDER_REQUEST_ID_2: 'ID entidad',
  LAST_UPDATED_AT: 'Fecha última actualización',
  PROCESSING_SUCCESSFUL: 'Procesado correctamente',
  PROCESSING_DID_NOT_ALTER_APPLICATION: 'El resultado no alteró esta solicitud',
  PROCESSING_DID_UPDATE_THE_APPLICATION_SUCCESSFULLY: 'La solicitud se actualizó.',
  PROCESS: 'Procesar',
  SELECTED_LENDER: 'Entidad seleccionada',
  NO_RESPONSE_FROM_LENDER: 'Sin respuesta de la entidad.',
  LENDER_IS_PROCESSING_THE_APPLICATION: 'La entidad está procesando la solicitud',
  LENDER_IS_PROCESSING_THE_APPLICATION_TRY_AGAIN_LATER:
    'La entidad está procesando la solicitud en estos momentos. Este proceso puede tardar algunos minutos. Refresca esta página en unos instantes para ver el estado actualizado o vuelve a reprocesar la solicitud.',
  SELECTED_LENDER_APPLICATION: 'Seleccionada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.NOT_PROCESSED}`]: 'No procesada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.PROCESSED}`]: 'Procesada',
  [`LOAN_APPLICATION_STATUS_${LoanApplicationStatus.SELECTED}`]: 'Seleccionada',
  PENDING_TO_COMPLETE_PAYMENT: 'Pendiente completar',
  PENDING_TO_SELECT_PAYMENT_METHOD: 'Pendiente método de pago',
  NO_RESPONSE: 'Sin respuesta',
  ANSWERED_YES: 'Aceptada',
  ANSWERED_NO: 'Denegada',
  IN_STUDY: 'En estudio',
  SELECT_A_LOAN_APPLICATION: 'Selecciona una entidad',
  SELECT_A_LOAN_APPLICATION_TEXT:
    'Haz click en el botón para seleccionar la entidad financiera y completar el proceso de solicitud.',
  LENDER_X_ANSWERED_X_TO_APPLICATION: 'La entidad financiera $v1 ha respondido "$v2" a la solicitud',
  PROCESS_TOOLTIP: 'Procesar manualmente la solicitud en la entidad financiera',
  loan_application_error: 'Error entidad financiera',
  UN_SIGN: 'Anular',
  MODIFY: 'Modificar',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT: 'Anular firma de contrato',
  UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_DESCRIPTION:
    '¿Deseas anular la firma del contrato existente? La solicitud volverá al estado anterior y los datos de envío y firma del contrato serán eliminados.',
  OPEN_PROCESS_RESPONSE_FOLDER: 'Abrir ficheros de respuesta',
  SET_LENDER_REQUEST_ID: 'Modificar ID solicitud',
  SET_LENDER_REQUEST_ID_DESCRIPTION:
    '¿Deseas modificar el ID de la solicitud en la entidad financiera? Al modificar el ID, se volverán a procesar los datos de la solicitud para este nuevo ID',
  CHANGE_LENDER_APPROVAL_STATUS: 'Modificar estado de aprobación',
  CHANGE_LENDER_APPROVAL_STATUS_DESCRIPTION: 'Selecciona el nuevo estado de aprobación de la entidad financiera',
  LENDER_APPROVAL_STATUS: 'Estado de aprobación de la entidad financiera',
  [LenderApprovalStatus.MAYBE]: 'En estudio',
  UPDATE_LOAN_APPLICATION: 'Modificar',
  UPDATE_LOAN_APPLICATION_IN_LENDER: 'Modificar cotitular en entidad',
  UPDATE_LOAN_APPLICATION_IN_LENDER_DESCRIPTION:
    '¿Deseas modificar los datos del/de los cotitular(es) de la solicitud en la entidad financiera?',
  SELECTED_LOAN_APPLICATION: 'Solicitud seleccionada',
  ERROR_FETCHING_ERROR_RESPONSE:
    'Error al obtener la respuesta de la entidad financiera. Por favor, inténtalo más tarde.',
  ANALYSING_ERROR_RESPONSE: 'Analizando error en $v1...',

  [LenderName.ABANCA]: 'Abanca',
  [LenderName.APLAZAME]: 'Aplazame',
  [LenderName.ATRATO]: 'Atrato',
  [LenderName.BBVA]: 'BBVA Consumer Finance',
  [LenderName.BS]: 'Sabadell Consumer Finance',
  [LenderName.CAIXABANK]: 'CaixaBank P&C',
  [LenderName.CETELEM]: 'Cetelem',
  [LenderName.COFIDIS]: 'Cofidis',
  [LenderName.FINONLINE]: 'Finonline',
  [LenderName.FLOA]: 'FLOA',
  [LenderName.KOIN]: 'Koin',
  [LenderName.KUESKI]: 'Kueski',
  [LenderName.NEMURU]: 'Nemuru finance',
  [LenderName.PEPPER]: 'Pepper',
  [LenderName.SANTANDER_CONSUMER]: 'Santander Consumer Finance',
  [LenderName.SEQURA]: 'SeQura',
  [LenderName.SEQURA_QUIX]: 'Quix',
  [LenderName.SOYOU]: 'Sofinco',

  RISK_ANALYSIS: 'Análisis de riesgo',
  ASSESSMENT_RESULT: 'Recomendación',
  UNPAID_OPERATIONS: 'Operaciones impagadas',
  NO_RISK_SCORING_AVAILABLE: 'No existe un análisis de riesgo disponible',
  WHAT_IS_RECOMMENDATION: (
    <>
      <p>
        Resultado de la evaluación de riesgo del cliente a partir de las reglas establecidas. Puede tomar los siguientes
        valores:
      </p>
      <li>Verde: Análisis favorable, cliente con un buen perfil de riesgo.</li>
      <li>Amarillo: A revisar, cliente con un mal perfil de riesgo pero sin impagos.</li>
      <li>Rojo: Análisis desfavorable, cliente con un mal perfil de riesgo y con impagos.</li>
    </>
  ),
  WHAT_IS_SCORING: (
    <>
      <p>Indica el nivel de riesgo de impago del cliente. Puede tomar los siguientes valores:</p>
      <ul>
        <li>Muy Alto Riesgo (1)</li>
        <li>Alto Riesgo (2)</li>
        <li>Medio Riesgo (3)</li>
        <li>Medio/Bajo Riesgo (4)</li>
        <li>Bajo Riesgo (5)</li>
        <li>Muy Bajo Riesgo (6)</li>
      </ul>
    </>
  ),

  RISK_ASSESSMENT_FAILED_DUE_TO_THE_FOLLOWING_REASONS: ' no ha sido superado por los siguientes motivos:',
  RESULTS: 'Resultados',
  NO_RISK_INFORMATION: 'No se ha encontrado información de riesgos',
  NO_REASONS_GIVEN: 'No se han encontrado motivos',
  RISK_SCORE: 'Análisis de riesgos',
  PASSED: 'Aprobado',
  RISK_SCORE_FAILED: 'Rechazado',
  AML_RISK: 'AML',
  BANK_READER_RISK: 'Bank reader',
  CHECK_FAILED_REASONS: 'Ver motivos de rechazo',
  ASSESSMENT_FAILURE_REASONS: 'Motivos de rechazo de análisis de riesgos',
  aml_reject_FoundInLists: 'El cliente figura en las listas AML',
  br_reject_lifestyle_indebtedness: 'Endeudamiento por estilo de vida',
  br_reject_lowPositiveBalanceLastMonth: 'Baja puntuación por saldo positivo el último mes.',
  br_reject_lowPositiveBalanceAntiquity: 'Baja puntuación por antigüedad de saldo positivo.',
  br_reject_lastMontsIncomingStatementLessThan3: 'Menos de 3 ingresos.',

  // STATUS back
  status_initial: 'Iniciado',
  status_analysing: 'Solicitado',
  status_lender_has_been_selected: 'Preaprobado',
  status_contract_signed: 'Firmado por formalizar',
  status_docs_approved: 'Confirmado',
  status_active_trial: 'Pagado',
  status_active: 'Pagado',
  status_denied: 'Denegado',
  status_desisted: 'Desistido',
  status_ended: 'Finalizado',
  status_expired: 'Caducado',
  status_unpaid: 'Inpagado',
  status_cancelled: 'Cancelado',
  status_cancelled_test: 'Test cancelado',

  //FUNNEL
  TOTAL_AMOUNT: 'Importe total',
  TOTAL_NUMBER: 'Número total',
  SEARCH_BY_LENDER: 'Entidad financiera',
  MINIMUM_AMOUNT: 'Importe min.',
  MAXIMUM_AMOUNT: 'Importe máx.',
  ALL_PRODUCTS: 'Todos los productos',
  MORE_THAN_24_H: 'Más de 24h',
  MORE_THAN_3_DAYS: 'Más de 3 días',
  MORE_THAN_A_WEEK: 'Más de 1 semana',
  MORE_THAN_A_MONTH: 'Más de 1 mes',
  LOAN_APPLICATION_ERRORS: 'Errores en respuestas de entidades financieras',
  DOCUMENTATION_INCIDENCES: 'Incidencias documentales',
  FILTER_LOANS_WITH: 'Filtrar solicitudes con:',
  NO_FUNNEL_DATA: 'Todavía no existen datos para mostrar',
  WITH_INCIDENCE: 'En incidencia',
  SCHEDULED_DELIVERY_DATE: 'Fecha de entrega',
  SCROLL_TO_SELECTION_RESULTS_SHORT: 'Ver resultados',
  SCROLL_TO_SELECTION_RESULTS: 'Hacer scroll a los resultados de selección',

  // Table filters
  STATE: 'Estado',
  OTHER_FILTERS: 'Otros filtros',
  RESET_FILTERS: 'Restablecer filtros',
  WITH_DOCUMENTARY_INCIDENCE: 'En incidencia documental',
  WITH_ERROR: 'En error',
  VIN_INFORMED: 'Bastidor informado',
  DELIVERY_DATE_INFORMED: 'Fecha de entrega informada',

  // STEPS
  NO_RESULTS_TO_SHOW: 'Sin resultados',
  CUSTOM_GROUP: 'Grupo personalizado',

  // STEPS
  UNOPENED: 'Sin abrir',
  OPENED: 'Iniciado',
  // PERSONAL_INFORMATION: 'Información personal',
  FINANCIAL_INFORMATION: 'Información financiera',
  PROFESSIONAL_INFORMATION: 'Información profesional',
  RISK_INFORMATION: 'Información de riesgo',
  CONTRACT_NOT_SENT: 'Contrato por enviar',
  CONTRACT_SENT: 'Contrato enviado',
  VALIDATING_DOCUMENTATION: 'Firmado por formalizar',
  EDIT_BANK_ACCOUNT: 'Editar número de cuenta',

  // STATUS front
  status_opened: 'SMS abierto',
  status_kyc_set: 'Información personal',
  status_income_set: 'Información financiera',
  status_professional_details_set: 'Información profesional',
  status_risk_set: 'Información de riesgo',
  status_contract_sent: 'Contrato enviado',

  //STATUS Order
  started: 'Iniciado',
  initial: 'Iniciado',
  approved: 'Preaprobado',
  confirmed: 'Confirmado',
  captured: 'Capturado',
  on_hold: 'En estudio',
  denied: 'Denegado',
  cancelled: 'Cancelado',
  cancelled_test: 'Cancelado',
  desisted: 'Desistido',
  expired: 'Caducado',
  paid: 'Pagado',

  LOAN_STATUS_EXTERNAL: 'Estado',
  DEFAULT_STATUSES: 'Estados por defecto',

  //ORDER
  ORDER: 'Pedido',
  ORDER_STATUS_INITIAL: 'Información personal',
  ORDER_STATUS_ANALYSING: 'Pendiente OTP',
  ORDER_STATUS_LENDER_HAS_BEEN_SELECTED: 'Pendiente pago tarjeta',
  TOTAL_ORDER_AMOUNT: 'Total del pedido',
  TOTAL_CAPTURED_AMOUNT: 'Total capturado',
  TOTAL_REFUNDED_AMOUNT: 'Total devuelto',
  FROM_X_CAPTURES_AND_X_REFUNDS: 'De $v1 captura(s) y $v2 devolucion(es)',
  CATEGORY: 'Categoría',
  FROM: 'De',
  NO_ASSOCIATED_ITEMS: 'Sin artículos asociados',
  OTP: 'Código via SMS',
  MOBILE_VERIFICATION: 'Verificación móvil',
  OTP_PENDING: 'Pendiente OTP',
  DOWNPAYMENT: 'Primer pago',
  requested: 'Solicitado',

  PERSONAL_INFO_PENDING: 'Pendiente rellenar info personal',
  RESPONSE_PENDING: 'Pendiente respuesta entidad financiera',
  CONFIRMATION_PENDING: 'Pendiente confirmación',
  CAPTURE_PENDING: 'Pendiente captura',
  PAYMENT_PENDING: 'Pendiente pago',
  APPLICATION_COMPLETED: 'Solicitud completada',

  //ASSET DETAILS
  BRAND: 'Marca',
  MODEL: 'Modelo',
  version: 'Versión',
  LICENSE_PLATE_NUMBER: 'Matrícula',
  IDENTIFICATION_NUMBER: 'Número bastidor',
  IDENTIFICATION_NUMBER_MUST_BE_17_CHARACTERS: 'El número de bastidor debe tener 17 caracteres',
  INVALID_SPANISH_LICENSE_PLATE: 'La matrícula introducida no es válida.',
  REGISTRATION_DATE: 'Fecha matriculación',
  VEHICLE_TYPE: 'Tipo vehículo',
  ODOMETER: 'Kilometraje',
  MAX_POWER: 'Potencia máxima',
  ENGINE: 'Cilindrada',
  BODY_TYPE: 'Carrocería',
  KM: 'Km',
  CM_3: 'cm3',
  CV: 'Cv',
  FUEL_TYPE: 'Tipo combustible',
  GEAR_TYPE: 'Tipo cambio',
  IS_NEW_VEHICLE: 'Vehículo nuevo',
  IMPORTED: 'Vehículo importado',
  DELIVERY_DATE: 'Fecha de entrega',
  manual: 'Manual',
  automatic: 'Automático',
  gasoline: 'Gasolina',
  diesel: 'Diesel',
  electric: 'Eléctrico',
  hybrid: 'Híbrido',
  compressed_natural_gas: 'GNC',
  ethanol: 'Etanol',
  others: 'Otros',
  electric_hybrid: 'Híbrido eléctrico',
  type_of_vehicle: 'Tipo de vehículo',
  calculate_loan: 'Calcular préstamo',
  hatchback: 'Compacto',
  sedan: 'Sedán 4 puertas',
  suv: 'SUV',
  coupe: 'Coupé',
  convertible: 'Descapotable',
  wagon: 'WAGON',
  station_wagon: 'Coche familiar',
  minivan: 'Minivan',
  four_by_four: '4X4',
  cabrio: 'Cabrio',
  pick_up: 'Pick-up',
  camper_van: 'Furgoneta camperizada',
  car: 'Automóvil',
  off_road: '4x4',
  industrial: 'Industrial',

  ASSET_DETAILS: 'Información de producto',
  AUTO_ASSET_DETAILS: 'Información del vehículo',
  AUTO_DETAILS: 'Detalles del vehículo',
  VEHICLE_AMOUNT: 'Importe del vehículo',
  DOWN_PAYMENT_DOCUMENT: 'Justificante primer pago',
  TOTAL_COURSE_AMOUNT: 'Importe del curso',
  SCHOLARSHIP: 'Becas y ayudas',
  COURSE_DOWNPAYMENT: 'Importe de la matrícula',
  COURSE_START_DATE: 'Fecha inicio de curso',
  COURSE_END_DATE: 'Fecha fin de curso',
  WORKSITE_ADDRESS: 'Dirección de la reforma',
  [AssetType.HOME_IMPROVEMENT]: 'Hogar',
  [AssetType.UTILITIES_SUPPLY]: 'Punto de suministro',
  [AssetType.HEALTH]: 'Salud',
  [AssetType.TRAVEL]: 'Viajes',
  //KYC PERSONAL INFORMATION:

  BORROWER_INVITATION: 'Datos de contacto',
  EDIT_BORROWER_INVITATION: 'Editar datos de contacto',
  NO_INFORMATION_PROVIDED: 'Sin información',
  PENDING_INFORMATION_FROM_BORROWER_ONBOARDING: 'Todavía no se ha proporcionado información del cliente',
  PENDING_DOCUMENTATION_FROM_BORROWER_ONBOARDING: 'Todavía no se ha proporcionado documentación del cliente',
  PENDING_FOR_FINANCIAL_INFORMATION_FROM_BORROWER_ONBOARDING:
    'Todavía no se ha proporcionado información financiera del cliente',
  PENDING_FOR_ADDRESS_INFORMATION: 'Todavía no se ha proporcionado información de la dirección',

  //BORROWER INVITATION
  DOCUMENT_NUMBER: 'Número de documento',
  EXPIRES_ON: 'Fecha expiración de solicitud',
  RELATION: 'Relación',
  [Relation.SPOUSE]: 'Cónyuge',
  [Relation.SIBLING]: 'Hermano/a',
  [Relation.PARENT]: 'Padre/madre',
  [Relation.SON]: 'Hijo/a',
  [Relation.REST_OF_FAMILY]: 'Otro familiar',
  [Relation.OTHER]: 'Otro',

  // PHONE VERIFICATION
  PHONE_VERIFICATION: 'Verificación teléfono móvil',
  PHONE_VERIFICATION_SHORT: 'Verificación móvil',

  OTP_STATUS: 'Estado verificación',
  RECEIVED_CODE: 'Código introducido',
  RECEIVED_CODE_DATE: 'Fecha',
  [OtpStatus.ACCEPTED]: 'Aceptada',
  [OtpStatus.NOT_PROCESSED]: 'No procesada',
  [OtpStatus.REJECTED]: 'Rechazada',

  SENT_CODES: 'Códigos enviados',
  SENT_CODE_CODE: 'Código',
  SENT_CODE_STATUS: 'Estado SMS',
  SENT_CODE_STATUS_SHORT: 'Estado',
  SENT_CODE_PROVIDER_NAME: 'Proveedor SMS',
  SENT_CODE_DATE: 'Fecha',
  [SentCodeStatus.PENDING]: 'Pendiente',
  [SentCodeStatus.DELIVERED]: 'Entregado',
  [SentCodeStatus.FAILED]: 'Fallido',

  FIRST_INSTALMENT_PAID: 'Pago primera cuota',

  //DOCUMENT ID DETAILS
  NO_IMAGE: 'Sin imagen',
  LOADING_IMAGE: 'Obteniendo imagen...',
  NO_DOCUMENT: 'Sin documento',
  LOADING_DOCUMENT: 'Obteniendo documento ...',
  ONBOARDING_DETAILS: 'Información del cliente',
  FULFILLED_BY_MERCHANT_POS_DESCRIPTION: 'La información del cliente ha sido proporcionada por el comercio autorizado',
  DOCUMENT_ID: 'Documento de identidad',
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellidos',
  FULL_NAME: 'Nombre completo',
  DOCUMENT_TYPE: 'Tipo de documento',
  DOCUMENT_ID_NUMBER: 'Número de documento',
  DOCUMENT_ID_NUMBER_SHORT: 'Documento',
  GENDER: 'Género',
  [Gender.M]: 'Masculino',
  [Gender.F]: 'Femenino',
  NATIONALITY: 'Nacionalidad',
  BIRTH_DATE: 'Fecha de nacimiento',
  EXPIRATION_DATE: 'Fecha de caducidad',
  NIE_DATA: 'Datos del NIE',
  NATIONALITY_PERIOD: 'Antigüedad de nacionalidad',
  RESIDENCE_CARD_TYPE: 'Tipo de tarjeta de residencia',
  RESIDENCE_CARD_EXPIRATION_DATE: 'Fecha de caducidad de la tarjeta de residencia',
  SOCIAL_SECURITY_REGISTRATION_DATE: 'Fecha de alta en la seguridad social',
  NUMBER_OF_WORK: 'Número de empleos desde la nacionalización',
  NATIONALITY_PERIOD_unknown: 'Desconocida',
  NATIONALITY_PERIOD_less_than_3_months: 'Menos de 3 meses',
  NATIONALITY_PERIOD_between_3_and_11_months: 'De 3 a 11 meses',
  NATIONALITY_PERIOD_between_12_and_35_months: 'De 12 a 35 meses',
  NATIONALITY_PERIOD_between_36_and_59_months: 'De 36 a 59 meses',
  NATIONALITY_PERIOD_sixty_or_more_months: '60 meses o más',
  CARD_ID_initial: 'Inicial',
  CARD_ID_first_renewal: 'Primera renovación',
  CARD_ID_second_renewal: 'Segunda renovación',
  CARD_ID_permanent: 'Permanente',
  DOCUMENT_ADDRESS: 'Dirección del documento',
  STREET_NAME: 'Nombre calle',
  STREET_NUMBER: 'Número calle',
  CITY: 'Ciudad',
  COUNTRY: 'País',
  FLOOR_AND_DOOR: 'Piso y puerta',
  DOOR_NUMBER: 'Puerta',
  FLOOR_NUMBER: 'Piso',
  BIRTH_PLACE: 'Lugar de nacimiento',
  INVALID_DATE: 'Fecha no válida',
  DATE_SHOULD_NOT_BE_BEFORE_MINIMAL_DATE: 'Fecha anterior a la fecha mínima permitida',
  DATE_SHOULD_NOT_BE_AFTER_MAXIMAL_DATE: 'Fecha posterior a la fecha máxima permitida',
  ['Date should not be before minimal date']: 'Fecha anterior a la fecha mínima permitida',
  ['Date should not be after maximal date']: 'Fecha posterior a la fecha máxima permitida',
  INVALID_DOCUMENT_NUMBER: 'Número de documento no válido',
  ID_FRONT: 'Parte frontal del documento',
  ID_BACK: 'Parte trasera del documento',
  NIF: 'DNI',
  NIE: 'NIE',
  NIE_EU: 'NIE (Dentro de la UE)',
  NIE_NON_EU: 'NIE (Fuera de la UE)',
  nif: 'DNI',
  nie: 'NIE',
  nie_eu: 'NIE (Dentro de la UE)',
  nie_non_eu: 'NIE (Fuera de la UE)',
  passport: 'Pasaporte',
  CART: 'Carrito',
  DIAL_CODE: 'Prefijo',
  PHONE_NUMBER: 'Teléfono',
  DOCUMENT_EXPIRATION_DATE: 'Fecha caducidad del documento',
  PERSONAL_INFORMATION: 'Información personal',
  SHIPPING_AND_BILLING: 'Envío y facturación',
  SHIPPING_ADDRESS: 'Dirección de envío',
  BILLING_ADDRESS: 'Dirección de facturación',
  SHIPPING_METHOD: 'Método envío',
  SHIPPING_NAME: 'Nombre método envío',
  STREET_ADDRESS: 'Dirección',
  STREET_ADDRESS_2: 'Dirección adicional',
  COMPANY_VAT: 'CIF compañía',
  COMPANY_VAT_DESCRIPTION: 'Requerido por Sabadell Consumer, una de las entidades seleccionadas para la operación',
  SELECT_KYC: 'Seleccionar VideoID',
  SHOW_KYC_DATA: 'Ver datos VideoID',
  SIMILARITY_LEVEL: 'Grado de semejanza',
  [SimilarityLevel.HIGH]: 'Alto',
  [SimilarityLevel.MEDIUM]: 'Medio',
  [SimilarityLevel.LOW]: 'Bajo',
  [SimilarityLevel.VERY_LOW]: 'Muy bajo',
  AUTOMATIC_SECURITY_CHECKS: 'Verificaciones automáticas',
  MANUAL_CHECK: 'Verificación manual',
  VIDEO_ID: 'VideoID',
  KYC_DATA: 'Datos VideoID',
  PENDING_FOR_KYC_VERIFICATION: 'Pendiente de verificación manual',
  VERIFIER: 'Verificador/a',
  VERIFICATION_DATE: 'Fecha verificación',
  DURATION: 'Duración',
  SEND_REPEAT_KYC_EMAIL: 'Enviar nueva solicitud de VideoID',
  SEND_REPEAT_KYC_EMAIL_TEXT: '¿Deseas enviar una nueva solicitud de VideoID a $v1 ($v2)?',
  SEND_REPEAT_KYC_EMAIL_BTN: 'Enviar',
  [SecurityCheckName.DATA_INTEGRITY]: 'Integridad de los datos',
  [SecurityCheckName.LIVENESS]: 'Prueba de vida',
  [SecurityCheckName.NON_EXPIRED]: 'Documento en vigor',
  [SecurityCheckName.NOT_BW_COPY]: 'Documento en color',
  [SecurityCheckName.NOT_UNDERAGE]: 'Mayor de edad',
  [SecurityCheckName.SIDES_MATCH]: 'Compatibilidad entre anverso y verso',
  [SecurityCheckName.UNTAMPERED_DOCUMENT]: 'Documento sin alteraciones',
  [SecurityCheckName.UNTAMPERED_VIDEO]: 'Video sin alteraciones',
  [SecurityCheckName.REFLECTIVE_SURFACE]: 'Documento sin reflejos',
  [SecurityCheckName.NOT_FACE_SPOOFING]: 'Rostro no falsificado',

  //DIGITAL FOOTPRINT

  BROWSER: 'Navegador',
  DEVICE: 'Dispositivo',
  OPERATING_SYSTEM: 'OS',
  LOCALE: 'Idioma',

  SAVE: 'Guardar',
  // DOCUMENTATION
  OWNER_NUM_X: 'Titular #$v1',
  LOAN_DOCUMENTATION: 'Documetación solicitud',
  FILE_DOCUMENT_STATUS: 'Estados',
  DOCUMENTATION: 'Documentación',
  DOCUMENTATION_MANAGER: 'Gestor documental',
  DOCUMENTS: 'Documentos',
  UPLOADED: 'Subido',
  INCIDENCE: 'Incidencia',
  SENT: 'Enviado',
  UPLOAD_PENDING: 'Pendiente de subir',
  DOCUMENTATION_SENT_ON: 'Enviado el $v1',
  ALL_DOCUMENTS_UPLOADED: 'Toda documentación subida',
  INCIDENCE_IN_DOCUMENTS: 'Incidencia en documentación',
  ALL_DOCUMENTS_SENT: 'Toda documentación enviada',
  NO_REQUIRED_DOCUMENTS: 'Sin documentos requeridos',
  documentation_incidence: 'Incidencia documental',
  SEND_ALL_DOCUMENTS: 'Enviar todos los documentos',
  SEND_ALL_DOCUMENTS_DESCRIPTION: '¿Deseas enviar todos los documentos subidos a la entidad financiera seleccionada?',
  SYNCHRONIZE_DOCUMENTS: 'Sincronizar documentos',
  SYNCHRONIZE_DOCUMENTS_DESCRIPTION: '¿Deseas sincronizar la documentación con la entidad financiera seleccionada?',
  SYNCHRONIZE: 'Sincronizar',
  SET_ARE_DOCUMENTS_CONFIRMED: 'Confirmar todos los documentos',
  SET_ARE_DOCUMENTS_CONFIRMED_DESCRIPTION: '¿Deseas confirmar toda la documentación del titular?',
  SEND_INCIDENCE_NOTIFICATION: 'Enviar notificación de incidencia',
  SEND_INCIDENCE_NOTIFICATION_DESCRIPTION:
    '¿Deseas enviar un correo de notificación de incidencia documental al interviniente en cuestión?',
  ADD_REQUIRED_FILE_TYPE: 'Solicitar nuevo documento',
  ADD_REQUIRED_FILE_TYPE_DESCRIPTION: 'Selecciona el nuevo documento que deseas solicitar',
  REQUIRED_DOCUMENT_TYPE: 'Tipo de documento',
  UPLOADED_DOCUMENTS: 'Documentos subidos',
  REQUEST: 'Solicitar',
  CONFIRM: 'Confirmar',
  LOADING_FILE_TYPES: 'Cargando tipos de documentos...',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED: 'Eliminar documento solicitado',
  REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED_DESCRIPTION:
    '¿Deseas eliminar el documento solicitado al titular?',
  REMOVE: 'Eliminar',
  COMMENT: 'Comentario',
  SET_DOCUMENT_STATUS: 'Cambiar estado documento',
  SET_DOCUMENT_STATUS_REQUIRED_DESCRIPTION: 'Selecciona el nuevo estado con el que deseas marcar el documento.',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT: 'Marcar documento como no enviado',
  SET_DOCUMENT_REQUIRED_IS_NOT_SENT_DESCRIPTION: '¿Deseas marcar el documento como no enviado a la entidad financiera?',
  SET_NOT_SENT: 'Marcar como no enviado',
  DOCUMENT_VALIDATED: 'Documentación validada',
  CHANGE_STATUS: 'Cambiar estado',
  UPLOAD_FILE: 'Subir documento',
  DOWNLOAD_FILE: 'Descargar documento',
  DOWNLOAD_INSURANCE_OFFER: 'Descargar oferta de seguro',
  INSURANCE_OFFER_NOT_AVAILABLE_YET: 'La oferta de seguro aún no está disponible para las condiciones actuales',
  VALIDATED: 'Validado',
  UPLOAD_FILE_TEXT: 'Subir documento/s de tipo: ',
  ADD_FILE_ACTION: 'Seleccionar documento',
  UPLOADED_DOCUMENTATION: 'Documentación subida',
  DOCUMENTS_TO_UPLOAD: 'Documentación pendiente de subir',
  UPLOAD_FILES: 'Subir documentación',
  FILE_WILL_BE_OVERWRITTEN:
    'El nuevo fichero coincide con el nombre de un fichero ya subido. Si haces click en subir, se sobrescribirá el fichero que ya se encuentra subido actualmente.',
  THIS_MIME_FILE_TYPE_IS_NOT_POSSIBLE_TO_DOWNLOAD: 'No es posible descargar un documento de este tipo',
  //DOCUMENTATION FILETYPE
  PROFORMA_INVOICE: 'Factura proforma',
  BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION: 'Certificado de titularidad',
  PAYROLL: 'Nóminas',
  PERSONAL_INCOME_TAX: 'IRPF anual',
  BIOMETRICS_DOCUMENT: 'Documento biométrico del proceso KYC',
  DOCUMENT_ID_FRONT: 'Parte delantera del DNI / NIE',
  DOCUMENT_ID_BACK: 'Parte trasera del DNI / NIE',
  PASSPORT: 'Pasaporte',
  PENSION_DOCUMENT: 'Documento pensión',
  DOCUMENT_ID_FACE: 'Imagen facial extraída del documento de identidad',
  KYC_VIDEO: 'Vídeo extraído durante el proceso de KYC',
  DOCUMENT_ID_SIGNATURE: 'Firma extraída del documento de identidad',
  BIOMETRICS_FACE: 'Imagen facial extraída durante el proceso de KYC',
  LOAN_LENDER_BORROWER_CONTRACT: 'Contrato de financiación entre el cliente final y la entidad financiera',
  [IncomeType.BORROWER_BANK_READER]: 'Agregación bancaria',
  [IncomeType.DECLARED_INCOME]: 'Ingresos declarados',
  [NetIncomeType.SALARY]: 'Salario',
  [NetIncomeType.PENSION]: 'Pensión',
  [NetIncomeType.UNEMPLOYMENT_BENEFIT]: 'Paro',
  [NetIncomeType.OTHER_PAYMENT]: 'Otros',
  [BorrowerFileType.BORROWER_AML]: 'Resultados de la búsqueda de AML/PEP',
  [BorrowerFileType.BORROWER_ASNEF]: 'Resultado de la búqueda del DNI en listado de morosidad (ASNEF)',
  [LoanFileType.VEHICLE_INSPECTION_DOCUMENT]: 'Tarjeta de inspección técnica del vehículo',
  [LoanFileType.INE_NEMURU_DOCUMENT]: 'INE (Información Normalizada Europea) del préstamo intermediación',
  [LoanFileType.INE_LENDER_NEMURU_DOCUMENT]: 'INE (Información Normalizada Europea) del préstamo Nemuru Finance',
  [LoanFileType.DRIVING_PERMIT]: 'Permiso de circulación',
  [LoanFileType.CARFAX]: 'Documento Carfax del vehiculo',
  [LoanFileType.DEED_OF_SALE]: 'Escritura de compraventa',
  [LoanFileType.OWNERSHIP_DOCUMENTATION]:
    'Justificante de propiedad (IBI o escritura o nota simple o ultimo recibo hipoteca)',
  [LoanFileType.IBI]: 'Impuesto sobre bienes inmuebles',
  [LoanFileType.PROOF_OF_INCOME]:
    'Justificante de ingresos (nomina o revalorización pension o acuerdo de prejubilación o certificado bancario de cobro de pension o IRPF último ejercicio)',
  [LoanFileType.PROPERTY_REGISTRY_EXTRACT]: 'Nota simple del registro de la propiedad',
  [LoanFileType.LAST_MORTGAGE_PAYMENT]: 'Último recibo hipoteca',
  [LoanFileType.TRAFFIC_REPORT]: 'Informe trafico / Informe matricula / Informe cargas',
  [MerchantFileType.F_036]: 'Modelo 036 Alta autónomo',
  [BorrowerFileType.UNEMPLOYMENT_INCOME_DOC]: 'Documentación de ingresos por prestación por desempleo',
  [MerchantFileType.MERCHANT_DOCUMENT]: 'Documento de merchant',
  [MerchantFileType.MERCHANT_CONTRACT_AUDIT_TRAIL]: 'Traza de firma digital del contrato de merchant',
  [BorrowerFileType.SEPE_DOCUMENT]: 'Documento SEPE, confirmación del ERTE',
  [BorrowerFileType.LAST_FULL_PAYROLL]: 'Última nómina completa percibida antes del ERTE',
  [BorrowerFileType.PENSION_REVALUATION_LETTER]: 'Carta revalorización pensión de la seguridad social',
  [BorrowerFileType.LAST_PENSION_INCOME]: 'Último ingreso por pensión (recibo)',
  [BorrowerFileType.WORK_LEAVE]: 'Certificado de baja laboral',
  [BorrowerFileType.WORKING_LIFE_REPORT]: 'Certificado de vida laboral',
  [BorrowerFileType.CALLING_LETTER]: 'Carta de llamamiento (para trabajo temporal)',
  [BorrowerFileType.CONTRIBUTION_BASE]: 'Base de cotización',
  [BorrowerFileType.TAX_DATA]: 'Datos Fiscales',
  [BorrowerFileType.OTHER_1]: 'Otros 1',
  [BorrowerFileType.OTHER_2]: 'Otros 2',
  [BorrowerFileType.OTHER_3]: 'Otros 3',
  [BorrowerFileType.OTHER_4]: 'Otros 4',
  [BorrowerFileType.OTHER_5]: 'Otros 5',
  [BorrowerFileType.DRIVING_LICENCE]: 'Carnet de conducir',
  [BorrowerFileType.ADDRESS_EVIDENCE]: 'Justificante de direccion',
  [BorrowerFileType.SELF_EMPLOYMENT_FEE_VERIFIER]: 'Justificante cuota autónomos',
  [BorrowerFileType.MODEL_130_1T]: 'Model 130 1T',
  [BorrowerFileType.MODEL_130_2T]: 'Model 130 2T',
  [BorrowerFileType.MODEL_130_3T]: 'Model 130 3T',
  [BorrowerFileType.MODEL_130_4T]: 'Model 130 4T',
  [BorrowerFileType.MODELO_300_1T]: 'Modelo 300 1T',
  [BorrowerFileType.MODELO_300_2T]: 'Modelo 300 2T',
  [BorrowerFileType.MODELO_300_3T]: 'Modelo 300 3T',
  [BorrowerFileType.MODELO_300_4T]: 'Modelo 300 4T',
  [BorrowerFileType.MODEL_390_LAST_YEAR]: 'Declaración del último año IVA (Modelo 390)',
  [BorrowerFileType.PAYROLL_TWO_PREVIOUS_MONTHS]: 'Nómina de hace dos meses',
  [BorrowerFileType.PAYROLL_THREE_MONTHS_EARLIER]: 'Nómina de hace tres meses',
  [LoanFileType.SALES_INVOICE]: 'Factura de venta',
  [LoanFileType.BILL_SERVICES]: 'Factura servicios',
  [BorrowerFileType.BANK_READER_INCOME]: 'Ingreso detectado a través de la agregación bancaria',
  [BorrowerFileType.CAIXABANK_INCIDENCE_DOCUMENT]: 'Documentación adicional',
  [BorrowerFileType.INSURANCE_BORROWER_CONTRACT]:
    'Original de la Póliza del seguro firmada por el titular de la póliza',
  [BorrowerFileType.PHONE_OR_ENERGY_INVOICE]: 'Factura domiciliada de teléfono o luz a nombre del titular',
  [BorrowerFileType.CREDIT_CARD_FRONT]: 'Tarjeta de crédito (no débito) cara frontal',
  [BorrowerFileType.CREDIT_CARD_BACK]: 'Tarjeta de crédito (no débito) cara posterior',
  [BorrowerFileType.ENROLLMENT_OF_THE_STUDENT]: 'Matrícula del estudiante del año en curso',
  [BorrowerFileType.TAXI_LICENCE]: 'Licencia de taxi en vigor',
  [BorrowerFileType.PROPERTY_CERTIFICATE]: 'Justificante de propiedad',
  [BorrowerFileType.TAX_VAT_LAST_QUARTER]: 'IVA del último trimestre',
  [BorrowerFileType.TAX_VAT_PREVIOUS_QUARTER]: 'IVA del trimestre anterior',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_BACK]: 'Parte trasera del documento del apoderado 1',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_BACK]: 'Parte trasera del documento del apoderado 2',
  [BorrowerFileType.ATTORNEY_1_DOCUMENT_ID_FRONT]: 'Parte delantera del documento del apoderado 1',
  [BorrowerFileType.ATTORNEY_2_DOCUMENT_ID_FRONT]: 'Parte delantera del documento del apoderado 2',
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_CURRENT_YEAR]:
    'Balance de pérdidas y ganancias del ejercicio actual',
  [BorrowerFileType.BALANCE_SHEET_AND_INCOME_STATEMENT_LAST_YEAR]:
    'Balance de pérdidas y ganancias del ejercicio pasado',
  [BorrowerFileType.CORPORATE_IDENTIFICATION_NUMBER]: 'CIF de la compañía',
  [BorrowerFileType.POWERS_OF_ATTORNEY]: 'Escrituras de poderes del apoderado',
  [BorrowerFileType.MODEL_200_LAST_YEAR]: 'Impuestos de Sociedades - Modelo 200 (ejercicio pasado)',
  [BorrowerFileType.MODELO_303_CURRENT_YEAR]: 'Declaración trimestral del IVA - Modelo 303 (ejercicio actual)',
  [BorrowerFileType.ABANCA_ADHESION_BULLETIN]: 'Boletín de adhesión a Abanca',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_BS]: 'Nómina y certificado de titularidad BS',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_COFIDIS]: 'Nómina y certificado de titularidad Cofidis',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_NEMURU]: 'Nómina y certificado de titularidad Nemuru',
  [LoanFileType.INCOME_AND_OWNERSHIP_CERTIFICATION_SOYOU]: 'Nómina y certificado de titularidad Sofinco',
  [BorrowerFileType.CREDIT_CARD_CONTRACT]: 'Contrato de tarjeta de crédito',
  [LoanFileType.CREDIT_CARD_CONTRACT_AUDIT_TRAIL]: 'Traza de firma digital del contrato de tarjeta de crédito',
  [BorrowerFileType.NIE_EU_DOCUMENT_ID]: 'Documento de identidad NIE (Europeo)',

  //MAIN RESIDENCE DETAILS:
  MAIN_RESIDENCE: 'Domicilio principal',
  OWNERSHIP_TYPE: 'Tipo de propiedad',
  CONTRACT_TYPE: 'Tipo de contrato',
  HOME_EXPENSES: 'Gastos mensuales',
  ENTRANCE_DATE: 'Fecha de entrada al domicilio',
  MORTGAGE: 'Hipoteca',
  public_deed: 'Con escritura pública',
  private_contract: 'Con contrato privado',
  social_housing: 'Vivienda social',
  ownership: 'De mi propiedad',
  rent: 'Alquilado',
  leasing: 'Propiedad/alquier de empresa',
  usufruct: 'Usufructo',
  partner: 'Propiedad de cónyugue',
  parents: 'Propiedad de padres',
  FORMATTED_ADDRESS_WILL_BE_GEOLOCATED_WARNING:
    'La dirección proporcionada será geolocalizada automáticamente a través de Google y podría ajustarse para mayor precisión. Por favor, revisa el resultado final tras guardarla.',
  BUILDING_LABEL: 'Escalera / Bloque',
  AUTOCOMPLETE_ADDRESS: 'Autocompletar dirección',
  COMPLETE_ADDRESS_MANUALLY: 'Completar la dirección manualmente',
  AUTOCOMPLETE_HINT: 'Comieza a introducir tu dirección y selecciona una opción de la lista',
  SELECTED_ADDRESS: 'Dirección seleccionada',
  SEARCH_AGAIN: 'Volver a buscar',
  UPDATING_ADDRESS: 'Actualizando dirección',
  EDIT_ADDRESS: 'Editar dirección',
  ADDITIONAL_DETAILS: 'Detalles adicionales',
  CONFIRM_CHANGES: 'Confirmar cambios',
  HOME_EXPENSES_MUST_BE_GREATER_THAN_0: 'Los gastos mensuales deben ser superiores a 0',

  //FAMILIAR SITUATION DETAILS
  FAMILIAR_SITUATION: 'Situación familiar',
  MARITAL_STATUS: 'Estado civil',
  MARITAL_REGIME: 'Régimen matrimonial',
  CHILD_SUPPORT_NUMBER: 'Número de hijos a cargo',
  married: 'Casado/a',
  separated: 'Separado/a',
  single: 'Soltero/a',
  widowed: 'Viudo/a',
  divorced: 'Divorciado/a',
  separated_in_fact: 'Separado/a de hecho',
  similar_situation_to_married: 'Situación similar al matrimonio',
  matrimonial_assets: 'Con régimen de gananciales',
  separate_property: 'Con separación de bienes',

  //PROFESSIONAL DETAILS
  PROFESSIONAL_DETAILS: 'Información profesional',
  EMPLOYMENT_STATUS: 'Situación profesional',
  PROFESSIONAL_POSITION: 'Profesión',
  COMPANY: 'Empresa',
  COMPANY_NAME: 'Nombre de la compañía',
  COMPANY_ACTIVITY: 'Actividad de la compañía',
  COMPANY_CITY: 'Ciudad',
  INDIVIDUAL_FINANCIAL_DATA_PRICE: 'Importe neto ejercicio anterior',
  INDIVIDUAL_FINANCIAL_DATA_DATE: 'Año del ejercicio anterior',
  SENIORITY_YEARS: 'Años en la companía',
  SENIORITY_MONTHS: 'Meses en la companía',
  DATE_CONTRACT_END: 'Fecha de fin de contrato',
  TIME_IN_THE_COMPANY: 'Tiempo en la compañía',
  SENIORITY: 'Antigüedad',
  SELF_EMPLOYMENT_NET_INCOME: 'Importe neto del ejercicio anterior',
  SELF_EMPLOYMENT_NET_INCOME_DATE: 'Fecha del ejercicio anterior',
  [EmploymentStatus.SELF_EMPLOYED]: 'Autónomo/a',
  [EmploymentStatus.INDEFINITE_EMPLOYED]: 'Trabajo con contrato indefinido',
  [EmploymentStatus.TEMPORARY_EMPLOYED]: 'Trabajo con contrato temporal',
  [EmploymentStatus.FIXED_DISCONTINUOUS_EMPLOYED]: 'Trabajo con contrato fijo discontinuo',
  [EmploymentStatus.CIVIL_SERVANT]: 'Funcionario/a',
  [EmploymentStatus.TRAINEE]: 'Becario / En prácticas',
  [EmploymentStatus.CASUALTY_WORKER]: 'Temporero/a',
  [EmploymentStatus.UNEMPLOYED]: 'En paro',
  [EmploymentStatus.RETIRED]: 'Retirado/a',
  [EmploymentStatus.PENSIONER]: 'Pensionista',
  [EmploymentStatus.STUDENT]: 'Estudiante',
  [EmploymentStatus.RENTIER]: 'Rentista',
  [EmploymentStatus.WITHOUT_WORK]: 'Sin trabajo',
  [EmploymentStatus.WIDOWS_INCOME]: 'Pensión de viudedad',
  [ProfessionalPosition.ADMINISTRATIVE]: 'Administrativo/a',
  [ProfessionalPosition.MANAGING_DIRECTOR]: 'Directivo/a',
  [ProfessionalPosition.MANAGER]: 'Gerente',
  [ProfessionalPosition.WRITER]: 'Escritor/a',
  [ProfessionalPosition.COMPANY_OWNER]: 'Propietario/a / Administrador/a empresa',
  [ProfessionalPosition.TECHNICIANS_AND_PROFESSIONAL]: 'Técnico/a o Profesional',
  [ProfessionalPosition.SHOP_ASSISTANT]: 'Dependiente / Camarero/a',
  [ProfessionalPosition.COMMERCIAL_AND_SALES_PERSON]: 'Comercial / Ventas',
  [ProfessionalPosition.LABOR_WORKER]: 'Operario / Obrero',
  [ProfessionalPosition.ENGINEER]: 'Ingeniero/a',
  [ProfessionalPosition.ARCHITECT]: 'Arquitecto/a',
  [ProfessionalPosition.LAWYER_OR_NOTARY_ATTORNEY]: 'Abogado/a o notario/a',
  [ProfessionalPosition.DOCTOR_OR_DENTIST]: 'Profesionales de la salud',
  [ProfessionalPosition.PHARMACEUTICAL]: 'Farmacéutico/a',
  [ProfessionalPosition.VETERINARY]: 'Veterinario/a',
  [ProfessionalPosition.TEACHER]: 'Maestro/a',
  [ProfessionalPosition.JOURNALIST]: 'Periodista',
  [ProfessionalPosition.FARMER_OR_RANCHER]: 'Agricultor/a o ganadero/a',
  [ProfessionalPosition.TRANSPORTER]: 'Transportista',
  [ProfessionalPosition.PROFESSIONAL_ATHLETE]: 'Atleta profesional',
  [ProfessionalPosition.ARTIST]: 'Artista',
  [ProfessionalPosition.RELIGIOUS]: 'Religioso/a',
  [ProfessionalPosition.POLICE_AND_MILITARY]: 'Policía / Ejército',
  [ProfessionalPosition.DIPLOMATIC]: 'Diplomático/a',
  [ProfessionalPosition.CIVIL_SERVANT_A1]: 'Adm. público - Funcionario A1',
  [ProfessionalPosition.CIVIL_SERVANT_A2]: 'Adm. público - Funcionario A2',
  [ProfessionalPosition.CIVIL_SERVANT_B]: 'Adm. público - Funcionario B',
  [ProfessionalPosition.CIVIL_SERVANT_C1]: 'Adm. público - Funcionario C1',
  [ProfessionalPosition.CIVIL_SERVANT_C2]: 'Adm. público - Funcionario C2',
  [ProfessionalPosition.CIVIL_SERVANT_E]: 'Adm. público - Funcionario E',
  [ProfessionalPosition.LABOR_STAFF_G1]: 'Adm. público - Funcionario G1',
  [ProfessionalPosition.LABOR_STAFF_G2]: 'Adm. público - Funcionario G2',
  [ProfessionalPosition.LABOR_STAFF_G3]: 'Adm. público - Funcionario G3',
  [ProfessionalPosition.LABOR_STAFF_G4]: 'Adm. público - Funcionario G4',
  [ProfessionalPosition.LABOR_STAFF_G5]: 'Adm. público - Funcionario G5',
  [IberiaEmploymentStatus.EMPLOYEE_PERMANENT]: 'Trabajo con contrato indefinido',
  [IberiaEmploymentStatus.EMPLOYEE_CIVIL_SERVANT]: 'Administración público',
  [IberiaEmploymentStatus.EMPLOYEE_INTERN]: 'Becario/a',
  [IberiaEmploymentStatus.EMPLOYEE_TEMPORARY]: 'Trabajo con contrato temporal',
  [IberiaEmploymentStatus.EMPTY]: '-',
  [IberiaEmploymentStatus.EXECUTIVE_DIRECTOR]: 'Director/a ejecutivo/a',
  [IberiaEmploymentStatus.INACTIVE]: 'En paro',
  [IberiaEmploymentStatus.INVESTOR_SHAREHOLDER]: 'Inversor/a',
  [IberiaEmploymentStatus.PENSIONER_RETIRED_WIDOW]: 'Pensionista / jubilado/a / viudo/a',
  [IberiaEmploymentStatus.SELF_EMPLOYED_BUSINESS_OWNER]: 'Empresario/a',
  [IberiaEmploymentStatus.SELF_EMPLOYED_FREELANCER]: 'Autónomo/a',
  [CompanyActivity.AGRICULTURE_LIVESTOCK_FISHERIES]: 'Agricultura / Ganadería / Pesca',
  [CompanyActivity.MINING_METALLURGY]: 'Minería / Metalurgia',
  [CompanyActivity.GROCERY]: 'Comestibles',
  [CompanyActivity.TEXTILE_MANUFACTURE]: 'Textil',
  [CompanyActivity.WOOD]: 'Maderería',
  [CompanyActivity.GRAPHICS_ARTS_EDITION]: 'Arte gráfico / Edición',
  [CompanyActivity.CHEMISTRY]: 'Quimica',
  [CompanyActivity.MECHANICAL_MACHINERY]: 'Maquinaria mecánica',
  [CompanyActivity.ENERGY_DISTRIBUTION_ELECTRICAL_SUPPLY]: 'Energética',
  [CompanyActivity.OTHER_UNQUALIFIED_SERVICES]: 'Otro servicio no cualificado',
  [CompanyActivity.OTHER_QUALIFIED_SERVICES]: 'Otro servicio cualificado',
  [CompanyActivity.BUILDING]: 'Construcción',
  [CompanyActivity.COMMERCE]: 'Comercio',
  [CompanyActivity.PEDDLING]: 'Venta ambulante',
  [CompanyActivity.TRANSPORT_TERRESTRIAL_MESSAGING]: 'Mensajería por transporte terrestre',
  [CompanyActivity.OTHER_TRANSPORTS]: 'Otro tipo de transportista',
  [CompanyActivity.TAXI_DRIVER]: 'Servicio de chofer / Taxi',
  [CompanyActivity.TELECOMMUNICATIONS_MAIL]: 'Telecomunicación / Correo',
  [CompanyActivity.BARS_SERVICES]: 'Servicios / Gastronomía',
  [CompanyActivity.I_PLUS_D]: 'Investicación y desarrollo',
  [CompanyActivity.ADVOCACY_JOURNALISM]: 'Periodismo / Abogacía',
  [CompanyActivity.SECURE_FINANCIAL_SERVICES]: 'Servicios Financieros',
  [CompanyActivity.FINANCIAL_SERVICES_INSURANCE]: 'Aseguradora',
  [CompanyActivity.IT_CONSULTANT_AUDITOR]: 'IT / Consultoría / Auditoría',
  [CompanyActivity.ARCHITECTURE_ENGINEERING]: 'Ingeniería / Arquitectura',
  [CompanyActivity.VETERINARY_MEDICINE]: 'Medicina / Veterinaria',
  [CompanyActivity.PUBLIC_ADMINISTRATIONS]: 'Administración Pública',
  [CompanyActivity.ARMED_FORCES]: 'Fuerzas Armadas',
  [CompanyActivity.EDUCATION]: 'Educación',
  [CompanyActivity.HOLIDAY_SHOWS_SHOWS]: 'Vacacional / Entretenimiento',
  [CompanyActivity.SPORTS]: 'Deporte',
  [IberiaCompanyActivity.AERONAUTICS_TRANSPORT_NAUTICAL]: 'Aeronáutica, Transportes y Náutica',
  [IberiaCompanyActivity.AGRICULTURE_GARDENING_MINERALOGY_GEOLOGY]: 'Agricultura, Jardinería, Mineralogía y Geología',
  [IberiaCompanyActivity.BANKING_FINANCIAL_INSTITUTIONS]: 'Banca y Entidades Financieras',
  [IberiaCompanyActivity.EXPERIMENTAL_SCIENCES_MATHEMATICS_PHYSICS]: 'Ciencias Experimentales, Matemáticas y Física',
  [IberiaCompanyActivity.COMMUNICATION_ADVERTISING_PUBLIC_RELATIONS]: 'Comunicación, Publicidad y Relaciones Públicas',
  [IberiaCompanyActivity.CONSTRUCTION_BUILDING]: 'Construcción y Edificación',
  [IberiaCompanyActivity.SECURITY_FORCES_CRIMINOLOGY]: 'Cuerpos De Seguridad y Criminología',
  [IberiaCompanyActivity.SPORTS_PHYSICAL_EDUCATION]: 'Deporte y Educación Física',
  [IberiaCompanyActivity.LAW_POLITICS]: 'Derecho y Política',
  [IberiaCompanyActivity.DESIGN_GRAPHIC_TEXTILE_INDUSTRIAL_INTERIOR]: 'Diseño: Gráfico Textil, Industrial e Interiores',
  [IberiaCompanyActivity.ECONOMICS_BUSINESS_ADMINISTRATION]: 'Economía y Administración de Empresas',
  [IberiaCompanyActivity.EDUCATION_TRAINING]: 'Educación y Formación',
  [IberiaCompanyActivity.HOSPITALITY_TOURISM_CATERING]: 'Hostelería, Turismo y Restauración',
  [IberiaCompanyActivity.HUMANITIES_PSYCHOLOGY]: 'Humanidades, Psicólogo',
  [IberiaCompanyActivity.LANGUAGES_PHILOLOGY_TRANSLATION]: 'Idiomas, Filología y Traducción',
  [IberiaCompanyActivity.PERSONAL_IMAGE]: 'Imagen Personal',
  [IberiaCompanyActivity.IMAGE_SOUND]: 'Imagen y Sonido',
  [IberiaCompanyActivity.INDUSTRY_MECHANICS_ELECTRICITY_ELECTRONICS]: 'Industria, Mecánica, Electricidad y Electrónica',
  [IberiaCompanyActivity.IT_TELECOMMUNICATIONS]: 'Informática y Telecomunicaciones',
  [IberiaCompanyActivity.ENVIRONMENT_VETERINARY_SCIENCE]: 'Medio Ambiente y Veterinaria',
  [IberiaCompanyActivity.MUSIC_FILM_DANCE_THEATRE]: 'Música, Cine, Danza y Teatro',
  [IberiaCompanyActivity.HEALTHCARE_HEALTH]: 'Sanidad y Salud',
  [IberiaCompanyActivity.CRAFT_ARTISTIC_TECHNIQUES]: 'Técnicas Artesanales y Artísticas',

  //BUSINESS DETAILS

  BUSINESS_IDENTIFICATION: 'Detalles empresa',
  NATIONAL_ID_TYPE: 'Tipo de documento de identidad',
  NATIONAL_ID_NUMBER: 'Número de documento',
  BUSINESS_FINANCIAL_DETAILS: 'Detalles financieros',
  CAPITAL_STOCK: 'Capital social',
  OWN_FUNDS: 'Fondos propios',
  TAX_BASE: 'Benefício antes de impuestos',
  INDIVIDUAL_FINANCIAL_NET_AMOUNT: 'Facturación',
  BIRTH_COUNTRY: 'País nacimiento',
  HOLDER_TYPES: 'Tipo de apoderado',
  GRANTING_POWERS_DATE: 'Fecha otorgamiento de poderes',
  HOLDER_PERCENTAGE: 'Porcentaje participación',
  RELATIONSHIP_WITH_OWNER: 'Relación con propietario',
  [HolderType.ATTORNEY]: 'Apoderado',
  [HolderType.ADMINISTRATOR]: 'Administrador',
  [HolderType.SHAREHOLDER]: 'Socio',
  attorneys: 'Apoderados',
  shareholders: 'Socios',
  administrators: 'Administradores',
  EDIT_BUSINESS_IDENTIFICATION: 'Editar detalles de empresa',
  EDIT_BUSINESS_FINANCIAL_DETAILS: 'Editar detalles financieros',
  EDIT_BUSINESS_ADDRESS: 'Editar dirección de empresa',
  edit_attorney_details: 'Editar detalles de apoderado',
  edit_shareholder_details: 'Editar detalles de socio',
  edit_administrator_details: 'Editar detalles de administrador',

  //BUSINESS TYPE
  [BusinessType.AEI]: 'AGRUPACION EUROPEA INTERES ECO',
  [BusinessType.AIE]: 'AGRUPACION INTERES ECONOMICO',
  [BusinessType.CB]: 'COMUNIDAD DE BIENES',
  [BusinessType.CP]: 'COMUNIDAD DE PROPIETARIOS',
  [BusinessType.ECR]: 'ENTIDADES DE CAPITALRIESGO',
  [BusinessType.ESJ]: 'ENTIDAD SIN PERSON. JURIDICA',
  [BusinessType.MUT]: 'MUTUALIDAD',
  [BusinessType.OTR]: 'OTROS',
  [BusinessType.PRI]: 'ASOC./ORG. PRIVADA',
  [BusinessType.PUB]: 'ADMINISTRACION PUBLICA',
  [BusinessType.SA]: 'SOCIEDAD ANONIMA',
  [BusinessType.SAL]: 'SOCIEDAD ANONIMA LABORAL',
  [BusinessType.SAT]: 'SOCIEDAD AGRARIA TRANSFORMACIO',
  [BusinessType.SAU]: 'SOCIEDAD ANONIMA UNIPERSONAL',
  [BusinessType.SCA]: 'SOC. COMANDITARIA POR ACCIONES',
  [BusinessType.SCE]: 'SOCIEDAD COOPERATIVA EUROPEA',
  [BusinessType.SCL]: 'SOCIEDAD COLECTIVA',
  [BusinessType.SCO]: 'SOCIEDAD COOPERATIVA',
  [BusinessType.SCP]: 'SOCIEDAD CIVIL PRIVADA',
  [BusinessType.SCS]: 'SOC. COMANDITARIA SIMPLE',
  [BusinessType.SE]: 'SOCIEDAD ANONIMA EUROPEA',
  [BusinessType.SGR]: 'SOCIEDAD DE GARANTÍA RECIPROCA',
  [BusinessType.SL]: 'SOCIEDAD LIMITADA',
  [BusinessType.SLL]: 'SOCIEDAD LIMITADA LABORAL',
  [BusinessType.SLN]: 'SOCIEDAD LIM. NUEVA EMPRESA',
  [BusinessType.SLU]: 'SOCIEDAD LIMITADA UNIPERSONAL',
  [BusinessType.SPD]: 'SUCURSALES PAISES DIFERENTES',
  [BusinessType.SRL]: 'SOCIEDAD RESP. LIMITADA',

  //NET INCOME
  NET_INCOME: 'Ingresos',
  BANK_NAME: 'Entidad financiera',
  ACCOUNT_NUMBER: 'Número de cuenta bancaria',
  IBAN: 'IBAN',
  DETECTED_INCOMES: 'Ingresos detectados',
  LAST_12_MONTHS: 'Últimos 12 meses',
  MONTHLY: 'Mensual',
  ANNUAL: 'Anual',
  INCOME_TYPE: 'Tipo de ingreso',
  ORIGIN: 'Origen',
  LOADING_INCOME: 'Obteniendo ingresos detectados...',
  ANNUAL_NET_INCOME: 'Ingresos netos anuales',
  MONTHLY_NET_INCOME: 'Ingresos netos mensuales',
  EDIT_DECLARED_INCOME: 'Editar ingresos declarados',
  INVALID_IBAN: 'Número de cuenta no válido',
  NUMBER_OF_YEARLY_PAYMENTS: 'Número de pagas anuales',

  // ROLES
  [APP_ROLES.SUPER_ADMIN]: 'Super-administrador',
  [APP_ROLES.ADMIN]: 'Administrador',
  [APP_ROLES.LENDER]: 'Lender',
  [APP_ROLES.MERCHANT]: 'Merchant',
  [APP_ROLES.CHANNEL]: 'Canal',
  [APP_ROLES.AGENT]: 'Agente',
  [APP_ROLES.PARTNER]: 'Partner',
  [APP_ROLES.THIRD_PARTY_VALIDATION]: 'Agente de validación externa',

  //USER TYPE
  [`user_${UserType.SUPER_ADMIN}`]: 'Super-administrador',
  [`user_${UserType.ADMIN}`]: 'Administrador',
  [`user_${UserType.LENDER}`]: 'Lender',
  [`user_${UserType.MERCHANT}`]: 'Merchant',
  [`user_${UserType.CHANNEL}`]: 'Canal',
  [`user_${UserType.AGENT}`]: 'Agente',
  [`user_${UserType.MERCHANT_GROUP}`]: 'Grupo',
  [`user_${UserType.PARTNER}`]: 'Partner',
  [`user_${UserType.THIRD_PARTY_VALIDATION}`]: 'Agente de validación',
  [`user_${UserType.CPC_BACK_OFFICE}`]: 'Customer Support CPC',

  // ACCOUNT

  USER_NAME: 'Nombre de usuario',
  USER_TYPE: 'Tipo de usuario',
  PROFILE: 'Perfil',
  USER_INFO: 'Información de usuario',
  ACCOUNT_TYPE: 'Tipo de cuenta',
  APPLICATION_LANGUAGE: 'Idioma de la aplicación',
  CHANNEL_AGENTS_NUMBER: 'Número de agentes del canal',
  BUSINESS_PHONE: 'Teléfono',
  BUSINESS_ADDRESS: 'Dirección',
  THEME: 'Apariencia',
  DARK_MODE_TOGGLE: 'Modo oscuro',

  // SNACKBAR NOTIFICATIONS
  ACTION_GENERIC_ERROR: '¡Oops! Se ha producido un error.',
  ACTION_GENERIC_INFO: 'La acción se ha realizado correctamente',
  ACTION_GENERIC_SUCCESS: 'La acción se ha realizado correctamente',
  ACTION_GENERIC_ERROR_TITLE: 'La acción no se ha podido realizar',
  REQUEST_GET_LOAN_BY_ID_REJECTED: 'No se han podido cargar los datos del préstamo solicitado',

  //PRICINGS
  PRICINGS_LIST: 'Listado de tarifas',
  LOADING_PRICINGS: 'Cargando tarifas...',
  LOADING_PRICINGS_DETAILS: 'Cargando tarifa...',
  FILTERS: 'Filtros',
  AVAILABLE_PRICINGS: 'Tarifas disponibles',
  SELECT_THE_PAYMENT_METHOD: 'Selecciona el método de pago deseado.',
  WITH_GRACE_PERIOD_FILTER: 'Con carencia',
  WITHOUT_GRACE_PERIOD_FILTER: 'Sin carencia',
  GRACE_PERIOD_NO_FILTER: 'Carencia sin filtrar',
  NO_FILTER: 'Sin filtrar',
  WITH_SETUP_FEE_FILTER: 'Con gastos apertura',
  WITHOUT_SETUP_FEE_FILTER: 'Sin gastos apertura',
  SETUP_FEE_NO_FILTER: 'Gastos apertura sin filtrar',
  [`INSURANCE_TYPE_${InsuranceType.EXTENSION_GARANTIA}`]: 'Extensión garantía',
  [`INSURANCE_TYPE_${InsuranceType.NO}`]: 'Sin seguro',
  [`INSURANCE_TYPE_${InsuranceType.RETIRADA_CARNET}`]: 'Retirada carnet',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_AUTO}`]: 'Seguro auto',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_DESEMPLEO}`]: 'Seguro desempleo',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_PPP}`]: 'Seguro PPP',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA}`]: 'Seguro vida',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA}`]: 'Seguro vida IPA',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_IPA_PPP}`]: 'Seguro vida IPA PPP',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_PLUS}`]: 'Seguro vida+',
  [`INSURANCE_TYPE_${InsuranceType.SINIESTRO_TOTAL}`]: 'Siniestro total',
  [`INSURANCE_TYPE_${InsuranceType.VEHICULO_SUSTITUCION}`]: 'Vehículo sustitución',
  [`INSURANCE_TYPE_${InsuranceType.SEGURO_VIDA_SENIOR}`]: 'Seguro vida senior',
  NO_INSURANCE: 'Sin seguro',

  INSURANCE_PROVIDER: 'Proveedor',
  INSURANCE_TYPE_NONE: 'Sin seguro',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BBVA}`]: 'BBVA',
  [`INSURANCE_PROVIDER_${InsuranceProvider.CAIXABANK}`]: 'CaixaBank',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SANTANDER_CONSUMER}`]: 'Santander Consumer',
  [`INSURANCE_PROVIDER_${InsuranceProvider.BS}`]: 'BS',
  [`INSURANCE_PROVIDER_${InsuranceProvider.SOYOU}`]: 'SoYou',
  [`INSURANCE_PROVIDER_${InsuranceProvider.ABANCA}`]: 'Abanca',
  [`INSURANCE_PROVIDER_${InsuranceProvider.COFIDIS}`]: 'Cofidis',
  [`INSURANCE_PROVIDER_${InsuranceProvider.WEE_COVER}`]: 'Wee Cover',
  INSURANCE_COST: 'Importe seguro',
  INSURANCE_PERCENTAGE: 'Porcentaje seguro',

  //PAGE LOADING
  LOADING: 'Cargando',
  STILL_LOADING: 'Aún cargando...',
  IT_SEEMS_THAT_SOME_FEATURES_ARE_TAKING_LONGER_THAN_USUAL_TO_LOAD:
    'Parece que algunas funcionalidades están tardando más de lo habitual. Puedes esperar o **LINK**mostrar la pagina parcialmente**LINK** mientras cargan.',

  //CUSTOMER SUPPORT
  CUSTOMER_SUPPORT: 'Atención al cliente',
  DAY: 'día',
  DAYS: 'días',
  HOUR: 'hora',
  HOURS: 'horas',
  MINUTE: 'minuto',
  MINUTES: 'minutos',
  SECOND: 'segundo',
  SECONDS: 'segundos',
  AFTER: 'después',
  DONE: 'Realizadas',
  LOADING_TICKETS: 'Cargando histórico de gestión...',
  TIME_PASSED_SINCE_LAST_ACTION: 'Tiempo desde última acción',
  TOTAL_ACTIONS_TIME: 'Tiempo total de gestión',
  UPDATED_AT: 'Fecha actualización:',
  TICKET_STATUS: 'Estado:',
  PRIORITY: 'Prioridad:',
  SELECT_TICKET: 'Seleccionar ticket',
  TICKET_SOLVED: 'Resuelto',
  TICKET_OPENED: 'Abierto',
  TICKET_PENDING: 'Pendiente',
  TICKET_CLOSED: 'Cerrado',
  NO_TICKETS_AVAILABLE: 'No existe información de incidencias del servicio de atención al cliente',
  SINCE_LOAN_RESOLUTION: 'Desde la resolución del ticket',
  [Priority.URGENT]: 'Urgente',
  [Priority.NORMAL]: 'Normal',
  ACTIVITY_LOG: 'Actividad',
  TOTAL_ACTIONS: 'Total de acciones',
  SELECTED_CHANNELS: 'Canales seleccionados',
  [PendingDataType.NO_CHANNELS_SELECTED]: 'No hay canales seleccionados',
  [PendingDataType.PASSWORD_RECOVERY_NOT_FOUND]: 'No se han enviado emails de recuperación de contraseña',

  // New Application general
  NEW_APPLICATION: 'Nueva solicitud',
  RESTART: 'Reiniciar',
  RESTART_NOTICE: 'Los datos se perderán si reinicias la solicitud.',
  BACK_NOTICE: 'Los datos del carrito se perderán si vuelves atrás.',
  RESTART_APPLICATION: 'Reiniciar solicitud',
  LEAVE: 'Abandonar',
  LEAVE_NOTICE: 'Los datos se perderán si abandonas la solicitud.',
  LEAVE_APPLICATION: 'Abandonar solicitud',
  ORDER_DATA: 'Datos del pedido',
  SHOW_SUMMARY: 'Ver resumen',
  NOT_POSSIBLE_CREATING_NEW_APPLICATION: 'No es posible crear nueva solicitud',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_AMOUNT: 'No hay métodos de pago disponibles para el importe de la solicitud',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_USER: 'Tu usuario no dispone de métodos de pago activados.',
  NO_PAYMENT_METHODS_AVAILABLE_FOR_SELECTED_AGENT: 'El agente seleleccionado no dispone de métodos de pago activados.',
  CONTACT_NEMURU_FOR_SERVICE_ACTIVATION_OR_ERROR: (
    <>
      {
        'Si quieres activar este servicio o crees que es un error, por favor ponte en contacto con nosotros escribiéndonos a '
      }
      <a href="mailto:hola@nemuru.com">{'hola@nemuru.com'}</a>
      {'.'}
    </>
  ),

  // IBERIA CARDS APPLICATION
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SALE_POINT_AND_PRODUCT}`]: 'Nueva alta de tarjeta',
  [`APPLICATION_IBERIA_CARDS_STEP_${ApplicationIberiaCardsStep.SHORT_CONTACT_FORM}`]: 'Datos de contacto del titular',
  CARD_AND_CAMPAIGN: 'Tarjeta / Campaña',
  IBERIA_CARDS_CAMPAIGN_GROUP_INDIVIDUALS: 'Particulares',
  IBERIA_CARDS_CAMPAIGN_GROUP_IBERIA_EMPLOYEES: 'Empleados Iberia',
  IBERIA_CARDS_CAMPAIGN_GROUP_CORPORATE_GROUPS: 'Colectivos',
  MOBILE_PHONE_NUMBER: 'Número de teléfono móvil',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED: 'Tu usuario no está configurado para operar en stands.',
  IBERIA_CARDS_STANDS_AGENT_NOT_CONFIGURED_DESCRIPTION:
    'Contacta con tu supervisor para que te habilite los puntos de venta.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE: 'La creación de solicitudes no está disponible para tu usuario.',
  IBERIA_CARDS_APPLICATION_NOT_AVAILABLE_DESCRIPTION:
    'Solo los agentes de stands pueden crear solicitudes de tarjeta. Si crees que deberías tener acceso, contacta con tu supervisor.',
  IBERIA_CARDS_STANDS_SALE_POINT_AND_PRODUCT_INTRO: 'Confirma el punto de venta y el producto a contratar.',
  IBERIA_CARDS_STANDS_SHORT_CONTACT_FORM_INTRO:
    'Introduce los datos personales del titular exactamente como aparecen en su documento de identidad.',
  IBERIA_CARDS_STANDS_DOCUMENT_MATCH_HINT: 'igual que en el DNI/NIE',
  IBERIA_CARDS_STANDS_DOCUMENT_NUMBER: 'DNI/NIE',
  IBERIA_CARDS_DATA_PROTECTION_OPT_IN: (
    <>
      {'Confirmo que Iberia Cards ha puesto a mi disposición la información básica sobre la '}
      <Link
        href="https://www.iberiacards.es/proteccion-datos/"
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="always"
      >
        <strong>{'Protección de Datos'}</strong>
      </Link>
      {' y, en concreto, sobre los tratamientos de mis datos que se realizarán en el proceso de contratación.'}
    </>
  ),

  // AGENT SELECTION
  SALES_PROFILE: 'Perfil de ventas',
  SALES_PROFILE_SELECT: 'Asigna un vendedor para este pedido',
  SEARCH_BY_NAME: 'Buscar por nombre...',
  SELECT_AN_AGENT: 'Seleccionar un agente',
  SELECT_A_CHANNEL: 'Seleccionar un canal',
  SELECT_A_MERCHANT: 'Seleccionar un merchant',
  // -- ALREADY EXISTS -- CHANNEL: 'Channel',
  NO_AGENTS_AVAILABLE: 'No hay agentes disponibles',
  SELECT_NEW_AGENT: 'Seleccionar nuevo agente',
  SELECT_NEW_AGENT_NOTICE: '¿Deseas seleccionar un nuevo agente? Se perderán los datos introducidos en la solicitud.',

  //CUSTOMER CONTACT DATA:
  CUSTOMER_CONTACT_DATA: 'Datos del cliente',
  FILL_CUSTOMER_CONTACT_DATA: 'Rellena el formulario con los datos del cliente',
  CUSTOMER_NAME: 'Nombre del cliente',
  REFERENCES_SUBTITLE:
    'Introduce la referencia del pedido en tu sistema. No se puede utilizar una referencia que ya haya sido usada previamente.',

  //AUTO DETAILS
  LAST_VEHICLES: 'Últimos vehículos',
  AUTO_DETAILS_DESCRIPTION: 'Introduce los datos del vehículo a financiar',
  VEHICLE_CONDITION: 'Tipo de vehículo',
  NEW_VEHICLE_CONDITION: 'Nuevo',
  USED_VEHICLE_CONDITION: 'Ocasión',
  VEHICLE_MODEL_SECTION: 'Modelo',
  VEHICLE_USAGE_AND_IDENTIFICATION_SECTION: 'Uso e identificación',
  VEHICLE_IDENTIFICATION_SECTION: 'Identificación',
  EUROTAX_CODE_HINT: 'Código Eurotax $v1',
  NEW_VEHICLE_PLATE_NUMBER_HINT: 'Si ya está matriculado',
  NEW_VEHICLE_IDENTIFICATION_NUMBER_HINT: 'Si aún no lo tienes, se puede añadir más adelante',
  IDENTIFICATION_NUMBER_ALREADY_USED_HINT: 'Ya existe una solicitud con este bastidor',
  MODEL_DATE_SUFFIX_TOOLTIP:
    'El número final indica el año y mes del modelo (AAAAMM). Por ejemplo, 201607 es el modelo de julio de 2016.',
  VERSION_DATE_SUFFIX_TOOLTIP:
    'El número final indica el año y mes de la versión (AAAAMM). Por ejemplo, 201607 es la versión de julio de 2016.',
  PREVIOUS_VALUE: 'Antes: $v1',
  VEHICLE_CONDITION_NOT_EDITABLE: 'No se puede cambiar en una solicitud ya creada',
  FINANCING_RESELECTION_REQUIRED: 'Hay que elegirla de nuevo',
  FINANCING_RESELECTION_REQUIRED_DESCRIPTION:
    'Cambiar el importe o la fecha de matriculación invalida la cuota actual ($v1, $v2 meses).',
  LOADING_AUTO_DETAILS: 'Cargando datos del vehículo...',
  // Cart
  // -- ALREADY EXISTS -- ORDER_LINES: 'Ítems del pedido',
  CART_TEXT: 'Completa los ítems del carrito',
  CART_TEXT_KTUIN: 'Selecciona el producto y el importe a financiar',
  ORDER_REFERENCE_1_TOOLTIP:
    'Referencia en tu sistema para este pedido. No se puede utilizar una referencia que ya haya sido usada previamente en una sesión de pago confirmada.',
  ORDER_REFERENCE: 'Referencia',
  ORDER_REFERENCE_DETAILS: 'Referencia en tu sistema para este pedido',
  REFERENCE_NOT_VALID: 'Esta referencia ha sido usada previamente',
  ORDER_REFERENCE_1: 'Referencia del pedido',
  ORDER_REFERENCE_2: 'Referencia del pedido 2',
  ORDER_REFERENCE_LABEL: 'Referencia pedido',
  DISABLED_TOOLTIP_CART_ERROR: 'Para continuar, revisa el carrito. Está incompleto o con errores.',
  DISABLED_TOOLTIP_REFERENCE_ERROR: 'Para continuar, revisa la referencia del pedido 1.',
  DISABLED_TOOLTIP_REFERENCE_AND_CART_ERROR: 'Para continuar, revisa la referencia del pedido 1 y el carrito.',

  // -- ALREADY EXISTS -- UNITS: 'Unidades',
  UNITS_SHORT: 'Uds.',
  UNIT_PRICE: 'Precio',
  // -- ALREADY EXISTS -- UNIT_PRICE_WITH_TAX: 'Precio unitario con IVA incluido',
  VAT_TOOLTIP: 'En caso de ser operativa en las Islas Canarias se consideraría IGIC',
  ADD_NEW_ITEM: 'Añadir ítem',
  NEW_ITEM: 'Nuevo ítem',
  EDIT_ITEM: 'Editar ítem',
  DELETE_ITEM: 'Eliminar ítem',
  SUBTOTAL: 'Subtotal',
  // -- ALREADY EXISTS -- TOTAL: 'Total',
  // -- ALREADY EXISTS -- VAT_AMOUNT: 'Importe IVA',
  TOTAL_PRICE: 'Total',
  TOTAL_PRICE_WITH_TAX: 'Importe total (precio unitario x unidades) con IVA incluido',
  TOTAL_PRICE_WITH_INFO: 'Incl. impuestos y descuentos',
  ACCEPT: 'Aceptar',
  IN: 'en',
  OR: 'o',

  // Cart Dialog
  ARTICLE_INFORMATION: 'Datos del artículo',
  ARTICLE_TYPE: 'Tipo de artículo',
  SAVE_AND_NEW_ITEM: 'Guardar y añadir nuevo ítem',
  CART_DIALOG_CANCEL_CONFIRM: '¿Estás seguro de que deseas cerrar la ventana?',
  CART_DIALOG_CANCEL_CONFIRM_TEXT: 'Los cambios introducidos se perderán',
  CART_DIALOG_SUCCESS: 'Se ha actualizado correctamente el item',
  // -- ALREADY EXISTS -- SAVE: 'Guardar',
  [ArticleType.FLIGHT]: 'Vuelo',
  [ArticleType.ACCOMMODATION]: 'Alojamiento',
  [ArticleType.SERVICE]: 'Servicio',
  [ArticleType.ONLINE_PRODUCT]: 'Producto',
  [ArticleType.AUTOMOBILE]: 'Automóvil',
  [ArticleTypeExternal.PRODUCT]: 'Producto',

  // Product
  PRODUCT_DETAILS: 'Detalles del producto',
  ARTICLE_DESCRIPTION: 'Descripción del producto',
  ARTICLE_CATEGORY: 'Categoría',
  [`ARTICLE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'Físico',
  [`ARTICLE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_CATEGORY_${ArticleCategory.DISCOUNT}`]: 'Descuento',
  [`ARTICLE_CATEGORY_${ArticleCategory.SHIPPING_FEE}`]: 'Coste de envío',
  [`ARTICLE_CATEGORY_${ArticleCategory.GIFT_CARD}`]: 'Tarjeta regalo',

  // Service
  SERVICE_DETAILS: 'Detalles del servicio',
  SERVICE_DESCRIPTION: 'Descripción del servicio',
  SERVICE_ENDS_ON: 'Fecha fin del servicio',
  ARTICLE_SERVICE_CATEGORY: 'Categoría',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.DIGITAL}`]: 'Digital',
  [`ARTICLE_SERVICE_CATEGORY_${ArticleCategory.PHYSICAL}`]: 'Presencial',

  // Accomodation
  // -- ALREADY EXISTS -- ACCOMMODATION: 'Alojamiento',
  ACCOMMODATION_NAME: 'Nombre del alojamiento',
  ACCOMMODATION_NAME_PLACEHOLDER: 'Hotel Boutique Chaplin',
  ACCOMMODATION_DETAILS: 'Detalles del alojamiento',
  CHECKIN_DATE: 'Fecha entrada',
  CHECKOUT_DATE: 'Fecha salida',

  // Flight
  FLIGHT_DETAILS: 'Detalles del vuelo',
  FLIGHT_ONE_WAY: 'Sólo ida',
  FLIGHT_OUTBOUND: 'Ida',
  FLIGHT_INBOUND: 'Vuelta',
  FLIGHT_REFERENCE: 'Referencia del vuelo',
  FLIGHT_REFERENCE_PLACEHOLDER: 'VY6760',
  DEPARTURE_AIRPORT: 'Aeropuerto salida (IATA)',
  DESTINATION_AIRPORT: 'Aeropuerto llegada (IATA)',
  DATE: 'Fecha',
  IS_ROUND_TRIP: 'Ida y vuelta',
  PASSENGERS_DETAILS: 'Detalles de los pasajeros',
  PASSENGER_DOCUMENT_NUMBER: 'Número documento pasajero #$v1',
  ADD_ANOTHER_PASSENGER: 'Añadir otro pasajero',

  // Travel
  TRAVEL_DETAILS: 'Detalles del viaje',
  TRAVEL_DESTINATION: 'Destino',
  TRAVEL_DESTINATION_PLACEHOLDER: 'Egipto',
  TRAVEL_DESCRIPTION: 'Descripción',
  TRAVEL_DESCRIPTION_PLACEHOLDER: 'Ruta por las Pirámides de Giza',
  [`TRAVEL_CATEGORY_${TravelCategory.SENIOR_TRAVEL_PROGRAMS}`]: 'Programas senior',
  [`TRAVEL_CATEGORY_${TravelCategory.BUS}`]: 'Autobús',
  [`TRAVEL_CATEGORY_${TravelCategory.CIRCUITS}`]: 'Circuitos',
  [`TRAVEL_CATEGORY_${TravelCategory.CARS}`]: 'Coches',
  [`TRAVEL_CATEGORY_${TravelCategory.CRUISE}`]: 'Crucero',
  [`TRAVEL_CATEGORY_${TravelCategory.DISNEY}`]: 'Disney',
  [`TRAVEL_CATEGORY_${TravelCategory.TICKETS}`]: 'Tickets',
  [`TRAVEL_CATEGORY_${TravelCategory.EXCURSIONS}`]: 'Excursiones',
  [`TRAVEL_CATEGORY_${TravelCategory.FERRY}`]: 'Ferris',
  [`TRAVEL_CATEGORY_${TravelCategory.GRAND_TOURS}`]: 'Grandes Tours',
  [`TRAVEL_CATEGORY_${TravelCategory.PACKAGE}`]: 'Pack',
  [`TRAVEL_CATEGORY_${TravelCategory.INSURANCE}`]: 'Seguro',
  [`TRAVEL_CATEGORY_${TravelCategory.THEMATIC}`]: 'Temático',
  [`TRAVEL_CATEGORY_${TravelCategory.TRANSFERS}`]: 'Transfers',
  [`TRAVEL_CATEGORY_${TravelCategory.TRAINS}`]: 'Trenes',
  [`TRAVEL_CATEGORY_${TravelCategory.OTHER}`]: 'Otros',
  TRAVEL_TRAVELLERS: 'Número de viajeros',

  // Cart Validation
  REFERENCE_CHARACTER_NOT_ALLOWED: 'Los únicos carácteres especiales permitidos son /, \\, -, _, + y @.',
  AMOUNT_MUST_BE_NEGATIVE: 'El importe debe ser negativo',
  AMOUNT_MUST_BE_POSITIVE: 'El importe debe ser positivo',
  VALUE_MUST_BE_POSITIVE: 'El valor debe ser positivo',
  DOWN_PAYMENT_AMOUNT_MUST_BE_LESS_THAN_CART_AMOUNT:
    'El importe de la entrada debe ser menor que el importe del carrito',
  AMOUNT_NOT_ZERO: 'El importe debe ser distinto a 0',
  MORE_THAN_ONE_UNIT_ERROR: 'Artículo limitado a 1 unidad',
  AT_LEAST_ONE_UNIT_ERROR: 'Mínimo 1 unidad',
  INVALID_PERCENTAGE: 'Porcentaje no válido',
  INVALID_NEGATIVE_PERCENTAGE: 'Porcentaje negativo no es válido',
  PAST_DATE_NOT_ALLOWED: 'Fecha pasada no permitida',
  FUTURE_DATE_NOT_ALLOWED: 'Fecha futura no permitida',
  CHECKOUT_DATE_CANNOT_BE_PRIOR_TO_CHECKIN_DATE:
    'La fecha de salida no puede ser anterior o igual a la fecha de entrada',
  RETURN_DATE_CANNOT_BE_PRIOR_TO_DEPARTURE_DATE:
    'La fecha del vuelo de ida no puede ser anterior o igual a la fecha del vuelo de vuelta',
  END_DATE_CANNOT_BE_PRIOR_TO_START_DATE: 'La fecha de inicio no puede ser anterior o igual a la fecha de finalización',
  FLIGHT_REFERENCE_SHOULD_HAVE_AT_LEAST_3_CHARACTERS:
    'El código de referencia del vuelo debe tener al menos 3 caracteres',
  FLIGHT_REFERENCE_SHOULD_HAVE_MAX_8_CHARACTERS: 'El código de referencia del vuelo no puede tener más de 8 caracteres',
  DOCUMENT_NUMBER_SHOULD_HAVE_AT_LEAST_4_CHARACTERS: 'El número de documento debe tener al menos 4 caracteres',
  DOCUMENT_NUMBER_SHOULD_HAVE_MAX_15_CHARACTERS: 'El número de documento no puede tener más de 15 caracteres',
  AT_LEAST_ONE_TRAVELLER_ERROR: 'Mínimo 1 pasajero',

  // Cart Alerts
  CART_ALERT_ARTICLE_TOTAL: (
    <>
      El total del carrito debe ser <strong>positivo</strong>. Revisa el importe de tus productos y descuentos.
    </>
  ),
  CART_ALERT_ARTICLE_INCOMPLETE: (
    <>
      Alguno de los elementos del carrito está <strong>incompleto</strong>. Revisa los detalles de cada línea del
      carrito.
    </>
  ),
  CART_ALERT_ITEM_ERROR: (
    <>
      El carrito o algunos de sus items tienen un <strong>error</strong>. Revisa para continuar.
    </>
  ),
  CART_ALERT_ARTICLE_CATEGORY: (
    <>
      No hay ningún producto con categoría <strong>física</strong> o <strong>digital</strong>. Por favor, revisa las
      categorías de los productos introducidos.
    </>
  ),
  CART_ALERT_ARTICLE_TYPE_START: 'Es necesario incluir al menos un ítem de tipo',
  CART_ALERT_ARTICLE_TYPE_END: 'para poder continuar',
  CART_ALERT_ARTICLE_TYPE_SERVICE_ADDITIONAL: 'Sólo se permite 1 servicio por pedido.',
  CART_ALERT_ARTICLE_TYPE_AUTO_ADDITIONAL: 'Sólo se permite 1 vehículo por pedido.',
  CART_ALERT_PAYMENT_METHODS: 'No hay métodos de pago disponibles para el importe del carrito.',
  CART_ALERT_AGENT_CONFIGURATION: (
    <>
      Parece que el agente necesita <strong>sincronizar la configuración de métodos de pago</strong>. Por favor,
      contacta con <a href="mailto:hola@nemuru.com">hola@nemuru.com</a> informando de este problema.
    </>
  ),

  // Application Payment method
  // -- ALREADY EXISTS -- PAYMENT_METHOD: 'Método de pago'
  PAYMENT_METHOD_INSTRUCTIONS: 'Habilita los métodos de pago para la compra de tu cliente',
  PAYMENT_PROPOSAL_DETAILS: 'Detalles de la solicitud de pago',

  // Application Distribution
  APPLICATION_DISTRIBUTION_TITLE: 'Distribución del enlace de pago',
  APPLICATION_DISTRIBUTION_INSTRUCTIONS: 'Comparte el enlace de pago con tu cliente',
  APPLICATION_DISTRIBUTION_DETAILS:
    'Envía el enlace por email o SMS, mostra un QR o copia y distribuye el enlace por tus canales',
  SMS: 'SMS',
  SEND_LINK: 'Enviar enlace',
  APPLICATION_SUCCESS_MESSAGE: (
    <>
      La solicitud ha sido enviada a tu cliente mediante el/los métodos de envio escogidos. Recuerda que dispone de{' '}
      <strong>30&nbsp;días</strong> para acceder al enlace y realizar el proceso de pago. Pasado ese tiempo, el enlace
      caducará.
    </>
  ),
  APPLICATION_DISTRIBUTION_ALERT: 'Tu cliente dispone de 30 días para acceder y completar el pago de la primera cuota.',

  // NEW CHECKOUT SESSION APPLICATION :
  SELECTED: 'Seleccionado',
  FOR: 'Por',
  AND: 'Y',
  LOWERCASE_AND: 'y',
  FROM_AMOUNT: 'Desde',
  CONFIGURE: 'Configurar',
  PAYMENT_METHODS_TITLE: 'Métodos de pago',
  PAYMENT_METHODS_TEXT: 'Configura los métodos de pago disponibles para tu cliente',
  SEE_FILTERS: 'Ver filtros',
  QUOTA: 'Cuota',
  SETUP_FEE_SHORT: 'Gastos',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: 'Gastos (financiada)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: 'Gastos (fija/cuota)',
  [`SETUP_FEE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: 'Gastos (apertura)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FINANCED}`]: '(financiados)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_FIXED_AMOUNT}`]: '(fijos/cuota)',
  [`SETUP_FEE_TYPE_SHORT_${FeePaymentType.TYPE_UPFRONT}`]: '(apertura)',
  MERCHANT_COST: 'Coste comercio',
  MERCHANT_COST_SHORT: 'Coste',
  FREE: 'Gratis',
  CONDITIONS_GROUP_NOT_FOUND_START:
    'No hay opciones disponibles para el plazo seleccionado. Para los filtros seleccionados, los plazos disponibles van entre los',
  [FilterType.WITH_GRACE_PERIOD]: 'Con carencia',
  [FilterType.WITH_MERCHANT_DISCOUNT_PERCENTAGE]: 'Con coste comercio',
  [FilterType.WITH_SETUP_FEE]: 'Con gastos cliente',
  VALUE_MUST_BE_BETWEEN: 'El valor debe estar entre',
  START_PAYMENT_METHOD: 'Iniciar método de pago',
  START_PAYMENT_METHOD_DESCRIPTION: 'Haz click en el botón para iniciar este método de pago.',
  CREDIT_CARD_START_PAYMENT_METHOD: 'Iniciar contratación',
  CREDIT_CARD_START_PAYMENT_METHOD_DESCRIPTION:
    'Haz click en el botón para iniciar el proceso de contratación de la tarjeta Iberia Cards.',

  //CHECKOUT SESSION CREATION
  CHECKOUT_SESSION_CREATION: 'Completa el proceso de pago',
  CHECKOUT_SESSION_CREATION_DESCRIPTION: 'Selecciona cómo quieres completar el proceso de pago',
  COMPLETE_PAYMENT_PROCESS: 'Completa el proceso de pago',
  SELECT_HOW_TO_COMPLETE_PAYMENT_PROCESS: 'Selecciona cómo quieres completar el proceso de pago',
  SEND_TO_MY_CLIENT: 'Enviar a mi cliente',
  SHARE_PAYMENT_LINK: 'Compartir enlace de solicitud',
  SHARE_PAYMENT_LINK_WITH_YOUR_CLIENT:
    'Comparte el enlace de pago con tu cliente. Tu cliente llevará a cabo el proceso de pago desde su dispositivo.',
  START_MERCHANT_POS_PROCESS: 'Iniciar el proceso',
  MERCHANT_POS_PROCESS_DESCRIPTION:
    'Completa el proceso de pago en nombre de tu cliente. Al hacer click en continuar, consientes y afirmas que tu cliente se encuentra en el punto de venta y que su identidad ha sido validada.',
  START_NOW: 'Iniciar ahora',
  LOADING_CHECKOUT_SESSION_CREATION: 'Creando la solicitud de pago...',
  LOADING_CHECKOUT_SESSION_RESTORING: 'Recuperando datos de la solicitud de pago...',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_PAYMENT_METHODS_DESCRIPTION:
    'Los métodos de pago seleccionados no permiten completar el proceso de pago en nombre de tu cliente.',
  MERCHANT_POS_PROCESS_NOT_ALLOWED_BY_AGENT_DESCRIPTION:
    'La configuración del agente seleccionado para la solicitud no permite completar el proceso de pago en nombre de tu cliente.',
  FILL_IN_INTERVENERS_DATA: 'Rellena la información del titular (y otros intervinientes)',
  FILL_IN_INTERVENER_DATA: 'Rellena la información del $v1',
  INTERVENERS: 'Intervinientes',
  DOCUMENT_ID_FORM_INFO:
    'Más adelante, deberás subir una foto del documento de identidad del cliente. Asegúrate de que los datos introducidos a continuación coincidan con la información que aparece en dicho documento.',
  NET_INCOME_FORM_INFO:
    'Por favor, declara los ingresos reales del $v1. Será necesario aportar un justificante de ingresos, como una nómina, pensión u otro documento válido, para confirmar esta información',
  BANK_ACCOUNT_FORM_INFO:
    'Recuerda que el titular debe figurar como titular de la cuenta bancaria. Se solicitará un justificante de titularidad más adelante para confirmar la veracidad de la información',
  RECENT_BORROWERS: 'Últimos intervinientes',

  // OPT IN EMAIL
  OPT_IN_EMAIL: 'Aceptación de condiciones',
  OPT_IN_EMAIL_SUBTITLE:
    'Para aceptar las condiciones de uso de la plataforma. Es necesario que acceda al enlace que contiene el email para que las acepte y se pueda continuar con el proceso de pago.',
  OPT_IN_WAITING_FOR_ACCEPTANCE_TITLE: 'Esperando aceptación de condiciones...',
  OPT_IN_WAITING_FOR_ACCEPTANCE_DESCRIPTION: 'Esta ventana se cerrará automáticamente cuando acepte las condiciones.',
  OPT_IN_EMAIL_SENT_TO: 'Email enviado a',
  RESEND_EMAIL: 'Reenviar email',
  RESEND_EMAIL_IN: 'Reenviar en $v1 segundos',

  //CHECKOUT SESSION DETAILS (MERCHANT)
  [`${PaymentMethodType.A2A_PAYMENT}_tab_label`]: 'Transferencia inmediata',
  [`${PaymentMethodType.B2B_LOAN}_tab_label`]: 'Préstamo B2B',
  [`${PaymentMethodType.BNPL_INSTALMENTS}_tab_label`]: 'Pago en cuotas',
  [`${PaymentMethodType.BNPL_SPLIT_PAY}_tab_label`]: 'Fracciona el pago',
  [`${PaymentMethodType.CONSUMER_LOAN_INSTALMENTS}_tab_label`]: 'Financiación',
  [`${PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY}_tab_label`]: 'Financiación sin intereses',
  [`${PaymentMethodType.CARD_PAYMENT}_tab_label`]: 'Pago con tarjeta',
  [`${PaymentMethodType.SUBSCRIPTION}_tab_label`]: 'Suscripción',
  [`${PaymentMethodType.CREDIT_LINE}_tab_label`]: 'Línea de crédito',
  [`${PaymentMethodType.AUTO_LOAN}_tab_label`]: 'Préstamo auto',
  [`${PaymentMethodType.CREDIT_CARD}_tab_label`]: 'Tarjeta de crédito',
  [`${PaymentMethodType.CARD_ONBOARDING}_tab_label`]: 'Tarjeta de crédito',

  NEXT_STEPS: 'Próximos pasos',
  EDIT_BORROWER: 'Editar titular',
  EDIT_CO_BORROWER: 'Editar cotitular',
  EDIT_DATA: 'Editar datos',
  [`ADD_${OnboardingDetailsRole.CO_BORROWER}`]: 'Añadir cotitular',
  [`ADD_${OnboardingDetailsRole.GUARANTOR}`]: 'Añadir avalista',
  INVALID_PROGRESS: 'Progreso no disponible',
  ALL_ACTIONS_COMPLETED: 'Todas las acciones completadas',
  SEE_PROGRESS_HISTORY: 'Ver historial completo',
  SEE_PROGRESS_HISTORY_MOBILE: 'Historial',
  UPLOAD: 'Subir',
  SEE_CLIENT_HISTORY: 'Ver historial',
  CLIENT_HISTORY: 'Historial de $v1',
  SIGNATURE_LENDER_CONTRACT: 'Contrato de $v1',
  SIGNATURE_LENDER_CONTRACT_SANTANDER: 'Redirección a Santander',
  SIGN_CONTRACT: 'Firmar',
  SIGN_BORROWER_CONTRACT: 'Firma titular',
  SIGN_CO_BORROWER_CONTRACT: 'Firma cotitular',
  CONTRACT_SIGNED_SUCCESSFULLY: 'Contrato firmado correctamente',
  CONTRACT_SIGNED_SUCCESSFULLY_DESCRIPTION:
    'El contrato con la entidad financiera ha sido firmado digitalmente de forma correcta. Ya puedes cerrar esta ventana de forma segura.',

  SIGNATURE_GENERIC_MESSAGE: 'Haz click en firmar para iniciar el proceso de firma. ',
  REDIRECT_SIGNATURE_BS:
    'Antes de poder firmar el contrato, tu cliente debe descargar la información del crédito que recibirá mediante un SMS. Una vez completado este paso, podrás firmar digitalmente el contrato.',
  REDIRECT_SIGNATURE_SANTANDER:
    'Haz click en completar, para ser redirigido a la plataforma de Santander Consumer Finance, donde podrás completar la solicitud de financiación de tu cliente.',
  REDIRECT_SIGNATURE:
    'Haz click en firmar para ser redirigido al proceso de firma digital. Tu cliente recibirá un SMS con el código que deberás introducir para completar la firma.',
  EMBEDDED_REDIRECT_SIGNATURE:
    'Haz click en firmar para abrir el proceso de firma digital. Tu cliente recibirá un SMS con el código que deberás introducir para completar la firma.',
  SAML_SIGNATURE:
    'Haz click en firmar para iniciar el proceso de firma. Tu cliente recibirá un SMS con el código que deberás introducir para completar la firma.',
  ASYNC_SIGNATURE_EMAIL:
    'El cliente recibirá próximamente un correo electrónico con las instrucciones para firmar el contrato. Puede indicarle que esté atento a su bandeja de entrada y revise también la carpeta de spam o promociones.',
  ASYNC_SIGNATURE_SMS:
    'El cliente recibirá un SMS con un enlace para poder firmar el contrato. Puede indicarle que revise su teléfono para completar el proceso.',
  SIGNATURE_FROM_CAIXABANK_APP_MESSAGE:
    'La firma de este contrato debe realizarse desde la app de firma de CaixaBank P&C. Accede a la app desde tu dispositivo y facilita la firma al cliente.',
  RESIGNATURE_MESSAGE:
    'El contrato requiere una nueva firma. Haz clic en refirmar para iniciar el proceso de firma digital.',
  RESIGNATURE_CONTRACT: 'Refirmar',
  LOAN_RETENTION_INTERNAL_REVIEW: 'Solicitud en revisión interna por la entidad financiera',
  LOAN_RETENTION_CONTRACT_RESIGNATURE: 'El contrato requiere volver a ser firmado',
  LOAN_RETENTION_DOCS_INCIDENCE: 'Hay incidencias documentales que deben solventarse',

  NO_CONDITIONS_AVAILABLE: 'Oops! No hay condiciones disponibles',
  NO_CONDITIONS_AVAILABLE_DESCRIPTION:
    'Parece que este método de pago no tiene condiciones disponibles para esta compra. Por favor, selecciona otro método de pago o ponte en contacto con tu agente para que pueda ayudarte.',
  IN_ONE_CARD_PAYMENT: 'en un único pago con tarjeta',
  IN_ONE_A2A_PAYMENT: 'en un único pago con transferencia bancaria',

  MORE_ACTIONS: 'Más acciones',
  AVAILABLE: 'Disponible',
  NOT_AVAILABLE: 'No disponible',
  NOT_STARTED: 'No iniciado',

  //MERCHANT POS FORM
  ID_ALREADY_USED: 'Número de documento ya usado',
  FULL_NAME_ALREADY_USED: 'Nombre y apellidos ya usados',
  EMAIL_ALREADY_USED: 'Email ya usado',
  PHONE_NUMBER_ALREADY_USED: 'Número de teléfono ya usado',
  BORROWER_MARITAL_STATUS_DIFFERENT_TO_MARRIED: 'Estado civil del titular no permite esta relación',
  CO_BORROWER_MARITAL_STATUS_DIFFERENT_TO_MARRIED: 'El estado civil seleccionado no premite esta relación',

  // DISTRIBUTION DIALOG
  SHARE_PAYMENT_LINK_DESCRIPTION: 'Escoge cómo quieres compartir el enlace de solicitud con tu cliente:',
  [DistributionMethod.COPY_LINK]: 'Copiar enlace',
  [DistributionMethod.SEND_LINK]: 'Enviar enlace',
  [DistributionMethod.SHOW_QR]: 'Mostrar QR',
  [`${DistributionMethod.COPY_LINK}_SHORT`]: 'Copiar',
  [`${DistributionMethod.SEND_LINK}_SHORT`]: 'Enviar',
  [`${DistributionMethod.SHOW_QR}_SHORT`]: 'QR',
  SHARE: 'Compartir',
  SHARE_WITH_CUSTOMER: 'Compartir enlace',
  SENT_TO: 'Enviado a',
  SENT_AT_TIME: 'Fecha de envío',
  VIEWED_AT: 'Abierto',
  SENDING: 'Enviando...',
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION:
    'Se ha alcanzado el límite máximo de envíos del enlace de pago disponibles. Puedes copiar el enlace y enviarlo por otros canales, o mostrar el código QR a tu cliente.',
  MAX_DISTRIBUTIONS_ALERT_DESCRIPTION_CREDIT_CARD:
    'Se ha alcanzado el límite máximo de envíos del enlace de pago disponibles.',
  AN_ERROR_OCURRED: 'Ocurrió un error',
  SEE_DISTRIBUTIONS: 'Ver envíos',
  DISTRIBUTIONS_HISTORY: 'Historial de envíos',
  DISTRIBUTIONS_HISTORY_DESCRIPTION: 'Aquí puedes ver el historial de envíos del enlace a esta solicitud de pago.',

  // CHECKOUT SESSION DETAILS
  CHECKOUT_SESSIONS: 'Solicitudes',
  CHECKOUT_SESSION: 'Solicitud',
  SESSIONS: 'Sesiones',
  CHECKOUT_SESSIONS_OVERVIEW: 'Vista general solicitudes',
  CHECKOUT_SESSION_DETAIL: 'Detalle de la solicitud',
  CHECKOUT_SESSION_DETAILS: 'Detalles de la solicitud',
  CHECKOUT_SESSION_OVERVIEW: 'Resumen',
  CHECKOUT_SESSION_ID: 'Id solicitud:',
  CANCEL_CHECKOUT_SESSION: 'Cancelar solicitud de pago',
  CANCEL_CHECKOUT_SESSION_SHORT: 'Cancelar solicitud',
  CANCEL_CHECKOUT_SESSION_DESCRIPTION: '¿Deseas cancelar la solicitud de pago de tu cliente?',
  [DownPaymentCollection.NONE]: 'None',
  [DownPaymentCollection.BEFORE_CONFIRM]: 'Before confirm',
  [DownPaymentCollection.UPFRONT]: 'Upfront',
  PURCHASE_COUNTRY: 'País de compra:',
  EXPIRES_IN: 'Caduca en:',
  CONTACT_DATA: 'Datos de contacto',
  OWNER: 'Titular',
  ACTIVE_PAYMENT_METHODS: 'Métodos de pago habilitados',
  PAYMENT_INTENTS: 'Solicitudes de pago',
  PAYMENT_INTENTS_LIST_TITLE: 'Intentos de pago',
  NO_PAYMENT_INTENTS: 'Todavía no se han generado solicitudes de pago',
  ARTICLE_IN_CART: '$v1 x $v2',
  TOTAL_TO_FINANCE: 'Total a financiar',
  TOTAL_TO_PAY: 'Total a pagar',
  [HppStatus.COMPLETED]: 'Completada',
  [HppStatus.CHALLENGE]: 'Challenge',
  SELECTED_PAYMENT_METHOD: 'Método de pago seleccionado',
  OTHER_PAYMENT_METHODS: 'Otros métodos de pago',
  CHALLENGE: 'Acción requerida',

  // CHECKOUT SESSION DETAIL - EDIT
  EDIT_CHECKOUT_SESSION_ACTION_CART: 'Editar carrito',
  EDIT_CHECKOUT_SESSION_ACTION_CART_AUTO: 'Editar vehículo',
  EDIT_CHECKOUT_SESSION_ACTION_DOWN_PAYMENT: 'Editar entrada',
  EDIT_LEAVE_ALERT_TITLE: 'Abandonar edición',
  EDIT_LEAVE_ALERT_DESCRIPTION: 'Atención, si cierras el diálogo, las modificaciones se perderán.',
  EDIT_PAYMENT_METHOD_CONDITIONS: 'Editar configuración del método de pago',
  EDIT_PAYMENT_METHOD_CONDITIONS_INSTRUCTIONS:
    'Selecciona una nueva configuración para el método de pago de tu cliente:',
  CART_EDIT: 'Editar carrito',
  CART_EDIT_INSTRUCTIONS: 'Edita los detalles del carrito de la solicitud:',
  EDIT_AUTO_PAYMENT_METHOD: 'Editar datos de solicitud',
  EDIT_VEHICLE_DATA: 'Editar vehículo',
  SPECS_TAB: 'Vehículo',
  FINANCING_TAB: 'Financiación',
  VEHICLE_AMOUNT_REQUIRES_FINANCING_RESELECTION_DESCRIPTION:
    'El importe y/o la fecha de matriculación del vehículo ha cambiado. En el siguiente paso deberás seleccionar nuevas condiciones de financiación en el simulador.',
  LIVE_SUMMARY: 'Resumen',
  BORROWER_SUMMARY: 'Detalles del titular',
  FINANCING_SUMMARY: 'Financiación',
  EDIT_VEHICLE_DATA_IN_LENDER_PLATFORM:
    'La entidad financiera no permite modificar los datos del vehículo desde nuestra plataforma. Por favor, accede a la plataforma de $v1 para realizar los cambios. Disculpa las molestias',
  MISSING_VEHICLE_DATA_WARNING: 'Faltan datos del vehículo necesarios para firmar el contrato',
  SIGNATURE_MISSING_VEHICLE_DATA_EDITABLE:
    'Para firmar el contrato, completa los datos del vehículo. Debes **LINK**editar los datos del vehículo**LINK**.',
  SIGNATURE_MISSING_VEHICLE_DATA_NOT_EDITABLE: 'Los datos del vehículo no pueden modificarse desde nuestra plataforma.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_PLATFORM:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado el número de bastidor (VIN) y la matrícula para la firma. Puedes hacerlo desde el menú "Editar" en la parte superior derecha.',
  MISSING_VEHICLE_DATA_WARNING_EDIT_IN_LENDER:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado el número de bastidor (VIN) y la matrícula para la firma. Si no lo has introducido de inicio debes realizar la modificación en el aplicativo de la entidad financiera',
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_PLATFORM:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado el número de bastidor (VIN) para la firma. Puedes hacerlo desde el menú "Editar" en la parte superior derecha.',
  MISSING_VEHICLE_REGISTRATION_NUMBER_WARNING_EDIT_IN_LENDER:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado el número de bastidor (VIN) para la firma. Si no lo has introducido de inicio debes realizar la modificación en el aplicativo de la entidad financiera.',
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_PLATFORM:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado la matrícula para la firma. Puedes hacerlo desde el menú "Editar" en la parte superior derecha.',
  MISSING_VEHICLE_LICENSE_PLATE_WARNING_EDIT_IN_LENDER:
    'Recuerda que en el momento de realizar la firma del contrato es necesario haber informado la matrícula para la firma. Si no lo has introducido de inicio debes realizar la modificación en el aplicativo de la entidad financiera',
  CHANGE_DATA: 'Modificar datos',
  REQUEST_TO_LENDER_DELAY_WARNING:
    'Esta operación puede tardar unos segundos en completarse. Por favor, espera mientras comunicamos los cambios con la entidad financiera...',
  AUTO_MODIFICATION_PREVIEW_ERROR: 'No se ha podido previsualizar el cambio de datos del vehículo',
  AUTO_MODIFICATION_SAME_LENDER_INVALID: 'La entidad actual ya no es válida',
  AUTO_MODIFICATION_SAME_LENDER_INVALID_DESCRIPTION:
    'Con las nuevas condiciones, la entidad financiera actual ya no es válida. No es posible modificar las condiciones.',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE: 'Condiciones no óptimas',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_DESCRIPTION:
    'Se modificarán las condiciones en la entidad financiera actual. Con este cambio, la solicitud dejará de contar con la mejor oferta según las tarifas disponibles.',
  AUTO_MODIFICATION_ORDER_WOULD_CHANGE_OPTIMAL_LENDER: 'La oferta óptima se conseguiría con $v1.',
  CART_EDIT_INSTRUCTIONS_AUTO: 'Edita los detalles del vehículo de la solicitud:',
  ALERT_CART_NO_CHANGES: 'Para continuar, tienes que hacer cambios en el carrito.',
  ALERT_VEHICLE_NO_CHANGES: 'Para continuar, tienes que hacer cambios en el vehículo',
  REVIEW_CHANGES: 'Revisar cambios',
  CHANGES_REVIEW: 'Revisa los cambios',
  CHANGES_REVIEW_DESCRIPTION:
    'Estos son las modificaciones realizadas en tu solicitud. Revisa atentamente los cambios antes de continuar.',
  NEW_FINANCING_CONDITIONS: 'Nuevas condiciones de financiación',
  NEW_VEHICLE_DETAILS: 'Nuevos detalles del vehículo',
  EDIT_APPLICATION: 'Editar solicitud',
  EDIT_APPLICATION_TOOLTIP: 'Editar las condiciones de la solicitud y datos del vehículo',
  EDIT_FINANCING_DETAILS: 'Editar financiación',
  EDIT_FINANCING_DETAILS_TOOLTIP: 'Selecciona las nuevas condiciones de financiación de tu solicitud.',
  EDIT_VEHICLE_TOOLTIP: 'Editar los datos del vehículo',
  ORIGINAL_CART: 'Compra original',
  ORIGINAL_VEHICLE: 'Vehículo original',
  NEW_CART: 'Compra nueva',
  NEW_VEHICLE: 'Vehículo nuevo',
  NEW_PAYMENT_METHODS_CONFIRMATION: 'Confirmar nuevos métodos de pago disponibles',
  NOTE: 'Nota',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOTE: (
    <>
      {'Ha habido una variación en el '}
      <b>{'importe total de la compra'}</b>
      {' que afectaría a los métodos de pago disponibles para tu cliente:'}
    </>
  ),
  ORIGINAL_CONDITIONS: 'Configuración original',
  NEW_CONDITIONS: 'Configuración nueva',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_ALERT:
    'Alguno de los métodos de pago no es compatible con tus modificaciones.',
  NEW_PAYMENT_METHODS_CONFIRMATION_CHANGE_DESCRIPTION:
    '¿Estás seguro de que quieres continuar?. Los metodos de pago indicados se deshabilitarán.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_ALERT:
    'Ninguno de los métodos de pago es compatible con tus modificaciones.',
  NEW_PAYMENT_METHODS_CONFIRMATION_NOT_COMPATIBLE_DESCRIPTION:
    'Por favor, para mantener la solicitud es necesario que vuelvas atrás y revises el importe total de la compra.',
  WARNING: 'Atención',
  EDIT_CONFIRM_ALERT_DESCRIPTION:
    '¿Estás seguro de que quieres solicitar los cambios?. Esta operación no se puede deshacer.',
  EDIT_CONFIRM_ALERT_BUTTON: 'Confirmar y enviar',
  PAYMENT_METHOD_RESTORE_ERROR_TITLE: 'Modificación no disponible',
  PAYMENT_METHOD_RESTORE_ERROR_DESCRIPTION: (
    <>
      {'No ha sido posible recuperar las condiciones de este método de pago.'}
      <p>{'Es posible que ya no esté disponible para el agente y el importa a financiar asociados a la solicitud.'}</p>
    </>
  ),
  DOWN_PAYMENT_EDIT: 'Editar entrada',
  DOWN_PAYMENT_EDIT_DESCRIPTION: 'Modifica el importe de la entrada de la solicitud:',
  OLD_VALUES: 'Valores anteriores',
  ALERT_DISABLED_DOWN_PAYMENT_EDIT: 'Para continuar, cambia el valor de la entrada.',

  // CHECKOUT SESSION DETAIL (MERCHANT EDITION)
  REQUEST_FOR: 'Solicitud para',
  EVALUATE_AND_CONFIRM: 'Métodos de pago',
  EVALUATE_AND_CONFIRM_TEXT: 'Procesa y confirma el método de pago deseado para tu cliente',
  NOT_PROCESSED: 'Sin procesar',
  PROCESSED: 'Procesado',
  PAY: 'Pagar',
  EVALUATE: 'Evaluar',
  REEVALUATE: 'Volver a evaluar',
  COMPLETE: 'Completar',
  PENDING_ACTIONS: 'Acciones pendientes',
  [Action.COMPLETE_ONBOARDING]: 'Completar el proceso de solicitud',
  [Action.NO_LENDER_REQUEST_ID]: 'Esperando respuesta de la entidad',
  [Action.PAY]: 'Completar el pago',
  [Action.UPLOAD_DOCUMENTS]: 'Subir los documentos requeridos',
  [Action.REVIEW_DOCUMENTS]: 'Revisar los documentos subidos',
  [Action.SIGN_CONTRACT]: 'Firmar el contrato digitalmente',
  [Action.COMPLETE_PROCESS_SANTANDER]: 'Finalizar el proceso en Santander',
  [Action.PAY_FIRST_INSTALMENT]: 'Pagar primera cuota con tarjeta',
  [Action.CAPTURE_ORDER]: 'Capturar pedido',
  [Action.COMPLETE_KYC]: 'Completar la verificación de identidad',
  [Action.VALIDATE_CARD_DATA]: 'Validar los datos de la tarjeta con el agente',
  [Action.PRINT_CARD]: 'Expedición de la tarjeta',
  VALIDATE_CARD_DATA_DESCRIPTION:
    'Abre el flujo de validación para que un agente revise y valide los datos del cliente.',
  VALIDATE_CARD_DATA_CTA: 'Abrir validación',
  PRINT_CARD_DESCRIPTION:
    'Reenvía el QR de expedición de la tarjeta al cliente por email para que el comercio pueda imprimirla.',
  PRINT_CARD_CTA: 'Reenviar QR por email',
  PRINT_CARD_QR_STUB: 'El QR de expedición de la tarjeta se envía por email.',
  PRINT_CARD_SENT_SUCCESS: 'El QR de expedición de la tarjeta se ha enviado por email.',
  PAYMENT_INTENT_APPROVED_BY: 'Aprobada por',
  PAYMENT_INTENT_ON_HOLD_IN: 'En estudio en',
  PAYMENT_INTENT_TO_BE_COMPLETED: 'Puedes completar el proceso o compartir el enlace para que tu cliente lo finalice.',
  PAYMENT_INTENT_CANCELLED: 'La solicitud ha sido denegada por las entidades financieras.',
  PAYMENT_INTENT_PROCESSING: 'Por favor, espera. Tu solicitud está siendo procesada por las entidades finacieras.',
  NO_LENDER_REQUEST_ID_TITLE: 'Sin respuesta de $v1',
  NO_LENDER_REQUEST_ID_TITLE_TEXT:
    'Todavía no ha sido posible obtener una respuesta al enviar los datos de la solicitud a los sistemas de $v1. No te precupes, se reintentará automáticamente hasta que se obtenga una respuesta.',
  NO_SIGNATURE_AVAILABLE_TITLE: 'Firma no disponible',
  NO_SIGNATURE_PROCESS_AVAILABLE_AT_THE_MOMENT:
    'El proceso de firma digital en $v1 no está disponible en este momento. Cuando se haya habilitado, podrás firmar el contrato digitalmente.',
  PAY_TITLE: 'Pendiente pago con tarjeta',
  PAY_DESCRIPTION:
    'Deberás compartir el enlace de pago con tu cliente para que pueda acceder al proceso y completar el pago. Una vez realizado el pago, el proceso se completará automáticamente.',

  // PROCESSING STRATEGY
  PROCESSING_STRATEGY: 'Respuesta entidades financieras',
  PROCESSING_STRATEGY_MOBILE: 'Respuesta entidades',

  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE: 'Seleccionar entidad',
  SELECT_LOAN_APPLICATION_MANUAL_CHOOSE_TEXT:
    'Selecciona manualmente la entidad financiera deseada para continuar con el proceso de solicitud.',

  PROCESSING_SUMMARY_SINGLE: 'Una sola entidad disponible',
  PROCESSING_SUMMARY_SINGLE_AUTOMATIC_TEXT:
    'La solicitud se envía automáticamente a la única entidad disponible. No tienes que hacer nada.',
  PROCESSING_SUMMARY_SINGLE_MANUAL_TEXT: 'Envía la solicitud a la única entidad disponible desde su fila.',

  PROCESSING_SUMMARY_PARALLEL: 'Se consulta a todas las entidades a la vez',
  PROCESSING_SUMMARY_PARALLEL_TEXT:
    'La solicitud sale al mismo tiempo para todas las entidades de la lista. Cuando responden, la plataforma se queda con la mejor oferta. No tienes que hacer nada.',

  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC: 'La plataforma consulta a las entidades una a una',
  PROCESSING_SUMMARY_WATERFALL_AUTOMATIC_TEXT:
    'Se envía a la primera de la lista y se espera su respuesta antes de pasar a la siguiente. La plataforma avanza sola por el orden que ves abajo. No tienes que hacer nada.',

  PROCESSING_SUMMARY_WATERFALL_MANUAL: 'Tú decides a qué entidad enviar',
  PROCESSING_SUMMARY_WATERFALL_MANUAL_TEXT:
    'No se envía nada de forma automática. El orden de abajo es la recomendación de la plataforma, pero puedes empezar por la que quieras. Envía la solicitud desde cada fila y su respuesta aparecerá aquí.',

  [`PROCESSING_SUMMARY_STOP_${StopCondition.YES}`]:
    'Se detiene cuando una entidad aprueba. Si una deniega o falla, continúa con la siguiente.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.MAYBE}`]:
    'Se detiene cuando una entidad aprueba o deja la solicitud en estudio. Si una deniega o falla, continúa con la siguiente.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.NO}`]:
    'Se detiene con la primera entidad que conteste, aunque deniegue. No habrá un segundo intento automático.',
  [`PROCESSING_SUMMARY_STOP_${StopCondition.ERROR}`]:
    'Se detiene con la primera entidad que conteste, sea cual sea la respuesta. En la práctica solo se consulta una entidad.',

  PROCESSING_STRATEGY_IN_PROGRESS: 'Procesando...',
  PROCESSING_STRATEGY_IN_PROGRESS_TEXT:
    'Obteniendo respuestas de las entidades financieras. Por favor, espera unos segundos.',

  DOCUMENTATION_SYNC_IN_PROGRESS: 'Un momento...',
  DOCUMENTATION_SYNC_IN_PROGRESS_TEXT:
    'Estamos consultando los documentos requeridos por la entidad seleccionada. Por favor, espera unos segundos.',

  //DOCUMENTATION_SYNC_COMPLETED: 'Documentos sincronizados',
  //DOCUMENTATION_SYNC_COMPLETED_TEXT:
  //  'Los documentos requeridos por la entidad seleccionada han sido sincronizados correctamente. Ya puedes cerrar esta ventana y subir los documentos para completar la solicitud.',

  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.YES}`]: 'Solicitud aprobada',
  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.NO}`]: 'Solicitud denegada',
  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.MAYBE}`]: 'Solicitud en estudio',
  ['SELECT_LOAN_APPLICATION_no_status']: 'Sin respuesta',

  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.YES}_TEXT`]:
    'La solicitud ha sido aprobada por $v1. Ya puedes cerrar esta ventana y completar la solicitud.',
  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.NO}_TEXT`]:
    'Lo sentimos, la solicitud no ha sido aprobada por ninguna entidad financiera.',
  [`SELECT_LOAN_APPLICATION_${LenderApprovalStatus.MAYBE}_TEXT`]:
    'La solicitud está en fase de estudio por la entidad financiera. Una vez finalizado el análisis, el estado de la solicitud se actualizará automáticamente.',
  ['SELECT_LOAN_APPLICATION_no_status_TEXT']:
    'No ha sido posible obtener una respuesta de las entidades financieras. Inténtalo de nuevo por favor.',

  //SINGLE PAYMENT LIST
  A2A_PAYMENTS_LIST: 'Transferencias inmediatas',
  A2A_PAYMENT_SUBSECTION_TITLE: 'Listado de transferencias inmediatas',

  CARD_PAYMENTS_LIST: 'Pagos con tarjeta',
  CARD_PAYMENT_SUBSECTION_TITLE: 'Listado de pagos con tarjeta',

  //SINGLE PAYMENT DETAIL
  SINGLE_PAYMENT: 'Pago único',
  PROVIDER: 'Proveedor',
  CARD_PAYMENT_DETAIL: 'Detalle del pago con tarjeta',
  SINGLE_PAYMENT_OVERVIEW: 'Resumen',
  A2A_PAYMENT_OVERVIEW: 'Resumen pago por transferencia',
  A2A_PAYMENT_DETAIL: 'Detalle del pago por transferencia',
  PRODUCT_ID: 'ID producto',
  MERCHANT_KEY: 'Clave merchant',
  MERCHANT_PASSWORD: 'Contraseña merchant',
  EXPIRED_AT: 'Caduca en:',

  //CARD LIST
  CARD: 'Tarjeta',
  CREDIT_CARD: 'Tarjeta de crédito',
  CREDIT_CARD_LIST: 'Tarjeta de crédito',
  CARD_DETAIL: 'Detalle tarjeta',
  CREDIT_CARD_DETAIL: 'Detalle tarjeta de crédito',
  CARD_SUBSECTION_TITLE: 'Listado de tarjetas',
  CARD_OVERVIEW: 'Resumen tarjeta',
  [PetitionType.BORROWER]: 'Particular',
  [PetitionType.BUSINESS]: 'Empresa',
  [PaymentMode.END_OF_MONTH]: 'Fin de mes',
  [PaymentMode.FIXED_INSTALLMENT]: 'Cuota fija',
  [PaymentMode.PERCENTAGE_CONTRACT_LIMIT]: 'Porcentaje límite contrato',
  [PaymentMode.PERCENTAGE_USED_LIMIT]: 'Porcentaje límite usado',
  [PaymentMode.ROUND_INSTALLMENT]: 'Cuota redondeada',
  PAYMENT_MODE: 'Modo de pago',
  MONTHLY_STATEMENT_DAY: 'Día de cobro',
  CARD_REQUESTED_LIMIT: 'Límite de crédito',
  FIXED_INSTALMENT_AMOUNT: 'Cuota fija',
  PRE_CARD_REQUESTED: 'Tarjeta pre-solicitada',

  //IBERIA CREDIT CARD
  CREDIT_CARD_ID: 'ID de la tarjeta de crédito',
  CREDIT_CARD_OVERVIEW: 'Resumen',
  CREDIT_CARD_DETAILS: 'Detalles de la tarjeta',
  CREDIT_CARD_CONFIGURATION: 'Configuración de la tarjeta',
  CARD_TYPE: 'Tipo de tarjeta',
  BRAND_TYPE_AND_PRODUCT: 'Marca/Tipo/Producto',
  MARKETING_CAMPAIGN: 'Campaña de marketing',
  APPLICATION_ORIGIN: 'Origen',
  CORPORATE_GROUP: 'Grupo corporativo',
  CUSTOMER_TYPE: 'Tipo de cliente',
  PROVIDER_NAME: 'Proveedor',
  HOLDER_NAME: 'Nombre completo en tarjeta',
  CONTRACT: 'Contrato',
  CONTRACT_DETAILS: 'Detalles del contrato',
  CONTRACT_SIGNATURE: 'Firma de contrato',
  CONTRACT_SIGNATURE_PENDING: 'Firma de contrato pendiente',
  CONTRACT_SIGNED: 'Contrato firmado',
  CONTRACT_SENT_ON: 'Enviado el $v1',
  CONTRACT_SIGNED_ON: 'Firmado el $v1',
  CONTRACT_SEND: 'Envío de contrato',
  PENDING_CONTRACT_SEND: 'Pendiente de envío',
  SIGNATURE_PENDING: 'Firma pendiente',
  CREDIT_CARD_CONDITIONS: 'Condiciones de la tarjeta de crédito',
  [CreditCardName.ZENIT]: 'Iberia Zenit',
  [CreditCardName.AIRE]: 'Iberia Aire',
  [CreditCardName.ICON]: 'Iberia Icon',
  APPLICATION_PROCESS: 'Proceso de solicitud',
  PERSONAL_DATA: 'Datos personales',
  BIRTH_NATIONALITY: 'País de nacimiento',
  ADDITIONAL_INFORMATION: 'Información adicional',
  PROFESSIONAL_DATA: 'Datos profesionales',
  BANK_ACCOUNT_DATA: 'Datos bancarios',
  STEP: 'Paso',
  USER_AGENT: 'Agente',
  IP: 'IP',
  WORKFLOW_TYPE: 'Tipo de proceso',
  WORKFLOW_PROGRESS: 'Resumen del proceso',
  CREDIT_CARD_PROGRESS: 'Progreso de la tarjeta de crédito',
  CURRENT_STEP_PROGRESS: 'Progreso actual',
  COMPLETED_STEPS: 'Pasos completados',
  SPOUSE_EMPLOYED: '¿Tu pareja trabaja?',
  MONTHLY_EXPENSES: 'Gasto mensual otros créditos',
  GROSS_INCOME: 'Ingresos brutos anuales',
  IBERIA_CLUB: 'Iberia Club',
  IBERIA_CARD_ID: 'ID solicitud de Iberia Cards',
  IBERIA_CLUB_NUMBER: 'Número Iberia Club',
  [WorkflowPlace.INVITATION]: 'Invitación',
  [WorkflowPlace.KYC_OCR]: 'OCR',
  [WorkflowPlace.PERSONAL_INFO]: 'Datos personales',
  [WorkflowPlace.ADDITIONAL_INFO]: 'Información adicional',
  [WorkflowPlace.ADDRESS]: 'Dirección',
  [WorkflowPlace.PROFESSIONAL_DETAILS]: 'Datos profesionales',
  [WorkflowPlace.BANK_ACCOUNT]: 'Datos bancarios',
  [WorkflowPlace.SUMMARY]: 'Resumen',
  [WorkflowPlace.LOW_LIMIT]: 'Límite de crédito',
  [WorkflowPlace.GDPR]: 'GDPR',
  [WorkflowPlace.INE]: 'INE',
  [WorkflowPlace.CONTRACT_SIGNATURE]: 'Firma de contrato',
  [WorkflowPlace.KYC_ADDITIONAL_DOCUMENTATION]: 'NIE EU',
  [WorkflowPlace.KYC_VIDEO]: 'Vídeo de identificación',
  [WorkflowPlace.DOCUMENTATION]: 'Documentación',
  [WorkflowPlace.IBERIA_CLUB]: 'Iberia Club',
  CREDIT_CARD_STATUS_INITIAL: 'Iniciada',
  CREDIT_CARD_STATUS_ON_HOLD: 'En estudio',
  CREDIT_CARD_STATUS_REQUESTED: 'Solicitada',
  CREDIT_CARD_STATUS_APPROVED: 'Preaprobada',
  CREDIT_CARD_STATUS_CONFIRMED: 'Confirmada',
  CREDIT_CARD_STATUS_CAPTURED: 'Capturada',
  CREDIT_CARD_STATUS_SIGNED: 'Firmada',
  CREDIT_CARD_STATUS_PAID: 'Completada',
  CREDIT_CARD_STATUS_DESISTED: 'El cliente ha desistido',
  CREDIT_CARD_STATUS_EXPIRED: 'Caducado',
  CREDIT_CARD_STATUS_CANCELLED: 'Cancelada',
  CREDIT_CARD_STATUS_DENIED: 'Denegada',

  //LOADING MESSAGES
  AGENT_IN_LENDER_CONTEXT: 'Credenciales en entidades financieras',
  MERCHANT_TO_DO_LIST: 'Acciones pendientes',
  MERCHANT: 'Merchant',
  MERCHANT_IN_LENDER_STRUCTURE: 'Entidades financieras',
  AGENT_PRICINGS: 'Tarifas de agente',
  LOAN_DETAILS_OVERVIEW: 'Detalles del préstamo',
  BORROWER_CASH_IN_CASH_OUT_DETAILS: 'Información bancária',
  LOAN_ASSET_DETAILS: 'Detalles asset',
  KYC_LOAN: 'Información personal',
  BORROWER_KYC: 'Información borrower',
  LOAN_APPLICATIONS: 'Respuestas de entidades financieras',
  PAYOUT_SUMMARY: 'Resumen de pagos',
  COMPLETE_CLIENT_DATA: 'Elige un método de envío y rellena los datos de tu cliente:',
  COPY_LINK_AND_SHARE: 'Copia el enlace y compártelo con tu cliente:',
  PAYMENT_LINK_HAS_BEEN_CREATED: '¡El enlace de pago ha sido creado!',
  ENABLE_DISTRIBUTION_METHODS: 'Habilita los métodos de envío para compartirlo con tu cliente:',
  OR_SHARE_IT_DIRECTLY: 'o bien compártelo directamente:',
  SHOW_QR: 'Mostrar QR',
  SHOW_QR_TO_SHARE: 'Pide a tu cliente que escanee el QR para completar el pago:',
  OPEN_LINK: 'Visitar',
  NO_DATA_TO_DISPLAY: 'No hay datos para mostrar',

  INVALID_UUID: 'uuid inválido',

  // INTEGRATIONS
  INTEGRATIONS: 'Integraciones',
  WEBHOOKS: 'Webhooks',
  WEBHOOKS_MERCHANT_TEXT: (
    <>
      <p>
        {
          'Tu aplicación puede suscribirse para recibir notificaciones de eventos en Nemuru en una URL que elijas. Recibirás notificaciones de los siguientes eventos:'
        }
      </p>
      <ul>
        <li>
          <code>{'checkout_session_status_changed'}</code>
          {': El estado de la sesión de pago ha cambiado.'}
        </li>
        <li>
          <code>{'payment_intent_status_changed'}</code>
          {': El estado del intento de pago ha cambiado.'}
        </li>
        <li>
          <code>{'conditions_changed'}</code>
          {': Cuando cambian las condiciones del método de pago.'}
        </li>
        <li>
          <code>{'capture_approved'}</code>
          {': Notificación de que la captura ha sido aprobada.'}
        </li>
        <li>
          <code>{'refund_approved'}</code>
          {': Notificación de que el reembolso ha sido aprobado.'}
        </li>
      </ul>
      <p>
        {'Consulta nuestra '}
        <a className="underline" href="https://docs.nemuru.com/webhook-api" target="_blank">
          {'documentación técnica'}
        </a>
        {' para más información sobre los datos que enviamos en las notificaciones (contraseña: '}
        <code>{'Nemuru2024!'}</code>
        {').'}
      </p>
    </>
  ),
  WEBHOOKS_LIST: 'Listado de webhooks',
  CREATE_NEW_WEBHOOK: 'Crear nuevo webhook',
  NO_WEBHOOK_CONFIGURED: 'No hay ningún webhook configurado',
  ADD_WEBHOOK: 'Añadir webhook',
  EDIT_WEBHOOK: 'Editar webhook',
  DELETE_WEBHOOK: 'Eliminar webhook',
  THE_FOLLOWING_WEBHOOK_WILL_BE_DELETED: 'El siguiente webhook será eliminado:',
  WEBHOOK_URL: 'URL del webhook',
  WEBHOOK_URL_HINT:
    'Enviaremos solicitudes HTTP POST a esta URL cuando ocurran eventos. Esperamos una respuesta positiva con un estado 2XX; de lo contrario, reintentaremos el callback hasta 5 veces.',
  AUTHORIZATION_TYPE: 'Tipo de autorización',
  AUTHORIZATION_HEADER: 'Header de autorización',
  ADDITIONAL_PAYLOAD: 'Payload adicional',
  REQUIRED_SELECT_FIELD: 'Por favor, selecciona una opción',
  [`AuthorizationType_${AuthorizationType.NO_AUTH}`]: 'Sin autorización',
  [`AuthorizationType_${AuthorizationType.BASIC}`]: 'Autorización básica',
  [`AuthorizationType_${AuthorizationType.OAUTH_2}`]: 'Autorización OAuth 2.0',

  // USERS
  LOADING_INFORMATION_NEEDED: 'Cargando información',
  ADMINS_CREDENTIALS: 'Credenciales de administradores',
  [`${UserCredentialsType.AGENT}_TAB_LABEL`]: 'Agentes',
  [`${UserCredentialsType.ADMIN}_TAB_LABEL`]: 'Administradores',
  CREATE_NEW_AGENT: 'Crear nuevo agente',
  CREATE_NEW_CHANNEL: 'Crear nuevo canal',
  CREATE_NEW_ADMIN: 'Crear nuevo administrador',
  [`${UserCredentialsType.CHANNEL}_BTN`]: 'Crear canal',
  [`${UserCredentialsType.AGENT}_BTN`]: 'Crear agente',
  [`${UserCredentialsType.ADMIN}_BTN`]: 'Crear administrador',
  [`${UserCredentialsType.CHANNEL}_TITLE`]: 'Crear nuevo canal',
  [`${UserCredentialsType.AGENT}_TITLE`]: 'Crear nuevo agente',
  [`${UserCredentialsType.AGENT}_PASSWORD`]: 'Contraseña del agent',
  [`${UserCredentialsType.ADMIN}_TITLE`]: 'Crear nuevo administrador',
  [`${UserCredentialsType.ADMIN}_PASSWORD`]: 'Contraseña del administrador',
  [`${UserCredentialsType.ADMIN}_EMAIL`]: 'Correo del administrador',
  CHANNEL_USERS: 'Usuarios del canal',
  NO_AGENTS_IN_CHANNEL: 'Todavía no hay agentes en el canal',
  USER_CREDENTIALS_AGENTS: 'Credenciales de agentes',
  CHANGE_CHANNEL: 'Cambiar de canal',
  LOADING_AGENTS: 'Cargando agentes...',

  // SIMULATOR
  SIMULATOR: 'Simulador',
  SIMULATOR_DISABLED: 'El simulador de cuota todavía no está disponible para los métodos de pago de este agente.',
  SIMULATOR_DISABLED_AGENT_ACCOUNT:
    'El simulador de cuota todavía no está disponible para los métodos de pago habilitados por tu administrador.',
  SELECT_CONDITION_FROM_SIMULATOR: 'Selecciona una condición desde el simulador',
  MAXIMIZE: 'Ampliar',

  // DOCUMENTS VALIDATION
  DECLARED_DATA: 'Información declarada',
  STEP_X_OF_Y: 'Paso $v1 de $v2',
  DOCUMENT: 'Documento',
  VALIDATE: 'Validar',
  DO_NOT_VALIDATE: 'Marcar como no válido',
  DOCUMENTS_VALIDATION_ERROR_DESCRIPTION:
    'Por favor, inténtalo de nuevo más tarde. Si el problema persiste, contacta con nuestro equipo de soporte en: support@nemuru.com',
  DOCUMENTS_VALIDATION_INITIAL_TITLE: 'Validación documental',
  DOCUMENTS_VALIDATION_INITIAL_DESCRIPTION:
    'Bienvenido/a al proceso de validación para la emisión de una nueva targeta.',
  ENTER_CLIENT_DATA: 'Introduce el DNI/NIE de tu cliente',
  CLIENT_DOCUMENT_ID: 'DNI/NIE del cliente',
  CLIENT_DOCUMENT_ID_MISMATCH: 'El DNI/NIE introducido no coincide con el del cliente',
  CLIENT_DOCUMENT_ID_ERROR: 'No se han podido encontrar los datos del document de identidad',
  CLOSE_VALIDATION_TITLE: '¿Deseas reiniciar la validación?',
  CLOSE_VALIDATION_DESCRIPTION:
    'Si reinicias, tendrás que volver a empezar el proceso de validación, introduciendo el DNI/NIE del titular de la solicitud.',
  ID_VALIDATION_CHECKBOX:
    'He validado el documento de indentidad facilitado con el que se me presenta y con la persona. Acredito que los tres coinciden.',
  ID_VALIDATION_ERROR: 'No se han podido encontrar los datos para la validación del documento de identidad.',
  DOCUMENT_ID_FACE_PICTURE: 'Fotografía del documento de identidad',
  BIOMETRICS_FACE_PICTURE: 'Fotografía de la vídeo-identificación',
  VIDEO_ID_VALIDATION_CHECKBOX:
    'He validado la calidad de la vídeo-identificación y sus verificaciones automáticas. Confirmo que los dos rostros proporcionados coinciden.',
  VIDEO_ID_VALIDATION_ERROR: 'No se han podido encontrar los datos para la validación de la vídeo-identificación.',
  BANK_ACCOUNT_VALIDATION_CHECKBOX:
    'He validado que la cuenta bancaria facilitada y los nombres de titularidad proporcionados coinciden con los del documento. Acredito que el documento es válido.',
  BANK_ACCOUNT_VALIDATION_ERROR:
    'No se han podido encontrar los datos para la validación de la titularidad de la cuenta bancaria.',
  INCOME_VALIDATION_CHECKBOX:
    'He validado que los datos proporcionados coinciden con los del documento. Acredito que el documento es válido.',
  INCOME_VALIDATION_ERROR: 'No se han podido encontrar los datos para la validación de los datos socioeconómicos.',
  DOCUMENTS_VALIDATION_CONFIRMATION: 'Datos validados correctamente',
  DOCUMENTS_VALIDATION_CONFIRMATION_SUCCESS: '¡Felicidades! Has completado la validación de los datos.',
  DOCUMENTS_VALIDATION_CONFIRMATION_DESCRIPTION:
    'Hemos enviado un correo electrónico a $v1.  El cliente debe mostrar el código QR recibido por correo electrónico para proceder a la emisión de la tarjeta de crédito.',
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_1: 'En el caso de que el cliente no haya recibido ningún correo, haz click ',
  SEND_EMAIL_AGAIN_DESCRIPTION_PART_2: ' para volver a enviarlo.',
  SEND_EMAIL_AGAIN: 'Volver a enviar correo',
  SEND_EMAIL_AGAIN_DIALOG: '¿Deseas volver a enviar el correo a la dirección $v1?',
  NO_DOCUMENT_FOUND: 'No se ha encontrado el documento',
  WE_WERE_NOT_ABLE_TO_FIND_THE_DOCUMENT:
    'No hemos podido encontrar el documento necesario para proceder con la validación. Confirma con el cliente que se ha subido correctamente el documento en cuestión y vuelve a intentar descargarlo.',
  HERE: 'aquí',
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR_TITLE: 'No se ha podido validar la documentación',
  DOCUMENTS_VALIDATION_CONFIRMATION_ERROR:
    'Al no tener toda la documentación validada, no es posible realizar la emisión de la tarjeta de crédito. Para poder avanzar en el proceso, comunica al cliente que debe volver a subir los siguientes documentos:',
  CONFIRMATION_NEXT_STEP_1: 'Hemos enviado un correo a $v1 con el código QR.',
  CONFIRMATION_NEXT_STEP_2: 'Escanea el código QR desde la app de captación.',
  CONFIRMATION_NEXT_STEP_3: 'Completa el proceso en la app de captación para emitir la tarjeta.',
  RESET_VALIDATION: 'Reiniciar validación',
  RESET: 'Reiniciar',
  NO_LOAN_FOUND: 'Solicitud no encontrada',
  NO_DOCUMENTATION_FOUND: 'No se ha encontrado la documentación asociada a esta solicitud',
  CANCELLED_CARD: 'Esta solicitud de tarjeta ha sido cancelada',
  CANCEL_CARD: 'Cancelar solicitud',
  CANCEL_CARD_DESCRIPTION: '¿Deseas cancelar esta solicitud de tarjeta de crédito?',
  NO_LENDER_CONFIGURATION_FOUND: 'No se ha encontrado ninguna configuración de prestamista asociada a este merchant',

  // COMPLETE KYC ACTION STEP
  KYC_STEP_FAILED_TITLE: 'Verificación de identidad rechazada',
  KYC_STEP_PENDING_TITLE: 'Verificación de identidad pendiente',
  KYC_STEP_INITIAL_TITLE: 'Verificación de identidad requerida',
  KYC_STEP_HARD_FAILED_DESCRIPTION_P1:
    'Se ha alcanzado el número máximo de intentos permitidos para la verificación de identidad.',
  KYC_STEP_HARD_FAILED_DESCRIPTION_P2: (
    <>
      Si crees que ha habido un error, puedes llamarnos al <strong>+34 932 200 612</strong> para que revisemos el caso.
    </>
  ),
  KYC_STEP_PENDING_DESCRIPTION_P1_NO_EMAIL:
    'El $v1 recibirá próximamente un correo electrónico con las instrucciones para completar la verificación de identidad.',
  KYC_STEP_PENDING_DESCRIPTION_P1:
    'El $v2 recibirá próximamente un correo electrónico a $v1 con las instrucciones para completar la verificación de identidad.',
  KYC_STEP_PENDING_DESCRIPTION_P2:
    'Puede indicarle que esté atento a su bandeja de entrada y revise también la carpeta de spam o promociones.',
  KYC_STEP_PENDING_BUTTON_TEXT: 'Reenviar correo',
  KYC_STEP_SOFT_FAILED_BUTTON_TEXT: 'Reintentar verificación',
  KYC_STEP_DISCLAIMER: 'Recuerde que siempre puede verificar la identidad del $v1 de forma presencial.',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P1: 'La verificación de identidad ha sido rechazada.',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P2: 'Algunos motivos habituales son:',
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P3: (
    <>
      <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 32 }}>
        <li>Documento caducado o en mal estado</li>
        <li>Imágenes poco claras</li>
        <li>Datos que no coinciden</li>
      </ul>
    </>
  ),
  KYC_STEP_SOFT_FAILED_DESCRIPTION_P4: 'Puede reenviar el correo para volver a intentarlo.',
  KYC_STEP_INITIAL_DESCRIPTION_P1:
    'Para continuar con la solicitud, es necesario enviar al $v1 un correo electrónico con las instrucciones para completar la verificación de identidad.',
  KYC_STEP_INITIAL_BUTTON_TEXT: 'Enviar correo',
  KYC_STEP_PRESENTIAL_VERIFICATION_TEXT: 'Verificar presencialmente',
  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_1:
    'Al continuar, confirmas que has verificado presencialmente la identidad del $v1 y que sus datos son correctos.',
  KYC_STEP_PRESENTIAL_VERIFICATION_MODAL_TEXT_2: (
    <>
      <ul
        style={{
          marginTop: 0,
          marginBottom: 0,
          paddingInlineStart: 32,
          display: 'flex',
          gap: '4px',
          flexDirection: 'column',
        }}
      >
        <li>La persona presente es quien solicita la financiación</li>
        <li>El documento de identidad ha sido comprobado</li>
      </ul>
    </>
  ),
  KYC_ERROR_SENDING_VERIFICATION_EMAIL:
    'No hemos podido enviar el correo ahora mismo, inténtalo de nuevo en unos minutos.',
  KYC_ERROR_PERFORMING_MANUAL_VERIFICATION:
    'No hemos podido confirmar la verificación presencial en este momento, inténtalo de nuevo en unos minutos.',
  KYC_TITULAR: 'Titular',
  KYC_COTITULAR: 'Cotitular',
  KYC_COMPLETED_VERIFICATION_TEXT: 'Verificación de identidad completada',
  KYC_COMPLETED_VERIFICATION_TEXT_SECTION: 'Verificaciones completadas',
  KYC_STEP_PRESENTIAL_VERIFICATION_BUTTON_TEXT: 'Confirmar',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.BORROWER}`]: 'titular',
  [`KYC_OWNER_LABEL_${KycIntegrationMethodOwner.COWORROWER}`]: 'cotitular',

  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_NUMBER_VALIDATION}`]: 'Número de documento',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.DOCUMENT_ID_VALIDATION}`]: 'Documento de identidad',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.VIDEO_ID_VALIDATION}`]: 'Vídeo identificación',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.BANK_ACCOUNT_VALIDATION}`]: 'Titularidad de cuenta',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.INCOME_VALIDATION}`]: 'Datos de ingresos',
  [`DOCUMENTS_VALIDATION_STEP_${ValidationStep.CONFIRMATION}`]: 'Confirmación',

  // CREDIT CARD CHECKOUT SESSION
  CREDIT_CARD_PURCHASE_TITLE: 'Continuar con la contratación',
  CREDIT_CARD_PURCHASE_FIRST_INSTRUCTIONS:
    'Existe una solicitud de tarjeta de crédito en curso. Pulsa en continuar para retomar el proceso junto al cliente.',
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_1: (
    <>
      Para continuar con la contratación, haz clic en <strong>"Compartir enlace"</strong> y envíalo al cliente por email
      o SMS.
    </>
  ),
  CREDIT_CARD_PURCHASE_SECOND_INSTRUCTIONS_2: (
    <>
      Asegúrate de que el{' '}
      <strong>cliente complete el proceso únicamente a través de ese enlace y desde su propio dispositivo.</strong>
    </>
  ),
  CREDIT_CARD_PURCHASE_STANDS_SUPERVISOR_PRE_SCORING_INSTRUCTIONS:
    'La solicitud aún no ha completado el resumen. El agente del stand debe completarla junto al cliente hasta ese paso; a partir de entonces podrás continuarla o compartir el enlace.',
  CREDIT_CARD_PURCHASE_CONTINUE: 'Continuar',
  CREDIT_CARD_FETCH_ERROR_TITLE: 'Información de tarjeta no disponible',
  CREDIT_CARD_FETCH_ERROR_DESCRIPTION:
    'No se pudo acceder a los datos de la tarjeta en este momento. Por favor, vuelve a intentarlo.',
  CREDIT_CARD_FETCH_ERROR_BTN_LABEL: 'Reintentar',
  CREDIT_CARD_SMS_SENT_TOAST: 'SMS enviado',

  // ERROR BOUNDARY
  ERROR_GENERIC: 'Ha habido un error al procesar tu solicitiud.',
  ERROR_BOUNDARY_TEXT: 'Ha habido un error al cargar la página. Por favor, vuélvelo a intentar más tarde.',
  ERROR_BOUNDARY_TEXT_ASYNC: 'Ha habido un error al procesar tu solicitiud. Por favor, vuélvelo a intentar más tarde.',
  ERROR_BOUNDARY_TEXT_CONTACT: 'Si el problema persiste, no dudes en contactar a nuestro equipo de soporte:',
  ERROR_MESSAGE_ZOD_SCHEMA: 'Error en la validación del esquema de datos',
  RELOAD_PAGE: 'Volver a cargar página',

  APPLICATION_HISTORY: 'Historial solicitud',
  APPLICATION_PROGRESS: 'Progreso solicitud',

  //REQUEST NOTIFICATION MESSAGES
  [`${patchSetAgentConfiguration.name}_fulfilled`]: 'Se ha actualizado la configuración del agente.',
  [`${patchSetAgentConfiguration.name}_rejected`]: 'La actualización de la configuración del agente ha fallado.',
  [`${patchSetPricingIdsToAgent.name}_fulfilled`]: 'Se han modificado las tarifas asignadas correctamente',
  [`${patchSetPricingIdsToAgent.name}_rejected`]: 'Ha surgido un problema al intentar modificar las tarifas asignadas',
  [`${postCreateAgent.name}_fulfilled`]: 'Nuevo agente creado correctamente.',
  [`${postCreateAgent.name}_rejected`]: 'Ha surgido un problema al intentar crear el agente.',
  [`${postCreditCardIberiaCards.name}_rejected`]: 'No se ha podido crear la solicitud. Inténtalo de nuevo.',
  [`${postCreatePaymentIntent.name}_rejected`]: 'No se ha podido iniciar la contratación. Inténtalo de nuevo.',
  [`${postSyncPricingsToCdnByAgentId.name}_fulfilled`]: 'Se han subido correctamente las tarifas al CDN',
  [`${postSyncPricingsToCdnByAgentId.name}_rejected`]: 'Ha surgido un problema al intentar subir las tarifas al CDN',
  [`${postCreateChannel.name}_fulfilled`]: 'Nuevo canal creado correctamente.',
  [`${postCreateChannel.name}_rejected`]: 'Ha surgido un problema al intentar crear el canal.',
  [`${patchChangeUserId.name}_fulfilled`]: 'Se han movido correctamente las credenciales de usuario',
  [`${patchChangeUserId.name}_rejected`]: 'Ha surgido un problema al intentar mover las credenciales de usuario',
  [`${patchChangeAgentIdChannel.name}_fulfilled`]: 'El agente ha sido cambiado de canal correctamente.',
  [`${patchChangeAgentIdChannel.name}_rejected`]: 'Ha surgido un problema al intentar cambiar el agente de canal.',
  [`${patchChangeApprovalStatusByMerchantId.name}_fulfilled`]: 'Cambio realizado correctamente.',
  [`${patchChangeApprovalStatusByMerchantId.name}_rejected`]: 'Ha surgido un problema al intentar realizar el cambio.',
  [`${patchChangeMerchantStatusByMerchantId.name}_fulfilled`]: 'Cambio realizado correctamente.',
  [`${patchChangeMerchantStatusByMerchantId.name}_rejected`]: 'Ha surgido un problema al intentar realizar el cambio.',
  [`${patchChangeAcquisitionChannelByMerchantId.name}_fulfilled`]:
    'Canal de adquisición del merchant modificados correctamente',
  [`${patchChangeAcquisitionChannelByMerchantId.name}_rejected`]:
    'Ha surgido un problema al modificar el canal de adquisición',
  [`${patchChangeRegistrationFieldsByMerchantId.name}_fulfilled`]:
    'Datos de registro del merchant modificados correctamente',
  [`${patchChangeRegistrationFieldsByMerchantId.name}_rejected`]:
    'Ha surgido un problema al modificar los datos de registro.',
  [`${postCreateMerchant.name}_fulfilled`]: 'Nuevo merchant creado correctamente.',
  [`${postCreateMerchant.name}_rejected`]: 'Ha surgido un problema al intentar crear el nuevo merchant.',
  [`${postCreateMerchantData.name}_fulfilled`]: 'Nuevo merchant creado correctamente.',
  [`${postCreateMerchantData.name}_rejected`]: 'Ha surgido un problema al intentar crear el nuevo merchant.',
  [`${patchSetLegalAddress.name}_fulfilled`]: 'Dirección fiscal actualizada correctamente.',
  [`${patchSetLegalAddress.name}_rejected`]: 'Ha surgido un problema al intentar actualizar la dirección fiscal.',
  [`${patchSetNieData.name}_fulfilled`]: 'Datos actualizados correctamente.',
  [`${patchSetNieData.name}_rejected`]: 'Ha surgido un problema al intentar actualizar los datos NIE.',
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_fulfilled`]:
    'Se ha actualizado la información bancaria correctamente.',
  [`${patchUpdateCashInCashOutMethodByMerchantId.name}_rejected`]:
    'Ha surgido un problema al actualizar la información.',
  [`${patchAddCashInCashOutMethodByMerchantId.name}_fulfilled`]: 'Se ha añadido la información bancaria correctamente.',
  [`${patchAddCashInCashOutMethodByMerchantId.name}_rejected`]:
    'Ha surgido un problema al añadir la información bancaria.',
  [`${patchUpdateCashInCashOutMethod.name}_fulfilled`]: 'Se ha actualizado la información bancaria correctamente.',
  [`${patchUpdateCashInCashOutMethod.name}_rejected`]: 'Ha surgido un problema al actualizar la información.',
  [`${patchBlockUser.name}_fulfilled`]: 'Se han bloqueado las credenciales del usuario correctamente',
  [`${patchBlockUser.name}_rejected`]: 'Ha surgido un problema al bloquear las credenciales del usuario',
  [`${patchUnblockUser.name}_fulfilled`]: 'Se han habilitado las credenciales del usuario correctamente',
  [`${patchUnblockUser.name}_rejected`]: 'Ha surgido un problema al habilitar las credenciales del usuario',
  [`${postAgentInLenderContext.name}_fulfilled`]: 'Se han creado correctamente las nuevas credenciales',
  [`${postAgentInLenderContext.name}_rejected`]: 'La creación de nuevas credenciales ha fallado',
  [`${patchSetAgentIdInLenderContextById.name}_fulfilled`]: 'Se han modificado correctamente las credenciales',
  [`${patchSetAgentIdInLenderContextById.name}_rejected`]: 'La modificación de las credenciales ha fallado',
  [`${deleteAgentInLenderContextById.name}_fulfilled`]: 'Se han eliminado correctamente las credenciales',
  [`${deleteAgentInLenderContextById.name}_rejected`]: 'No se han podido eliminar las credenciales',
  [`${patchChangeType.name}_fulfilled`]: 'Tipo de canal modificado correctamente',
  [`${patchChangeType.name}_rejected`]: 'Ha surgido un problema al intentar modificar el tipo de canal',
  [`${patchChangeDescription.name}_fulfilled`]: 'Descripción de canal modificada correctamente',
  [`${patchChangeDescription.name}_rejected`]: 'Ha surgido un problema al intentar modificar la descripción del canal',
  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_fulfilled`]:
    'Se ha enviado un recordatorio de la firma del contrato al merchant correctamente.',
  [`${patchCreateSignatureReminderRequestForMerchantContract.name}_rejected`]:
    'Ha surgido un problema al enviar un recordatorio de la firma del contrato al merchant.',
  [`${patchCreateSignatureRequestForMerchantContract.name}_fulfilled`]:
    'Se ha enviado un nuevo contrato al merchant correctamente.',
  [`${patchCreateSignatureRequestForMerchantContract.name}_rejected`]:
    'Ha surgido un problema al enviar el nuevo contrato al merchant.',
  [`${patchUpdateDeclaredIncome.name}_fulfilled`]: 'Ingresos declarados actualizados correctamente',
  [`${patchUpdateDeclaredIncome.name}_rejected`]: 'Ha surgido un problema al actualizar los ingresos declarados',
  [`${patchUpdateInvitationByType.name}_fulfilled`]: 'Datos de la invitación modificados correctamente',
  [`${patchUpdateInvitationByType.name}_rejected`]: 'Ha surgido un problema al modificar de los datos de la invitación',
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_fulfilled`]:
    'Datos de la empresa modificados correctamente',
  [`${patchSetBusinessDetailsToBusinessOnboardingDetails.name}_rejected`]:
    'Ha surgido un problema al modificar de los datos de la empresa',
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_fulfilled`]: 'Interviniente(s) modificado(s) correctamente',
  [`${patchSetHoldersToBusinessOnboardingDetails.name}_rejected`]:
    'Ha surgido un problema al modificar los interviniente(s)',
  [`${postSendEmailForNewVideoId.name}_fulfilled`]:
    'Correo para requerimiento de nueva videoidentificación correctamente enviado',
  [`${postSendEmailForNewVideoId.name}_rejected`]:
    'Ha surgido un error al enviar el correo para la nueva videoidentificación',
  [`${patchUnSignLoanLenderBorrowerContract.name}_fulfilled`]: 'Se ha anulado la firma de contrato correctamente',
  [`${patchUnSignLoanLenderBorrowerContract.name}_rejected`]:
    'Ha surgido un problema durante la anulación de la firma del contrato',
  [`${patchSetLenderRequestId.name}_fulfilled`]: 'ID de solicitud modificado correctamente',
  [`${patchSetLenderRequestId.name}_rejected`]: 'Ha surgido un problema al modificat el ID de solicitud',
  [`${patchUpdateBorrowerContractLoan.name}_fulfilled`]: 'Datos actualizados con éxito',
  [`${patchUpdateBorrowerContractLoan.name}_rejected`]: 'Ha surgido un problema al actualizar los datos',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_fulfilled`]: 'Fecha de pago actualizada correctamente',
  [`${patchUpdatePaymentDateByPaymentLineId.name}_rejected`]: 'Ha surgido un problema al actualizar la fecha de pago',
  [`${patchUpdatePaymentPlanLineStatus.name}_fulfilled`]: 'Estado de pago cambiado correctamente',
  [`${patchUpdatePaymentPlanLineStatus.name}_rejected`]: 'Ha surgido un problema al cambiar el estado de pago',
  [`${patchSignLoanLenderBorrowerContract.name}_fulfilled`]: 'Se ha marcado el contrato de esta solicitud como firmado',
  [`${patchSignLoanLenderBorrowerContract.name}_rejected`]:
    'Ha surgido un problema al marcar el contrato de esta solicitud como firmado',
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_fulfilled`]: 'Interviniente correctamente añadido a la solicitud',
  [`${patchSetBorrowerOnboardingDetailsByRole.name}_rejected`]:
    'Ha surgido un problema al añadir el interviniente a la solicitud',
  [`${patchSendDocumentationIncidenceNotification.name}_fulfilled`]:
    'La notificación de incidencia se ha enviado correctamente',
  [`${patchSendDocumentationIncidenceNotification.name}_rejected`]:
    'Ha surgido un error al enviar la notificación de incidencia',
  [`${patchUpdatePaymentPlanLineSentDate.name}_fulfilled`]:
    'Email de solicitud de pago de la cuota enviado correctamente al cliente',
  [`${patchUpdatePaymentPlanLineSentDate.name}_rejected`]:
    'Ha surgido un problema al enviar el email de solicitud de pago de la cuota al cliente',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_fulfilled`]: 'Documento solicitado correctamente',
  [`${patchAddRequiredFileTypeToDocumentationRequired.name}_rejected`]:
    'Ha surgido un problema en la solicitud de nuevo documento',
  [`${patchSetDocumentRequiredIsNotSent.name}_fulfilled`]: 'Documento correctamente marcado como no enviado',
  [`${patchSetDocumentRequiredIsNotSent.name}_rejected`]:
    'Ha surgido un problema al marcar el documento como no enviado',
  [`${patchUploadFileToDocumentationRequired.name}_fulfilled`]: 'Documentación correctamente subida',
  [`${patchUploadFileToDocumentationRequired.name}_rejected`]:
    'Ha surgido un problema durante la subida de la documentación',
  [`${patchSetDocumentStatus.name}_fulfilled`]: 'Estado de documento cambiado correctamente',
  [`${patchSetDocumentStatus.name}_rejected`]: 'Ha surgido un problema al cambiar el estado del documento',
  [`${patchSyncBorrowerDocumentationByLoanId.name}_fulfilled`]: 'Documentación sincronizada correctamente',
  [`${patchSyncBorrowerDocumentationByLoanId.name}_rejected`]:
    'Ha surgido un problema durante la sincronización de la documentación ',
  [`${patchUploadDocumentationToLender.name}_fulfilled`]: 'Documentación enviada a la entidad financiera correctamente',
  [`${patchUploadDocumentationToLender.name}_rejected`]:
    'Ha surgido un problema al enviar la documentación a la entidad financiera',
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_fulfilled`]:
    'Documento solicitado eliminado correctamente',
  [`${patchRemoveRequiredFileTypeFromDocumentationRequired.name}_rejected`]:
    'Ha surgido un problema al eliminar el documento solicitado',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_fulfilled`]: 'Código de tarifa añadido correctamente.',
  [`${patchAddPricingSpecInLenderContextInPricingSpec.name}_rejected`]:
    'Ha surgido un problema al añadir el código de tarifa.',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_fulfilled`]:
    'Código de tarifa eliminado correctamente',
  [`${patchRemovePricingSpecInLenderContextFromPricingSpecByLenderId.name}_rejected`]:
    'Ha surgido un problema al eliminar el código de tarifa.',
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_fulfilled`]:
    'Se ha actualizado la información de branding correctamente.',
  [`${patchSetBrandInformationAndUploadLogoToCDN.name}_rejected`]:
    'Ha surgido un problema al actualizar la información.',
  [`${postCreateUser.name}_fulfilled`]: 'Nuevas credenciales creadas correctamente.',
  [`${postCreateUser.name}_rejected`]: 'Ha surgido un problema al intentar crear las credenciales.',
  [`${patchChangeLoanStatus.name}_fulfilled`]: 'El cambio de estado de la solicitud se ha procesado correctamente',
  [`${patchChangeLoanStatus.name}_rejected`]: 'Ha surgido un problema al cambiar el estado de la solicitud',
  [`${patchProcessLoanApplicationInLenderManually.name}_fulfilled`]:
    'Se ha cambiado el estado de aprobación de la entidad financiera correctamente',
  [`${patchProcessLoanApplicationInLenderManually.name}_rejected`]:
    'Ha surgido un problema al cambiar el estado de aprobación de la entidad financiera',
  [`${patchSetAreDocumentsConfirmed.name}_fulfilled`]: 'Documentación confirmada correctamente',
  [`${patchSetAreDocumentsConfirmed.name}_rejected`]: 'Ha surgido un problema al confirmar la documentación',
  [`${postCreateCheckoutSession.name}_fulfilled`]: 'Solicitud de pago creada',
  [`${postCreateCheckoutSession.name}_rejected`]: 'Ha surgido un problema al crear la solicitud de pago.',
  [`${patchSetRangesForAgent.name}_fulfilled`]: 'Límites de tarifas modificados correctamente',
  [`${patchSetRangesForAgent.name}_rejected`]: 'Ha surgido un problema al modificar los límites de las tarifas',
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_fulfilled`]: 'Se ha cancelado correctamente la solicitud de pago',
  [`${deleteCheckoutSessionByCheckoutSessionId.name}_rejected`]:
    'Ha surgido un problema al al cancelar el proceso de pago',
  patchCreateApplicationsByPaymentMethodType_rejected: 'Ha surgido un problema con la evaluación de la solicitud',
  [`${patchUpdateLoanApplicationInLender.name}_fulfilled`]:
    'Se han actualizado correctamente los datos en la entidad financiera',
  [`${patchUpdateLoanApplicationInLender.name}_rejected`]:
    'Ha surgido un problema al intentar actualizar los datos en la entidad financiera',
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_fulfilled`]:
    'Se han modificado correctamente las condiciones del prestamo',
  [`${patchUpdateLoanConditionsByPricingIdPrincipalAndPeriod.name}_rejected`]:
    'Ha surgido un problema al intentar modificar las condiciones del prestamo',
  [`${postCloneOrUpdateAgent.name}_fulfilled`]: 'Se ha creado/actualizado el agente correctamente',
  [`${postCloneOrUpdateAgent.name}_rejected`]: 'Ha surgido un problema al intentar crear/actualizar el agente',
  [`${patchUpdateBorrowerDetails.name}_rejected`]:
    'La combinación de correo electrónico y teléfono introducidos no coinciden con la información registrada de este cliente',
  [`${patchSetCart.name}_fulfilled`]: 'Se ha actualizado correctamente la solicitud de pago',
  [`${patchSetCart.name}_rejected`]: 'Ha surgido un problema al modificar la solicitud de pago',
  [`${patchUpdateDownPayment.name}_fulfilled`]: 'Se ha actualizado correctamente la solicitud de pago',
  [`${patchUpdateDownPayment.name}_rejected`]: 'Ha surgido un problema al modificar la solicitud de pago',
  [`${patchUpdatePaymentMethodOptions.name}_fulfilled`]:
    'Se ha actualizado correctamente la configuración del método de pago de la solicitud',
  [`${patchUpdatePaymentMethodOptions.name}_rejected`]:
    'Ha surgido un problema al modificar la configuración del método de pago de la solicitud',
  [`${patchPaymentMethodModification.name}_fulfilled`]: 'Se han actualizado correctamente los datos del vehículo',
  [`${patchPaymentMethodModification.name}_rejected`]:
    'Ha surgido un problema al intentar actualizar los datos del vehículo',
  [`${postPaymentMethodModificationPreview.name}_rejected`]:
    'Ha surgido un problema al intentar previsualizar los cambios de los datos del vehículo',

  // ─── Document Extractor Dialog ────────────────────────────────────────────────
  // Dialog
  DOCUMENT_EXTRACTOR_BUTTON_TEXT: 'Autorellenar con IA',
  DOCUMENT_EXTRACTOR_DIALOG_TITLE: 'Autorellenar con IA',
  DOCUMENT_EXTRACTOR_DIALOG_DESCRIPTION:
    'Sube la documentación que dispones para extraer automáticamente los datos y rellenar el formulario.',
  DOCUMENT_EXTRACTOR_EXTRACT: 'Extraer',
  DOCUMENT_EXTRACTOR_CONFIRM_AND_PREFILL: 'Confirmar y rellenar',
  DOCUMENT_EXTRACTOR_EXTRACTING: 'Extrayendo documentos...',
  DOCUMENT_EXTRACTOR_APPLYING: 'Aplicando datos extraídos...',
  DOCUMENT_EXTRACTOR_DROP_FILES: 'Arrastra archivos aquí o haz clic para seleccionar',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_PREFIX: 'máx.',
  DOCUMENT_EXTRACTOR_FILE_SIZE_LIMIT_SUFFIX: 'MB por archivo',
  DOCUMENT_EXTRACTOR_DRAG_REORDER_HINT: 'Arrastra para reordenar — los documentos más arriba tienen prioridad.',
  // Pre-fill confirmation
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_TITLE: '¿Rellenar el formulario con los datos extraídos?',
  DOCUMENT_EXTRACTOR_PREFILL_CONFIRM_DESCRIPTION:
    'Los campos del formulario que ya estaban rellenos y coincidan con los datos extraídos serán reemplazados. Esta acción no se puede deshacer.',
  // File entry row
  DOCUMENT_EXTRACTOR_DATA_TITLE: 'Datos extraídos',
  DOCUMENT_EXTRACTOR_NO_EXTRACTED_DATA_YET: 'Este documento aún no ha sido procesado.',
  DOCUMENT_EXTRACTOR_EXPAND_ALL: 'Expandir todo',
  DOCUMENT_EXTRACTOR_COLLAPSE_ALL: 'Contraer todo',
  DOCUMENT_EXTRACTOR_STATUS_EXTRACTED: 'Extraído',
  DOCUMENT_EXTRACTOR_STATUS_FAILED: 'Fallido',
  DOCUMENT_EXTRACTOR_STATUS_PENDING: 'Pendiente',
  DOCUMENT_EXTRACTOR_DOC_TYPE_AUTO_DETECT: 'Auto-detectar',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_TITLE: '¿Eliminar archivo?',
  DOCUMENT_EXTRACTOR_REMOVE_FILE_DESCRIPTION: 'será eliminado de la lista.',
  DOCUMENT_EXTRACTOR_DUPLICATE_DOC_TYPE_WARNING:
    'Se han detectado varios documentos del mismo tipo. El documento más arriba en la lista tiene prioridad.',
  DOCUMENT_EXTRACTOR_EXTRACTION_FAILED_SELECT_TYPE:
    'Extracción fallida. Selecciona un tipo de documento arriba y vuelve a intentarlo.',
  DOCUMENT_EXTRACTOR_LOW_CONFIDENCE_PREFIX: 'Baja confianza',
  DOCUMENT_EXTRACTOR_REVIEW_DATA: 'Revisa los datos extraídos cuidadosamente.',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_PREFIX: 'Este PDF tiene',
  DOCUMENT_EXTRACTOR_HIGH_PAGE_COUNT_SUFFIX: 'páginas. Solo se procesó la primera página relevante.',
  // Document type labels
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT: 'DNI (frente)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_BACK: 'DNI (reverso)',
  DOCUMENT_EXTRACTOR_TYPE_DNI_FRONT_BACK: 'DNI (frente y reverso)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_FRONT: 'NIE (frente)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_BACK: 'NIE (reverso)',
  DOCUMENT_EXTRACTOR_TYPE_NIE_EU_GREEN_CARD: 'NIE (carta verde)',
  DOCUMENT_EXTRACTOR_TYPE_PAYROLL: 'Nómina',
  DOCUMENT_EXTRACTOR_TYPE_PENSION_REVALUATION: 'Revalorización de pensión',
  DOCUMENT_EXTRACTOR_TYPE_PERSONAL_INCOME_TAX: 'Declaración de la renta',
  DOCUMENT_EXTRACTOR_TYPE_BANK_CERTIFICATE: 'Certificado bancario',
  DOCUMENT_EXTRACTOR_TYPE_VEHICLE_INSPECTION: 'Inspección técnica de vehículo',
  // Validation errors
  DOCUMENT_EXTRACTOR_ERROR_UNSUPPORTED_FORMAT: 'formato no compatible. Formatos aceptados:',
  DOCUMENT_EXTRACTOR_ERROR_FILE_TOO_LARGE: 'supera el tamaño máximo de',
  DOCUMENT_EXTRACTOR_ERROR_EXTRACTION_FAILED: 'Extracción fallida. Por favor, inténtalo de nuevo.',
  DOCUMENT_EXTRACTOR_ERROR_RETRY_FAILED: 'Reintento fallido. Por favor, inténtalo de nuevo.',
  DOCUMENT_EXTRACTOR_ERROR_PDF_ROTATE_FAILED: 'Error al rotar el PDF. Por favor, inténtalo de nuevo.',

  // LENDER ORCHESTRATION (MERC-135)
  LENDER_ORCHESTRATION: 'Orquestación de lenders',
  LENDER_ORCHESTRATION_SUBTITLE: 'Reparto de solicitudes',
  LENDER_ORCHESTRATION_SUBTITLE_TEXT: 'Configuración por método de pago, aplicada a todos los agentes del merchant.',
  LENDER_ORCHESTRATION_COLUMN_STRATEGY: 'Envío',
  LENDER_ORCHESTRATION_COLUMN_MODE: 'Modo',
  LENDER_ORCHESTRATION_COLUMN_STOP: 'Parada',
  LENDER_ORCHESTRATION_COLUMN_RANKING: 'Ranking',
  LENDER_ORCHESTRATION_MIXED: 'Mixto',
  LENDER_ORCHESTRATION_UNIFY: 'Unificar',
  LENDER_ORCHESTRATION_DEFAULT_TAG: 'default',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_CELL: 'Entidad prioritaria ·',
  LENDER_ORCHESTRATION_API_INFO_TITLE: 'Merchants integrados por API',
  LENDER_ORCHESTRATION_API_INFO_TEXT:
    'Pueden fijar otra orquestación en cada sesión de checkout. Esta configuración es la que se aplica cuando la sesión no indica nada.',
  LENDER_ORCHESTRATION_LOAD_ERROR: 'No se ha podido cargar la orquestación de lenders',
  CONFIGURATION_ERROR: 'Error de configuración',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL: 'Paralelo',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_SUMMARY: 'Todas a la vez',
  LENDER_ORCHESTRATION_STRATEGY_PARALLEL_DESCRIPTION: 'La solicitud sale al mismo tiempo para todas las entidades. Cuando responden, el ranking elige entre las que aprueban. Máxima aprobación; más consultas al cliente en burós.',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL: 'Cascada',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_SUMMARY: 'Una a una',
  LENDER_ORCHESTRATION_STRATEGY_WATERFALL_DESCRIPTION: 'Se envía a la primera del ranking y se espera su respuesta antes de pasar a la siguiente. Se para con la respuesta que elijas en el punto 3. Menos huella en burós y control del reparto.',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC: 'Automático',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_TITLE: 'La plataforma, automáticamente',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_SUMMARY: 'Avanza sola en cuanto llega cada respuesta',
  LENDER_ORCHESTRATION_MODE_AUTOMATIC_DESCRIPTION: 'La solicitud avanza por el orden del ranking en cuanto llega cada respuesta. Tu equipo no tiene que hacer nada.',
  LENDER_ORCHESTRATION_MODE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_MODE_MANUAL_TITLE: 'Tu equipo, a mano',
  LENDER_ORCHESTRATION_MODE_MANUAL_SUMMARY: 'Tu equipo envía y registra cada respuesta',
  LENDER_ORCHESTRATION_MODE_MANUAL_DESCRIPTION: 'Nada se envía de forma automática: tu equipo procesa manualmente cada solicitud. El ranking es solo una recomendación.',
  LENDER_ORCHESTRATION_STOP_YES: 'Aprobada',
  LENDER_ORCHESTRATION_STOP_YES_TITLE: 'Cuando una aprueba',
  LENDER_ORCHESTRATION_STOP_YES_SUMMARY: 'Solo una aprobación detiene',
  LENDER_ORCHESTRATION_STOP_YES_DESCRIPTION: 'Solo una aprobación detiene la cascada. Si una entidad falla, rechaza o deja la solicitud en estudio, se consulta a la siguiente.',
  LENDER_ORCHESTRATION_STOP_MAYBE: 'Aprobada o en estudio',
  LENDER_ORCHESTRATION_STOP_MAYBE_TITLE: 'Cuando una aprueba o estudio',
  LENDER_ORCHESTRATION_STOP_MAYBE_SUMMARY: 'También una respuesta en estudio',
  LENDER_ORCHESTRATION_STOP_MAYBE_DESCRIPTION: 'Una entidad que se queda la operación a estudio ya detiene la cascada. Si falla o rechaza, se consulta a la siguiente.',
  LENDER_ORCHESTRATION_STOP_NO: 'Primera respuesta',
  LENDER_ORCHESTRATION_STOP_NO_TITLE: 'Con la primera que conteste',
  LENDER_ORCHESTRATION_STOP_NO_SUMMARY: 'Cualquier respuesta, salvo fallo técnico',
  LENDER_ORCHESTRATION_STOP_NO_DESCRIPTION: 'Aprobar, dejar en estudio o rechazar detienen la cascada. Solo en caso de un fallo técnico pasa a la siguiente.',
  LENDER_ORCHESTRATION_STOP_ERROR: 'Solo la primera',
  LENDER_ORCHESTRATION_STOP_ERROR_TITLE: 'Solo la primera, pase lo que pase',
  LENDER_ORCHESTRATION_STOP_ERROR_SUMMARY: 'Una sola entidad, pase lo que pase',
  LENDER_ORCHESTRATION_STOP_ERROR_DESCRIPTION: 'Se consulta únicamente a la primera entidad del ranking. Sea cual sea su respuesta, incluso un fallo técnico, no se consulta a ninguna más.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR: 'Menor coste y TAE',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_SUMMARY: 'Primero la más barata para ti, luego menor TAE',
  LENDER_ORCHESTRATION_CHOOSE_MIN_APR_DESCRIPTION: 'Primero la entidad que menos te cuesta. A igualdad de coste, la de menor TAE para tu cliente.',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY: 'Mayor rentabilidad',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_SUMMARY: 'Primero la más rentable para ti',
  LENDER_ORCHESTRATION_CHOOSE_MAX_PROFITABILITY_DESCRIPTION: 'Primero la entidad con la que la operación es más rentable para ti.',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET: 'Preferir 0% de interés',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_SUMMARY: 'Primero las entidades al 0% de interés',
  LENDER_ORCHESTRATION_CHOOSE_SHARE_OF_WALLET_DESCRIPTION: 'Si alguna entidad ofrece 0% de interés al cliente, va primero. Entre varias al 0%, la que menos te cuesta.',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE: 'Entidad prioritaria, luego precio',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_SUMMARY: 'Una entidad fija primero, el resto por precio',
  LENDER_ORCHESTRATION_CHOOSE_PRIORITY_LENDER_THEN_PRICE_DESCRIPTION: 'La entidad que elijas va siempre primero si tiene tarifa para la operación. El resto, por menor coste y TAE.',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION: 'Elige el cliente',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_SUMMARY: 'El cliente elige en el checkout',
  LENDER_ORCHESTRATION_CHOOSE_BORROWER_SELECTION_DESCRIPTION: 'El cliente ve las ofertas de las entidades en el checkout y elige con cuál financiar. La plataforma no decide por él.',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA: 'Iberia',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_SUMMARY: 'Reparto acordado con Iberia Cards',
  LENDER_ORCHESTRATION_CHOOSE_IBERIA_DESCRIPTION: 'Reparto de primeras posiciones acordado con Iberia Cards: cada entidad gana la primera posición un 10% de las veces; el resto decide el precio. A 3 meses, siempre por precio.',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL: 'Manual',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_SUMMARY: 'Orden fijado en la sesión',
  LENDER_ORCHESTRATION_CHOOSE_MANUAL_DESCRIPTION: 'Orden fijado en cada sesión de checkout.',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA: 'Menor cuota',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_SUMMARY: 'Primero la de menor cuota',
  LENDER_ORCHESTRATION_CHOOSE_MIN_QUOTA_DESCRIPTION: 'Primero la entidad con la cuota más baja.',
  LENDER_ORCHESTRATION_QUESTION_STRATEGY: '¿Cómo se envía la solicitud a las entidades?',
  LENDER_ORCHESTRATION_QUESTION_MODE: '¿Quién avanza la cascada? Solo en cascada.',
  LENDER_ORCHESTRATION_QUESTION_STOP: '¿Con qué respuesta se detiene la cascada? Solo en cascada. El mismo ejemplo de cuatro entidades en cada opción: la 1ª falla, la 2ª rechaza, la 3ª la deja en estudio, la 4ª aprueba.',
  LENDER_ORCHESTRATION_QUESTION_RANKING: '¿En qué orden se prefieren las entidades? En cascada marca el orden de consulta; en paralelo, cuál gana entre las que aprueban.',
  LENDER_ORCHESTRATION_PRIORITY_LENDER: 'Entidad prioritaria',
  LENDER_ORCHESTRATION_PRIORITY_LENDER_TEXT: 'Lista limitada a las entidades del merchant.',
  LENDER_ORCHESTRATION_LOCKED_TITLE: 'Solo un super_admin puede cambiarlo',
  LENDER_ORCHESTRATION_LOCKED_TEXT: 'Este valor está restringido. Puedes cambiar el resto de la configuración; se mantendrá tal cual.',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TITLE: 'Cascada en modo manual',
  LENDER_ORCHESTRATION_MANUAL_WARNING_TEXT: 'Ninguna solicitud se enviará a una entidad hasta que tu equipo la registre. Las operaciones quedarán en análisis mientras tanto.',
  LENDER_ORCHESTRATION_ERROR_WATERFALL_BORROWER: 'Elige el cliente solo funciona con envío en paralelo',
  LENDER_ORCHESTRATION_ONLY_PARALLEL: 'Solo con envío en paralelo',
  LENDER_ORCHESTRATION_DEFAULT_HINT: 'Default de la plataforma para este tipo: $v1 · $v2',
  LENDER_ORCHESTRATION_RESET_DEFAULT: 'Restablecer default',
  LENDER_ORCHESTRATION_APPLY: 'Aplicar a $v1 agentes',
  LENDER_ORCHESTRATION_RESTRICTED: 'super_admin',
  LENDER_ORCHESTRATION_LENDERS_LOAD_ERROR: 'No se han podido cargar las entidades de cada método de pago',
  LENDER_ORCHESTRATION_READ_ONLY_TITLE: 'Solo un super_admin puede cambiar este método de pago',
  LENDER_ORCHESTRATION_READ_ONLY_TEXT: 'Sus agentes tienen rankings distintos y alguno está restringido. Unificarlo requiere un super_admin.',
  LENDER_ORCHESTRATION_APPLY_ONE: 'Aplicar a 1 agente',
  [`${patchSetProcessingConfigToMerchantAgents.name}_fulfilled`]: 'Se ha aplicado la orquestación de lenders.',
  [`${patchSetProcessingConfigToMerchantAgents.name}_rejected`]: 'No se ha podido aplicar la orquestación de lenders.',
  LENDER_ORCHESTRATION_DIAGRAM_REQUEST: 'Solicitud',
  LENDER_ORCHESTRATION_DIAGRAM_AT_ONCE: 'a la vez',
  LENDER_ORCHESTRATION_DIAGRAM_APPROVES: 'aprueba',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTS: 'rechaza',
  LENDER_ORCHESTRATION_DIAGRAM_REJECTED: 'rechazó',
  LENDER_ORCHESTRATION_DIAGRAM_WHEN_ANSWERS: 'cuando responda',
  LENDER_ORCHESTRATION_DIAGRAM_REVIEW: 'en estudio',
  LENDER_ORCHESTRATION_DIAGRAM_FAILS: 'falla',
  LENDER_ORCHESTRATION_DIAGRAM_ANY_RESULT: 'cualquier resultado',
  LENDER_ORCHESTRATION_DIAGRAM_NOT_CONSULTED: 'no se consulta',
  LENDER_ORCHESTRATION_DIAGRAM_WINS: 'gana',
  LENDER_ORCHESTRATION_DIAGRAM_IN_RANKING_ORDER: (
    <>
      en el <tspan fontWeight={700}>orden del ranking</tspan>, una tras otra
    </>
  ),
  LENDER_ORCHESTRATION_DIAGRAM_PLATFORM: 'plataforma',
  LENDER_ORCHESTRATION_DIAGRAM_YOUR_TEAM: 'tu equipo',
  LENDER_ORCHESTRATION_DIAGRAM_CONSULTING: 'consultando…',
  LENDER_ORCHESTRATION_DIAGRAM_WAITING: 'en espera',
  LENDER_ORCHESTRATION_DIAGRAM_AUTO_HINT: 'cada respuesta dispara sola la siguiente consulta',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT_TOP: 'el orden es solo una recomendación',
  LENDER_ORCHESTRATION_DIAGRAM_MANUAL_HINT: 'nada se envía solo · tu equipo procesa manualmente cada solicitud',
  LENDER_ORCHESTRATION_DIAGRAM_COST_FOR_YOU: 'lo que te cuesta',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_APR: 'TAE del cliente',
  LENDER_ORCHESTRATION_DIAGRAM_MIN_APR_HINT: 'A y B empatan en coste → gana la de menor TAE',
  LENDER_ORCHESTRATION_DIAGRAM_PROFITABILITY: 'rentabilidad de la operación para ti',
  LENDER_ORCHESTRATION_DIAGRAM_COSTS_YOU: 'te cuesta',
  LENDER_ORCHESTRATION_DIAGRAM_ALWAYS_FIRST: 'la que elijas, siempre 1ª',
  LENDER_ORCHESTRATION_DIAGRAM_REST_BY_PRICE: 'el resto, por menor coste y TAE',
  LENDER_ORCHESTRATION_DIAGRAM_NO_PRICING_FALLBACK: 'si no tiene tarifa para la operación, solo manda el precio',
  LENDER_ORCHESTRATION_DIAGRAM_CUSTOMER_CHECKOUT: 'Checkout del cliente',
  LENDER_ORCHESTRATION_DIAGRAM_INSTALMENTS_OF: 'cuotas de',
  LENDER_ORCHESTRATION_DIAGRAM_FIRST_POSITIONS: '10% de primeras posiciones',
  LENDER_ORCHESTRATION_DIAGRAM_RESERVED_EACH: 'reservado a cada entidad',
  LENDER_ORCHESTRATION_DIAGRAM_REMAINING: '70% restante',
  LENDER_ORCHESTRATION_DIAGRAM_BY_COST_APR: 'por menor coste y TAE',
  LENDER_ORCHESTRATION_DIAGRAM_THREE_MONTHS: 'a 3 meses: siempre por precio',
};

export const es_alt_setup_fee = {
  SETUP_FEE: 'Gastos de apertura',
};

export default es;
